export default {
  en: {
    home: 'Home',
    dashboard: 'Dashboard',
    bookings: 'Bookings',
    bookingPage: 'Booking Page',
    aiDocuments: 'AI Documents',
    clientPortalNav: 'Client Portal',
    lawyersNav: 'Lawyers',
    login: 'Log in',
    getStarted: 'Get Started Free',
    lawyersTitle: 'Lawyers & Law Firms',
    lawyersSubtitle: 'registered in Georgia',
    searchPlaceholder: 'Search by name, firm, or practice area...',
    lawyersBtn: 'Lawyers',
    firmsBtn: 'Firms',
    allFilter: 'All',
    corporateLaw: 'Corporate Law',
    criminalLaw: 'Criminal Law',
    familyLaw: 'Family Law',
    realEstate: 'Real Estate',
    taxLaw: 'Tax Law',
    ipLaw: 'IP',
    immigration: 'Immigration',
    laborLaw: 'Labor Law',
    bankingFinance: 'Banking & Finance',
    firmsMatch: 'firms match',
    lawyersMatch: 'lawyers match',
    reviews: 'reviews',
    loadingMore: 'Load more',
    independent: 'Independent',
    yearsExperience: 'years experience',
    languages: 'Languages',
    backToDirectory: '← Back to directory',
    about: 'About',
    bookConsultation: 'Book Consultation',
    sendMessage: 'Send Message',
    call: 'Call',
    reviewsRatings: 'Reviews & Ratings',
    reviewsComingSoon: 'Reviews coming soon. Be the first to review.',
    barId: 'Bar ID',
    ourTeam: 'Our Team',
    contact: 'Contact',
    website: 'Website',
    established: 'Est.',
    lawyersCount: 'lawyers',
    georgian: 'Georgian',
    english: 'English',
    russian: 'Russian',
    german: 'German',
    french: 'French',
    turkish: 'Turkish',
    heroLine1: 'Your legal',
    heroLine2: 'team. One',
    heroLine3: 'platform.',
    heroSubtitle: 'TrustLegal — bookings, cases, payments and AI document drafting for Georgian law firms. One monthly fee, no contract.',
    tryFree: 'Try Free →',
    liveDemo: 'Live Demo',
    trustedBrands: 'Brands that care about quality work with us',
    howItWorks: 'How it works',
    processLabel: '// Process',
    step1Title: 'Sign up',
    step1Desc: 'Create an account and choose a plan. No credit card required — first 30 days free.',
    step2Title: 'Manage cases',
    step2Desc: 'Add clients, cases and bookings. Automatic reminders and calendar sync.',
    step3Title: 'Draft with AI',
    step3Desc: 'AI-powered document drafting in Georgian. Claims, power of attorney, contract analysis.',
    step4Title: 'Grow',
    step4Desc: 'Track invoices, revenue and team productivity. Real-time analytics.',
    demoBadge: '// Live Demo',
    todaysBookings: 'Today\'s bookings',
    fullDemo: 'Full demo →',
    onePlatformThreePillars: 'One platform.\nThree pillars.',
    capabilitiesLabel: '// Capabilities',
    bookingFeature: 'Booking',
    bookingFeatureDesc: 'Clients pick their own time. Auto reminders. Calendar sync. Public booking page.',
    operationsFeature: 'Operations',
    operationsFeatureDesc: 'Centralized case management. Client portal. Invoices and payments. Team management.',
    aiFeatureDesc: 'Document drafting in Georgian. Contract analysis. Legal research. Auto follow-up.',
    simplePricing: 'Simple pricing',
    plansLabel: '// Plans',
    perMonth: '/ month',
    bookingMgmt: 'Booking management',
    caseTracking: 'Case tracking',
    calendarSync: 'Calendar sync',
    emailReminders: 'Email reminders',
    starterPlan: 'Starter',
    startNow: 'Start now →',
    everythingStarter: 'Everything from Starter',
    aiDocDrafting: 'AI document drafting',
    invoicesPayments: 'Invoices and payments',
    clientPortalFeature: 'Client portal',
    directSupport: 'Direct support',
    professionalPlan: 'Professional',
    mostPopular: 'Most popular',
    everythingPro: 'Everything from Professional',
    teamMgmt10: 'Team management (10+ lawyers)',
    contractAnalysis: 'Contract analysis',
    advancedAnalytics: 'Advanced analytics',
    personalOnboarding: 'Personal onboarding',
    businessPlan: 'Business',
    spotsLeft: '3 spots left',
    enterpriseNote: 'Enterprise — contact us for a custom offer.',
    readyQuestion: 'Ready?',
    first30DaysFree: 'First 30 days free. No contract. Cancel anytime.',
    footerTagline: 'Georgian legal SaaS platform.',
    productLabel: 'Product',
    companyLabel: 'Company',
    bookingsLink: 'Bookings',
    casesLink: 'Cases',
    aiDocsLink: 'AI Documents',
    aboutUs: 'About us',
    careers: 'Careers',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'Built with Symbols',
    sidebarMain: 'Dashboard',
    sidebarBookings: 'Bookings',
    sidebarCases: 'Cases',
    sidebarClients: 'Clients',
    sidebarDocs: 'Documents',
    sidebarPayments: 'Payments',
    sidebarLawyers: 'Lawyers',
    sidebarSettings: 'Settings',
    sidebarLogout: 'Log out',
    bookingsTitle: 'Bookings',
    newBooking: '+ New Booking',
    newBookingTitle: 'New Booking',
    clientName: 'Client name',
    phoneNumber: 'Phone',
    civilLaw: 'Civil',
    criminalLaw2: 'Criminal Law',
    administrativeLaw: 'Administrative',
    otherType: 'Other',
    notesPlaceholder: 'Notes...',
    confirmBooking: 'Confirm Booking',
    cancelBtn: 'Cancel',
    calendarSyncNote: 'Calendar sync — Google Calendar, Outlook, Apple Calendar sync automatically',
    synced: 'Synced',
    calendarSync2: 'Calendar Sync',
    syncedStatus: 'Synced',
    bookingsToday: '3 bookings today',
    settingsLink: 'Settings →',
    pendingStatus: 'Pending',
    connectionNeeded: 'Connection needed',
    connectLink: 'Connect →',
    lastSync: 'Last sync: 5 min ago',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    bookingDetails: 'Booking Details',
    confirmed: 'Confirmed',
    pending: 'Pending',
    upcomingBookings: 'Upcoming Bookings',
    closeBtn: 'Close',
    selectDateTime: 'Select date and time',
    fillInfo: 'Fill in information — ',
    firstName: 'First name',
    lastName: 'Last name',
    phoneField: 'Phone',
    emailField: 'Email',
    caseDescription: 'Brief case description',
    confirmBookingPublic: 'Confirm Booking',
    goBack: 'Go back',
    bookingConfirmedMsg: 'Booking confirmed!',
    timeLabel: 'Time: ',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Nino Barateli',
    casesTitle: 'Cases',
    searchPlaceholder2: 'Search...',
    newCase: '+ New Case',
    allTab: 'All',
    activeTab: 'Active',
    pendingTab: 'Pending',
    closedTab: 'Closed',
    selectCasePrompt: 'Select a case to view details',
    info: 'Info',
    registry: 'Registry',
    clientInfo: 'Client Information',
    chronology: 'Chronology',
    addNote: 'Add note',
    enterNote: 'Enter a note...',
    addBtn: 'Add',
    documentsLabel: 'Documents',
    createBtn: '+ Create',
    noDocs: 'No documents',
    hearingSchedule: 'Hearing Schedule',
    caseStatus: 'Case Status',
    electronicFiling: 'Electronic Filing',
    idCode: 'ID Code:',
    director: 'Director:',
    addressLabel: 'Address:',
    statusLabel: 'Status:',
    registeredProperty: 'Registered Property',
    extractLabel: 'Extract',
    recentChanges: 'Recent Changes',
    yourFieldChanges: 'Changes in your field',
    newLabel: 'New',
    notifications: 'Notifications',
    clientsTitle: 'Clients',
    clientsSearchPlaceholder: 'Search clients...',
    clientsProfile: 'Client Profile',
    clientsContactLabel: 'Contact',
    clientsInvoiceHistory: 'Invoice History',
    clientsUnpaid: 'Unpaid',
    clientsPaid: 'Paid',
    clientsPortalInvite: 'Send client portal access',
    dashTodayBookings: 'Today bookings',
    dashUnpaid: 'Unpaid',
    dashOverdue: 'Overdue',
    dashAiGenerations: 'AI generations',
    dashTodaysBookings: 'Today\'s bookings',
    dashConfirmed: 'Confirmed',
    dashRecentCases: 'Recent cases',
    dashNewBooking: '+ New Booking',
    dashNewCase: '+ New Case',
    dashAiDocument: 'AI Document',
    docsTitle: 'Documents',
    docsCreate: 'Create',
    docsExisting: 'Existing Documents',
    docsFiles: 'Files',
    docsOcrScan: 'Scan',
    docsOcrTitle: 'OCR Scanning',
    docsUploadText: 'Upload a document photo or PDF',
    docsScanning: 'Document scanning...',
    docsFile: 'File',
    docsPages: 'Pages',
    docsLanguage: 'Language',
    docsGeorgian: 'Georgian',
    docsAddToCase: 'Add to case',
    docsCopy: 'Copy',
    docsRescan: 'Rescan',
    docsClaim: 'Claim',
    docsPowerOfAttorney: 'Power of Attorney',
    docsNotification: 'Notification',
    docsContractReview: 'Contract Review',
    docsFreeForm: 'Free Form',
    docsParty1: 'Party 1',
    docsNameCompany: 'Name / Company',
    docsParty2: 'Party 2',
    docsDate: 'Date',
    docsAdditionalInfo: 'Additional Information',
    docsGenerating: 'Generating...',
    docsGenerate: 'Generate',
    docsGeneratedDocument: 'Generated Document',
    docsEmptyState: 'Generated document will appear here',
    docsShowDemo: 'Show demo document',
    docsDownload: 'Download',
    docsSend: 'Send',
    docsCreatedDocuments: 'Created Documents',
    docsSearch: 'Search...',
    docsFileManager: 'File Manager',
    docsUpload: 'Upload',
    docsCases: 'Cases',
    docsTemplates: 'Templates',
    docsRecentFiles: 'Recent Files',
    billingTitle: 'Billing',
    billingNewInvoice: 'New Invoice',
    billingTotalSent: 'Total Sent',
    billingPaid: 'Paid',
    billingUnpaid: 'Unpaid',
    billingOverdue: 'Overdue',
    billingActive: 'Active',
    billingClientStatus: 'Client Status',
    billingEInvoice: 'e-Invoice',
    billingAutoCheck: 'Auto-check',
    billingSettings: 'Settings →',
    billingInvoice: 'Invoice',
    billingClient: 'Client',
    billingCase: 'Case',
    billingAmount: 'Amount',
    billingDue: 'Due',
    billingStatus: 'Status',
    aiTitle: 'AI Assistant',
    aiPowered: 'Powered by AI',
    aiDraftDocs: 'Document Drafting',
    aiContractAnalysis: 'Contract Analysis',
    aiLegalResearch: 'Legal Research',
    aiDraftAvailable: 'Document drafting is available on the documents page',
    aiGoToDocuments: 'Go to documents →',
    aiPasteContract: 'Paste contract text here...',
    aiAnalyze: 'Analyze',
    aiReanalyze: 'Re-analyze',
    aiParties: 'Parties',
    aiObligations: 'Key Obligations',
    aiRiskFactors: 'Risk Factors',
    aiDeadlines: 'Deadlines',
    aiRecommendations: 'Recommendations',
    aiAskQuestion: 'Ask a question about Georgian law',
    aiLegalResearchTitle: 'AI Legal Research',
    aiAskPlaceholder: 'Ask a question...',
    aiSend: 'Send',
    pitchTagline: 'Georgia\'s Legal SAAS',
    pitchSubtitle: 'Booking · Operations · AI — for Georgian firms',
    pitchCta: 'See the opportunity →',
    pitchMarketLabel: '// Market',
    pitchMarketTitle: '5000+ lawyers in Georgia',
    pitchPopulation: 'Population',
    pitchTbilisi: 'Tbilisi',
    pitchConcentrated: 'Concentrated market',
    pitchZeroCompetitor: 'Local SaaS competitor',
    pitchProblemLabel: '// Problem',
    pitchProblemTitle: 'Georgian firms still run on WhatsApp and Excel',
    pitchNoBooking: 'No client booking system',
    pitchManualCases: 'Manual case management',
    pitchNoAiTools: 'No AI tools in Georgian',
    pitchCapabilitiesLabel: '// Capabilities',
    pitchOnePlatform: 'One platform. Three pillars.',
    pitchProductLabel: '// Product',
    pitchProductTitle: 'Everything in one platform',
    pitchIntegrationsLabel: '// Integrations',
    pitchIntegrationsTitle: 'Automation, not manual work',
    pitchPublicRegistry: 'Public Registry',
    pitchCalendarSyncTitle: 'Calendar Sync',
    pitchOcrTitle: 'OCR & Scanning',
    pitchPlansLabel: '// Plans',
    pitchPlansTitle: 'Pricing for the Georgian market',
    pitchTierStarter: 'Starter',
    pitchMostPopular: 'Most Popular',
    pitchTierPro: 'Professional',
    pitchTierBusiness: 'Business',
    pitchTierEnterprise: 'Enterprise',
    pitchRevenueLabel: '// Revenue',
    pitchRevenueTitle: 'Revenue Potential',
    pitchFinanceLabel: '// Financials',
    pitchFinanceTitle: 'Unit Economics',
    pitchTimeLabel: '// Timing',
    pitchTimeTitle: 'The timing is right',
    pitchPrivacyLabel: '// Privacy',
    pitchPrivacyTitle: 'Privacy is a priority',
    pitchCtaLabel: '// Build Together',
    pitchCtaTitle: 'Let\'s build Georgia\'s legal infrastructure',
    pitchCtaLink: 'Home page →',
    pitchPerMonth: 'month',
    settingsTitle: 'Settings',
    settingsTabProfile: 'Profile',
    settingsTabFirm: 'Firm',
    settingsTabTeam: 'Team',
    settingsTabNotifications: 'Notifications',
    settingsUploadPhoto: 'Upload Photo',
    settingsSave: 'Save',
    settingsFirmAddress: 'Address',
    settingsFirmRegNumber: 'Registration Number',
    settingsPublicBookingUrl: 'Public Booking URL',
    settingsTeamMembers: 'Team Members',
    settingsInvite: '+ Invite',
    settingsRoleOwner: 'Owner',
    settingsRoleLawyer: 'Lawyer',
    settingsNotifyTitle: 'Notification Settings',
    settingsToggleOn: 'Enabled',
    settingsToggleOff: 'Disabled',
    loginSubtitle: 'Sign in to your account',
    loginLawyer: 'Lawyer',
    loginClient: 'Client',
    loginPassword: 'Password',
    loginSubmit: 'Sign in →',
    loginCaseNumber: 'Case Number',
    loginBackLink: '← Go back',
    portalLogout: 'Log out',
    portalWelcome: 'Hello,',
    portalActiveCases: 'Active Cases',
    portalDocuments: 'Documents',
    portalMessages: 'Messages',
    portalSend: 'Send',
    clientDashNavCases: 'Cases',
    clientDashNavInvoices: 'Invoices',
    clientDashNavDocuments: 'Documents',
    clientDashNavMessages: 'Messages',
    clientDashLogout: 'Log out',
    clientDashWelcome: 'Hello,',
    clientDashDownload: 'Download',
    clientDashSend: 'Send',
    findLawyer: 'Find a Lawyer',
    lawyersSearchSub: 'Search 5,700+ lawyers registered with the Georgian Bar Association',
    searchBtn: 'Search',
    viewAll: 'View all',
    lawyerPortal: 'Lawyer Portal',
    aiFeature: 'AI',
    aiChip1: 'Notarial contract cancellation',
    aiChip1Question: 'What are the conditions for canceling a notarial contract?',
    aiChip2: 'Civil Code Article 317',
    aiChip2Question: 'Interpretation of Civil Code Article 317',
    aiChip3: 'Transaction nullity',
    aiChip3Question: 'Court practice on transaction nullity in the last 3 years',
    aiDeadlinesData: '• Service start: 10 days from contract\n• First payment: April 1, 2026\n• Contract term: 12 months',
    aiEmptyChatSub: 'AI — Ask a question and get an answer about Georgian law',
    aiObligationsData: '1. Service delivery within 30 calendar days\n2. Payment within 15 business days\n3. Confidentiality for 3 years',
    aiPartiesData: 'Party 1: Barateli & Partners LLC\nParty 2: Delta Group LLC',
    aiRecommendationsData: '1. Add penalty clause (Civil Code Art. 417)\n2. Define dispute resolution via arbitration\n3. Expand force majeure clause',
    aiRisksData: '• Late payment penalty not defined\n• Dispute resolution mechanism not specified\n• Force majeure clause does not cover pandemic',
    address: 'Address',
    addressVal: 'Tbilisi, Chavchavadze 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'Giorgi Mamulashvili',
    billingClient2: 'Mariam Kvaratskhelia',
    billingClient3: 'Lela Gogiashvili',
    billingClientName: 'Delta Group LLC',
    billingDue1: '25 Mar',
    billingDue2: '15 Mar',
    billingDue3: '10 Mar',
    billingEmailNotification: 'Email notification',
    billingLastCheck: 'Last check: today',
    billingNoDebt: 'No outstanding debt',
    billingRsBanner: 'rs.ge integration — client tax debt and e-invoice in one click',
    billingRsTaxSystem: 'rs.ge — Tax System',
    billingStatusPaid: 'Paid',
    billingStatusSent: 'Sent',
    billingViewFull: 'View full →',
    billingViewInvoices: 'View invoices →',
    billingWeeklyEnabled: 'Weekly enabled',
    caseRow1Title: '#2024-047 — Giorgi Mamulashvili',
    caseRow2Title: '#2024-046 — Mariam Kvaratskhelia',
    caseRow3Title: '#2024-045 — Lela Gogiashvili',
    change1Date: 'March 15 — Effective: April 1',
    change1Desc: 'Deadline increased from 30 to 45 days',
    change1Name: 'Civil Code — Art. 316',
    change2Date: 'March 12 — Effective: May 1',
    change2Desc: 'Appeal deadline from 14 to 21 days',
    change2Name: 'Procedural Code — Deadlines',
    claimAccepted: 'Claim accepted — March 17',
    claimFiled: 'Claim filed — March 15',
    claimFiledDoc: 'Claim — Filed',
    clientName1: 'Giorgi Mamulashvili',
    clientName2: 'Mariam Kvaratskhelia',
    clientName3: 'Lela Gogiashvili',
    companyExtractLoaded: 'Company extract — Loaded',
    companyName: 'Delta Group LLC',
    clientsActiveCases1: '1 active case',
    clientsActiveCases2: '1 active case',
    clientsActiveCases3: '0 active cases',
    clientsAvatar1: 'GM',
    clientsAvatar2: 'MK',
    clientsAvatar3: 'LG',
    clientsCaseLink1: '#2024-047 — Civil',
    clientsCaseLink2: '#2024-046 — Administrative',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'No active cases',
    clientsPaid1: '₾2,400 paid',
    clientsPaid2: '₾800 paid',
    clientsPaid3: '₾1,800 paid',
    dashAlertText: '2 overdue cases and ₾1,840 unpaid invoices',
    dashBooking1Time: '10:00 — Civil',
    dashBooking2Time: '11:30 — Administrative',
    dashBooking3Time: '14:00 — Criminal',
    dashCaseMeta1: 'Civil · 18 Mar',
    dashCaseMeta2: 'Administrative · 17 Mar',
    dashCaseMeta3: 'Criminal · 15 Mar',
    dashClient3Name: 'Davit Chikovani',
    dashDate: 'March 18, 2026',
    dashGreeting: 'Hello, Nino',
    dateMar15: '15 Mar',
    dateMar17: '17 Mar',
    dateMar18: '18 Mar',
    disabledStatus: '— Disabled',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: 'Georgia, Tbilisi\n\nClaim\n\nPlaintiff: Barateli & Partners LLC\nDefendant: Delta Group LLC\n\nFactual Circumstances:\n\nBy this claim, the plaintiff requests the defendant to fulfill its obligations.\n\nRequest:\n\n1. Obligate defendant to pay 12,500 GEL\n2. Impose penalty of 1,875 GEL\n3. Reimburse court costs\n\nDate: March 18, 2026\nSignature: ________________',
    docsDocument: 'Document',
    docsFile1Meta: 'PDF · 124 KB · 15 Mar 2026',
    docsFile1Name: 'Claim - Mamulashvili.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 Mar 2026',
    docsFile2Name: 'Power of Attorney - Kvaratskhelia.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 Mar 2026',
    docsFile3Name: 'Contract №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 Mar 2026',
    docsFile4Name: 'ID Copy - Mamulashvili.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 Mar 2026',
    docsFile5Name: 'Notification - Gogiashvili.pdf',
    docsFolder1Count: '3 files',
    docsFolder1Name: '#2024-047 Mamulashvili',
    docsFolder2Count: '2 files',
    docsFolder2Name: '#2024-046 Kvaratskhelia',
    docsFolder3Count: '1 file',
    docsFolder3Name: '#2024-045 Gogiashvili',
    docsFolder4Count: '5 files',
    docsFormatAnalysis: 'Format analysis...',
    docsFreeText: 'Free text...',
    docsGeneratedClaimText: 'Georgia, Tbilisi\n\nClaim\n\nPlaintiff: [Party 1]\nDefendant: [Party 2]\n\nFactual Circumstances:\n\nBy this claim, the plaintiff requests the defendant to fulfill its obligations under the Civil Code of Georgia.\n\nLegal Basis:\n\nPursuant to Article 316 of the Civil Code, obligations must be performed properly.\n\nRequest:\n\nConsidering the above, the plaintiff requests the court to obligate the defendant.\n\nDate: March 18, 2026\nSignature: ________________',
    docsGeorgianSymbols: 'Georgian characters',
    docsOcrNote: 'OCR Scanning — automatic digitization of paper documents, no manual typing needed',
    docsOcrResultText: 'Contract №147\n\nTbilisi, March 10, 2026\n\nOn one hand, Barateli & Partners LLC (ID 404123456), represented by director Nino Barateli (hereinafter "Contractor") and on the other hand, Delta Group LLC (ID 404789012), represented by director Giorgi Mamulashvili (hereinafter "Client"), entered into this contract:\n\nArticle 1. Subject of Contract\n1.1. Contractor undertakes to provide legal services to Client.\n1.2. Service cost is 12,500 (twelve thousand five hundred) GEL.',
    docsOcrSuccess: 'Successfully recognized — 98.5% accuracy',
    docsRow1Meta: '#2024-047 · Claim · 15 Mar',
    docsRow1Name: 'Claim - Mamulashvili.pdf',
    docsRow2Meta: '#2024-046 · Power of Attorney · 12 Mar',
    docsRow2Name: 'Power of Attorney - Kvaratskhelia.pdf',
    docsRow3Meta: '#2024-045 · Notification · 8 Mar',
    docsRow3Name: 'Notification - Gogiashvili.pdf',
    docsTextRecognition: 'Text recognition',
    docsUploadFormats: 'JPG, PNG, PDF — max 10MB',
    docsUploadSub: 'Drag a file or click to select',
    ecourt: 'ecourt',
    ecourtDesc: 'File claims, check case status and hearing schedule — without visiting court',
    enabledStatus: '✓ Enabled',
    evidencePending: 'Evidence — Pending',
    extract: 'Extract',
    field1Text: 'Civil: Art. 316 amendment',
    field2Text: 'Civil: Art. 259 deadlines',
    field3Text: 'Administrative: e-service',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 Mar, 10:00 — Tbilisi City Court',
    hearingItem2: '📅 28 Mar, 14:30 — Court of Appeals',
    loginEmail: 'Email',
    matsne: 'matsne',
    matsneDesc: 'Legislation changes automatically — in your practice area',
    outlook: 'Outlook',
    prepHearing: 'Preparatory hearing — March 22',
    propertyApartment: 'Apartment — Vake, 85 sq.m · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'Property extract — Added',
    registryDesc: 'Company and property data automatically — no more manual extract downloads',
    timeEntry1Date: '18 Mar, 10:30',
    timeEntry1Text: 'Case opened, initial consultation completed',
    timeEntry2Date: '17 Mar, 14:00',
    timeEntry2Text: 'Client provided documentation',
    timeEntry3Date: '15 Mar, 09:00',
    timeEntry3Text: 'Client contacted firm, initial application',
    typeCivil: 'Civil',
    typeAdministrative: 'Administrative',
    typeCriminal: 'Criminal',
    pitchArpuMonth: 'Average ARPU/month',
    pitchArpuYear: 'Average ARPU/year',
    pitchAutoBackup: 'Automatic backup',
    pitchAutoNextSteps: 'Auto next steps',
    pitchAutoReminder: 'Auto reminder',
    pitchBooking: 'Booking',
    pitchCacOrganic: 'CAC (organic growth)',
    pitchCalcNote: '5000 lawyers × ₾35/month avg × 12 months',
    pitchCalendarSync: 'Calendar sync',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — hearings and deadlines sync automatically',
    pitchCaseManagement: 'Case management',
    pitchClientSchedule: 'Client schedule',
    pitchCloudDedicated: 'Dedicated Cloud',
    pitchCloudDedicatedDesc: 'Isolated cloud server — your data fully separated from other clients',
    pitchContractAnalysis: 'Contract analysis',
    pitchCtaSubtext: 'Booking + Operations + AI',
    pitchDedicatedServer: 'Dedicated server',
    pitchDocDraftGeo: 'Doc drafting in Georgian',
    pitchEcourtDesc: 'File claims, case status and hearing schedule — without visiting court',
    pitchGdprCompliant: 'GDPR compliant',
    pitchHybrid: 'Hybrid',
    pitchHybridDesc: 'Cloud + local — sensitive data locally, rest in cloud',
    pitchIntegrationsSub: 'Government services, calendars and OCR — from one platform',
    pitchInvoices: 'Invoices',
    pitchMatsneDesc: 'Legislation changes automatically — in your practice area',
    pitchOcrDesc: 'Automatic paper document digitization — no manual typing needed',
    pitchOnPremise: 'On-Premise Server',
    pitchOnPremiseDesc: 'Fully local — data stays in your office, no internet access',
    pitchOperations: 'Operations',
    pitchPerkAiDocs: 'AI Documents',
    pitchPerkBookings: 'Booking management',
    pitchPerkClientPortal: 'Client portal',
    pitchPerkCommunication: 'Communication',
    pitchPerkFileStorage: 'File storage',
    pitchPerkResponsive: 'Responsive',
    pitchPrivacySubtitle: 'Legal data requires maximum protection',
    pitchPublicRegistryDesc: 'Company and property data automatically — no manual extract downloads',
    pitchRateNote: '1 USD = 2.73 GEL — March 2026',
    pitchRecurringModel: 'Recurring model',
    pitchRsGeDesc: 'Tax debt and e-invoice — client status in one click',
    pitchScen250: '250 lawyers',
    pitchScen500: '500 lawyers',
    pitchScen1000: '1000 lawyers',
    pitchServerCost: 'Server cost/user',
    pitchTierBusiness10: '10+ lawyers',
    pitchTierEnterpriseCustom: 'Custom',
    pitchTierEnterprisePrice: 'Quote',
    pitchTierPro310: '3-10 lawyers',
    pitchTierStarter12: '1-2 lawyers',
    pitchTitle: 'TrustLegal for Georgia',
    pitchTrustedAccounting: 'Trusted accounting',
    pitchWhyAiCheap: 'AI tools are now affordable enough',
    pitchWhyDigitizing: 'Georgian legal market is rapidly digitizing',
    pitchWhyNoCompetitor: 'No established competitor',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'Nino Barateli',
    settingsMember2Name: 'Giga Aslanishvili',
    settingsNotifyDeadlineReminder: 'Deadline reminder',
    settingsNotifyNewBookingEmail: 'New booking — Email',
    settingsNotifyNewBookingWhatsapp: 'New booking — WhatsApp',
    settingsNotifyOverdueInvoice: 'Overdue invoice',
    settingsNotifyReminder24h: 'Reminder 24h before',
    settingsProfileName: 'Nino Barateli',
    settingsToggle3DaysBefore: '3 days before',
    portalCaseTypeCivil: 'Civil',
    portalDocDate1: '15 Mar',
    portalDocName1: 'Claim - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: 'Due: 25 Mar',
    portalLastUpdate: 'Last update: 18 Mar',
    portalMsgFrom1: 'Nino Barateli',
    portalMsgPlaceholder: 'Send a message...',
    portalMsgText1: 'Hello Giorgi, we have a new update on the case.',
    portalMsgText2: 'Thanks, waiting for details.',
    portalNextHearing: 'Court hearing March 25',
    portalPay: 'Pay',
    portalPendingInvoices: 'Pending Invoices',
    portalProgressLabel: 'Progress: 3/5 steps',
    portalStatusActive: 'Active',
    clientDashCaseTypeCivil: 'Civil',
    clientDashDocMeta1: 'Case #2024-047 · 15 Mar',
    clientDashDocMeta2: 'Case #2024-046 · 12 Mar',
    clientDashDocName1: 'Claim - Mamulashvili.pdf',
    clientDashDocName2: 'Power of Attorney - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: 'Documents',
    clientDashInvCase1: 'Case: #2024-047',
    clientDashInvCase2: 'Case: #2024-046',
    clientDashInvDue1: 'Due: March 25, 2026',
    clientDashInvoicesTitle: 'Invoices',
    clientDashInvPaidDate: 'Paid: March 14, 2026',
    clientDashLawyerInitials: 'NB',
    clientDashLawyerName: 'Nino Barateli',
    clientDashLawyerRole: 'Your lawyer',
    clientDashMessagesTitle: 'Messages',
    clientDashMsgFrom1: 'Nino Barateli',
    clientDashMsgFrom3: 'Nino Barateli',
    clientDashMsgPlaceholder: 'Write a message...',
    clientDashMsgText1: 'Hello Giorgi, we have a new case update. Court scheduled hearing for March 25.',
    clientDashMsgText2: 'Thanks, waiting for details. Should I prepare any documents?',
    clientDashMsgText3: 'No, everything is ready. Will contact you a week before the hearing.',
    clientDashMsgTime1: '10:30 · Today',
    clientDashMsgTime2: '10:45 · Today',
    clientDashMsgTime3: '11:02 · Today',
    clientDashMyCases: 'My Cases',
    clientDashPaid: 'Paid',
    clientDashPay: 'Pay',
    clientDashProgressLabel: 'Progress: 3/5 steps completed',
    clientDashStatActiveCase: 'Active case',
    clientDashStatDocument: 'Document',
    clientDashStatNextHearing: 'Next hearing',
    clientDashStatNextHearingValue: '25 Mar',
    clientDashStatPayable: 'Payable',
    clientDashStatusActive: 'Active',
    clientDashStep1Date: '5 Mar, 2026',
    clientDashStep1Title: 'Consultation completed',
    clientDashStep2Date: '10 Mar, 2026',
    clientDashStep2Title: 'Claim drafted',
    clientDashStep3Date: '15 Mar, 2026',
    clientDashStep3Title: 'Claim filed in court',
    clientDashStep4Date: '25 Mar, 2026 — Pending',
    clientDashStep4Title: 'Court hearing',
    clientDashStep5Title: 'Decision',
    clientDashUnpaid: 'Unpaid',
    clientDashWelcomeSub: 'Here you can track your cases, invoices and documents.',
  },

  ka: {
    home: 'მთავარი',
    dashboard: 'დეშბორდი',
    bookings: 'ჯავშნები',
    bookingPage: 'ჯავშნის გვერდი',
    aiDocuments: 'AI დოკუმენტები',
    clientPortalNav: 'კლიენტის პორტალი',
    lawyersNav: 'ადვოკატები',
    login: 'შესვლა',
    getStarted: 'დაიწყეთ უფასოდ',
    lawyersTitle: 'ადვოკატები და იურიდიული ფირმები',
    lawyersSubtitle: 'რეგისტრირებული საქართველოში',
    searchPlaceholder: 'მოძებნა სახელით, ფირმით ან სპეციალიზაციით...',
    lawyersBtn: 'ადვოკატები',
    firmsBtn: 'ფირმები',
    allFilter: 'ყველა',
    corporateLaw: 'კორპორაციული',
    criminalLaw: 'სისხლის',
    familyLaw: 'საოჯახო',
    realEstate: 'უძრავი ქონება',
    taxLaw: 'საგადასახადო',
    ipLaw: 'ინტელექტუალური',
    immigration: 'იმიგრაცია',
    laborLaw: 'შრომის',
    bankingFinance: 'საბანკო და ფინანსები',
    firmsMatch: 'ფირმა შეესაბამება',
    lawyersMatch: 'ადვოკატი შეესაბამება',
    reviews: 'შეფასება',
    loadingMore: 'იტვირთება...',
    independent: 'დამოუკიდებელი',
    yearsExperience: 'წლის გამოცდილება',
    languages: 'ენები',
    backToDirectory: '← უკან დირექტორიაში',
    about: 'შესახებ',
    bookConsultation: 'კონსულტაციის დაჯავშნა',
    sendMessage: 'შეტყობინების გაგზავნა',
    call: 'დარეკვა',
    reviewsRatings: 'შეფასებები და რეიტინგები',
    reviewsComingSoon: 'შეფასებები მალე. იყავით პირველი ვინც შეაფასებს.',
    barId: 'საბარო ID',
    ourTeam: 'ჩვენი გუნდი',
    contact: 'კონტაქტი',
    website: 'ვებსაიტი',
    established: 'დაარს.',
    lawyersCount: 'ადვოკატი',
    georgian: 'ქართული',
    english: 'ინგლისური',
    russian: 'რუსული',
    german: 'გერმანული',
    french: 'ფრანგული',
    turkish: 'თურქული',
    heroLine1: 'თქვენი სამართლებრივი',
    heroLine2: 'გუნდი. ერთი',
    heroLine3: 'პლატფორმა.',
    heroSubtitle: 'TrustLegal — ჯავშანი, საქმეები, გადახდები და AI დოკუმენტების შედგენა ქართული სამართლებრივი ფირმებისთვის. ერთი თვის საფასური, კონტრაქტის გარეშე.',
    tryFree: 'უფასოდ სცადეთ →',
    liveDemo: 'ლაივ დემო',
    trustedBrands: 'ჩვენთან მუშაობენ ბრენდები, რომლებსაც ხარისხი აინტერესებთ',
    howItWorks: 'როგორ მუშაობს',
    processLabel: '// პროცესი',
    step1Title: 'დარეგისტრირდით',
    step1Desc: 'შექმენით ანგარიში და აირჩიეთ გეგმა. საბანკო ბარათი არ არის საჭირო — პირველი 30 დღე უფასოა.',
    step2Title: 'მართეთ საქმეები',
    step2Desc: 'დაამატეთ კლიენტები, საქმეები და ჯავშნები. ავტომატური შეხსენებები და კალენდრის სინქრონიზაცია.',
    step3Title: 'AI-ით შედგენა',
    step3Desc: 'AI-ზე დაფუძნებული დოკუმენტების შედგენა ქართულად. სარჩელი, მინდობილობა, კონტრაქტის ანალიზი.',
    step4Title: 'გაიზარდეთ',
    step4Desc: 'თვალყური ადევნეთ ინვოისებს, შემოსავალს და გუნდის პროდუქტიულობას. ანალიტიკა რეალურ დროში.',
    demoBadge: '// ლაივ დემო',
    todaysBookings: 'დღევანდელი ჯავშნები',
    fullDemo: 'სრული დემო →',
    onePlatformThreePillars: 'ერთი პლატფორმა.\nსამი სვეტი.',
    capabilitiesLabel: '// შესაძლებლობები',
    bookingFeature: 'ჯავშანი',
    bookingFeatureDesc: 'კლიენტი თავად ირჩევს დროს. ავტომატური შეხსენებები. კალენდრის სინქრონიზაცია. საჯარო ჯავშნის გვერდი.',
    operationsFeature: 'ოპერაციები',
    operationsFeatureDesc: 'საქმეების ცენტრალური მართვა. კლიენტის პორტალი. ინვოისები და გადახდები. გუნდის მენეჯმენტი.',
    aiFeatureDesc: 'დოკუმენტების შედგენა ქართულად. კონტრაქტის ანალიზი. სამართლებრივი კვლევა. ავტო follow-up.',
    simplePricing: 'მარტივი ფასები',
    plansLabel: '// გეგმები',
    perMonth: '/ თვეში',
    bookingMgmt: 'ჯავშნების მართვა',
    caseTracking: 'საქმეების ტრეკინგი',
    calendarSync: 'კალენდრის სინქრონიზაცია',
    emailReminders: 'ელ.ფოსტის შეხსენებები',
    starterPlan: 'სტარტერი',
    startNow: 'დაიწყეთ →',
    everythingStarter: 'ყველაფერი სტარტერი-დან',
    aiDocDrafting: 'AI დოკუმენტების შედგენა',
    invoicesPayments: 'ინვოისები და გადახდები',
    clientPortalFeature: 'კლიენტის პორტალი',
    directSupport: 'პირდაპირი მხარდაჭერა',
    professionalPlan: 'პროფესიონალი',
    mostPopular: 'ყველაზე პოპულარული',
    everythingPro: 'ყველაფერი პროფესიონალი-დან',
    teamMgmt10: 'გუნდის მართვა (10+ იურისტი)',
    contractAnalysis: 'კონტრაქტის ანალიზი',
    advancedAnalytics: 'მოწინავე ანალიტიკა',
    personalOnboarding: 'პერსონალური ონბორდინგი',
    businessPlan: 'ბიზნესი',
    spotsLeft: '3 ადგილი დარჩა',
    enterpriseNote: 'ენტერპრაიზი — შეგვეხმიანეთ ინდივიდუალური შეთავაზებისთვის.',
    readyQuestion: 'მზად ხართ?',
    first30DaysFree: 'პირველი 30 დღე უფასოა. კონტრაქტის გარეშე. გააუქმეთ ნებისმიერ დროს.',
    footerTagline: 'ქართული სამართლებრივი SaaS პლატფორმა.',
    productLabel: 'პროდუქტი',
    companyLabel: 'კომპანია',
    bookingsLink: 'ჯავშანი',
    casesLink: 'საქმეები',
    aiDocsLink: 'AI დოკუმენტები',
    aboutUs: 'ჩვენს შესახებ',
    careers: 'კარიერა',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'Built with Symbols',
    sidebarMain: 'მთავარი',
    sidebarBookings: 'ჯავშნები',
    sidebarCases: 'საქმეები',
    sidebarClients: 'კლიენტები',
    sidebarDocs: 'დოკუმენტები',
    sidebarPayments: 'გადასახადები',
    sidebarLawyers: 'ადვოკატები',
    sidebarSettings: 'პარამეტრები',
    sidebarLogout: 'გასვლა',
    bookingsTitle: 'ჯავშნები',
    newBooking: '+ ახალი ჯავშანი',
    newBookingTitle: 'ახალი ჯავშანი',
    clientName: 'კლიენტის სახელი',
    phoneNumber: 'ტელეფონი',
    civilLaw: 'სამოქალაქო',
    criminalLaw2: 'სისხლის სამართალი',
    administrativeLaw: 'ადმინისტრაციული',
    otherType: 'სხვა',
    notesPlaceholder: 'შენიშვნები...',
    confirmBooking: 'ჯავშნის დადასტურება',
    cancelBtn: 'გაუქმება',
    calendarSyncNote: 'კალენდრის სინქრონი — Google Calendar, Outlook, Apple Calendar ავტომატურად სინქრონდება',
    synced: 'სინქრონიზებულია',
    calendarSync2: 'კალენდრის სინქრონიზაცია',
    syncedStatus: 'სინქრონიზებული',
    bookingsToday: '3 ჯავშანი დღეს',
    settingsLink: 'პარამეტრები →',
    pendingStatus: 'მოლოდინში',
    connectionNeeded: 'დაკავშირება საჭიროა',
    connectLink: 'დაკავშირება →',
    lastSync: 'ბოლო სინქრ: 5 წთ წინ',
    mon: 'ორშ',
    tue: 'სამ',
    wed: 'ოთხ',
    thu: 'ხუთ',
    fri: 'პარ',
    bookingDetails: 'ჯავშნის დეტალები',
    confirmed: 'დადასტურებული',
    pending: 'მოლოდინში',
    upcomingBookings: 'მომავალი ჯავშნები',
    closeBtn: 'დახურვა',
    selectDateTime: 'აირჩიეთ თარიღი და დრო',
    fillInfo: 'შეავსეთ ინფორმაცია — ',
    firstName: 'სახელი',
    lastName: 'გვარი',
    phoneField: 'ტელეფონი',
    emailField: 'ელ.ფოსტა',
    caseDescription: 'საქმის მოკლე აღწერა',
    confirmBookingPublic: 'ჯავშნის დადასტურება',
    goBack: 'უკან დაბრუნება',
    bookingConfirmedMsg: 'ჯავშანი დადასტურებულია!',
    timeLabel: 'დრო: ',
    lawGroupBarateli: 'სამართლებრივი ჯგუფი ბარათელი',
    ninoBarateli: 'ნინო ბარათელი',
    casesTitle: 'საქმეები',
    searchPlaceholder2: 'ძებნა...',
    newCase: '+ ახალი საქმე',
    allTab: 'ყველა',
    activeTab: 'აქტიური',
    pendingTab: 'მოლოდინში',
    closedTab: 'დახურული',
    selectCasePrompt: 'აირჩიეთ საქმე დეტალების სანახავად',
    info: 'ინფო',
    registry: 'რეესტრი',
    clientInfo: 'კლიენტის ინფორმაცია',
    chronology: 'ქრონოლოგია',
    addNote: 'შენიშვნის დამატება',
    enterNote: 'შეიყვანეთ შენიშვნა...',
    addBtn: 'დამატება',
    documentsLabel: 'დოკუმენტები',
    createBtn: '+ შექმნა',
    noDocs: 'დოკუმენტები არ არის',
    hearingSchedule: 'სხდომის განრიგი',
    caseStatus: 'საქმის სტატუსი',
    electronicFiling: 'ელექტრონული წარდგენა',
    idCode: 'ს/კოდი:',
    director: 'დირექტორი:',
    addressLabel: 'მისამართი:',
    statusLabel: 'სტატუსი:',
    registeredProperty: 'რეგისტრირებული ქონება',
    extractLabel: 'ამონაწერი',
    recentChanges: 'ბოლო ცვლილებები',
    yourFieldChanges: 'თქვენი სფეროს ცვლილებები',
    newLabel: 'ახალი',
    notifications: 'შეტყობინებები',
    clientsTitle: 'კლიენტები',
    clientsSearchPlaceholder: 'კლიენტის ძებნა...',
    clientsProfile: 'კლიენტის პროფილი',
    clientsContactLabel: 'საკონტაქტო',
    clientsInvoiceHistory: 'ინვოისების ისტორია',
    clientsUnpaid: 'გადაუხდელი',
    clientsPaid: 'გადახდილი',
    clientsPortalInvite: 'კლიენტის პორტალზე წვდომის გაგზავნა',
    dashTodayBookings: 'დღეს ჯავშნები',
    dashUnpaid: 'გადაუხდელი',
    dashOverdue: 'ვადაგასული',
    dashAiGenerations: 'AI გენერაციები',
    dashTodaysBookings: 'დღევანდელი ჯავშნები',
    dashConfirmed: 'დადასტურებული',
    dashRecentCases: 'ბოლო საქმეები',
    dashNewBooking: '+ ახალი ჯავშანი',
    dashNewCase: '+ ახალი საქმე',
    dashAiDocument: 'AI დოკუმენტი',
    docsTitle: 'დოკუმენტები',
    docsCreate: 'შექმნა',
    docsExisting: 'არსებული დოკუმენტები',
    docsFiles: 'ფაილები',
    docsOcrScan: 'სკანირება',
    docsOcrTitle: 'OCR სკანირება',
    docsUploadText: 'ატვირთეთ დოკუმენტის ფოტო ან PDF',
    docsScanning: 'დოკუმენტი სკანირდება...',
    docsFile: 'ფაილი',
    docsPages: 'გვერდები',
    docsLanguage: 'ენა',
    docsGeorgian: 'ქართული',
    docsAddToCase: 'საქმეში დამატება',
    docsCopy: 'კოპირება',
    docsRescan: 'ხელახლა სკანირება',
    docsClaim: 'სარჩელი',
    docsPowerOfAttorney: 'მინდობილობა',
    docsNotification: 'შეტყობინება',
    docsContractReview: 'კონტრაქტის მიმოხილვა',
    docsFreeForm: 'თავისუფალი შედგენა',
    docsParty1: 'მხარე 1',
    docsNameCompany: 'სახელი / კომპანია',
    docsParty2: 'მხარე 2',
    docsDate: 'თარიღი',
    docsAdditionalInfo: 'დამატებითი ინფორმაცია',
    docsGenerating: 'გენერაცია...',
    docsGenerate: 'გენერაცია',
    docsGeneratedDocument: 'შედგენილი დოკუმენტი',
    docsEmptyState: 'შედგენილი დოკუმენტი გამოჩნდება აქ',
    docsShowDemo: 'დემო დოკუმენტის ჩვენება',
    docsDownload: 'ჩამოტვირთვა',
    docsSend: 'გაგზავნა',
    docsCreatedDocuments: 'შექმნილი დოკუმენტები',
    docsSearch: 'ძებნა...',
    docsFileManager: 'ფაილების მენეჯერი',
    docsUpload: 'ატვირთვა',
    docsCases: 'საქმეები',
    docsTemplates: 'შაბლონები',
    docsRecentFiles: 'ბოლო ფაილები',
    billingTitle: 'გადასახადები',
    billingNewInvoice: 'ახალი ინვოისი',
    billingTotalSent: 'სულ გაგზავნილი',
    billingPaid: 'გადახდილი',
    billingUnpaid: 'გადაუხდელი',
    billingOverdue: 'ვადაგასული',
    billingActive: 'აქტიური',
    billingClientStatus: 'კლიენტის სტატუსი',
    billingEInvoice: 'ე-ინვოისი',
    billingAutoCheck: 'ავტო-შემოწმება',
    billingSettings: 'პარამეტრები →',
    billingInvoice: 'ინვოისი',
    billingClient: 'კლიენტი',
    billingCase: 'საქმე',
    billingAmount: 'თანხა',
    billingDue: 'ვადა',
    billingStatus: 'სტატუსი',
    aiTitle: 'AI დამხმარე',
    aiPowered: 'Powered by AI',
    aiDraftDocs: 'დოკუმენტების შედგენა',
    aiContractAnalysis: 'კონტრაქტის ანალიზი',
    aiLegalResearch: 'სამართლებრივი კვლევა',
    aiDraftAvailable: 'დოკუმენტების შედგენა ხელმისაწვდომია დოკუმენტების გვერდზე',
    aiGoToDocuments: 'დოკუმენტების გვერდზე გადასვლა →',
    aiPasteContract: 'ჩასვით კონტრაქტის ტექსტი აქ...',
    aiAnalyze: 'გაანალიზეთ',
    aiReanalyze: 'ხელახლა გაანალიზეთ',
    aiParties: 'მხარეები',
    aiObligations: 'ძირითადი ვალდებულებები',
    aiRiskFactors: 'რისკ-ფაქტორები',
    aiDeadlines: 'ვადები',
    aiRecommendations: 'რეკომენდაციები',
    aiAskQuestion: 'დასვით კითხვა ქართულ სამართალზე',
    aiLegalResearchTitle: 'AI სამართლებრივი კვლევა',
    aiAskPlaceholder: 'დასვით კითხვა...',
    aiSend: 'გაგზავნა',
    pitchTagline: 'საქართველოს სამართლებრივი SAAS',
    pitchSubtitle: 'ჯავშანი · ოპერაციები · AI — ქართული ფირმებისთვის',
    pitchCta: 'შესაძლებლობის ნახვა →',
    pitchMarketLabel: '// ბაზარი',
    pitchMarketTitle: '5000+ ადვოკატი საქართველოში',
    pitchPopulation: 'მოსახლეობა',
    pitchTbilisi: 'თბილისი',
    pitchConcentrated: 'კონცენტრირებული ბაზარი',
    pitchZeroCompetitor: 'ადგილობრივი SaaS კონკურენტი',
    pitchProblemLabel: '// პრობლემა',
    pitchProblemTitle: 'ქართული ფირმები დღემდე WhatsApp-სა და Excel-ზე მუშაობენ',
    pitchNoBooking: 'კლიენტის ჯავშნის სისტემა არ არსებობს',
    pitchManualCases: 'საქმეების მართვა ხელით',
    pitchNoAiTools: 'AI ინსტრუმენტები ქართულად არ არსებობს',
    pitchCapabilitiesLabel: '// შესაძლებლობები',
    pitchOnePlatform: 'ერთი პლატფორმა. სამი სვეტი.',
    pitchProductLabel: '// პროდუქტი',
    pitchProductTitle: 'ყველაფერი ერთ პლატფორმაში',
    pitchIntegrationsLabel: '// ინტეგრაციები',
    pitchIntegrationsTitle: 'ავტომატიზაცია, არა ხელით მუშაობა',
    pitchPublicRegistry: 'საჯარო რეესტრი',
    pitchCalendarSyncTitle: 'კალენდრის სინქრონი',
    pitchOcrTitle: 'OCR და სკანირება',
    pitchPlansLabel: '// გეგმები',
    pitchPlansTitle: 'ქართული ბაზრისთვის ფასდადება',
    pitchTierStarter: 'სტარტერი',
    pitchMostPopular: 'ყველაზე პოპულარული',
    pitchTierPro: 'პროფესიონალი',
    pitchTierBusiness: 'ბიზნესი',
    pitchTierEnterprise: 'ენტერპრაიზი',
    pitchRevenueLabel: '// შემოსავალი',
    pitchRevenueTitle: 'შემოსავლის პოტენციალი',
    pitchFinanceLabel: '// ფინანსები',
    pitchFinanceTitle: 'ერთეულის ეკონომიკა',
    pitchTimeLabel: '// დრო',
    pitchTimeTitle: 'დრო სწორია',
    pitchPrivacyLabel: '// კონფიდენციალურობა',
    pitchPrivacyTitle: 'კონფიდენციალურობა პრიორიტეტია',
    pitchCtaLabel: '// ავაშენოთ ერთად',
    pitchCtaTitle: 'ავაშენოთ საქართველოს სამართლებრივი ინფრასტრუქტურა',
    pitchCtaLink: 'მთავარი გვერდი →',
    pitchPerMonth: 'თვეში',
    settingsTitle: 'პარამეტრები',
    settingsTabProfile: 'პროფილი',
    settingsTabFirm: 'ფირმა',
    settingsTabTeam: 'გუნდი',
    settingsTabNotifications: 'შეტყობინებები',
    settingsUploadPhoto: 'ფოტოს ატვირთვა',
    settingsSave: 'შენახვა',
    settingsFirmAddress: 'მისამართი',
    settingsFirmRegNumber: 'სარეგისტრაციო ნომერი',
    settingsPublicBookingUrl: 'საჯარო ჯავშნის ბმული',
    settingsTeamMembers: 'გუნდის წევრები',
    settingsInvite: '+ მოწვევა',
    settingsRoleOwner: 'მფლობელი',
    settingsRoleLawyer: 'ადვოკატი',
    settingsNotifyTitle: 'შეტყობინებების პარამეტრები',
    settingsToggleOn: 'ჩართული',
    settingsToggleOff: 'გამორთული',
    loginSubtitle: 'შედით თქვენს ანგარიშში',
    loginLawyer: 'ადვოკატი',
    loginClient: 'კლიენტი',
    loginPassword: 'პაროლი',
    loginSubmit: 'შესვლა →',
    loginCaseNumber: 'საქმის ნომერი',
    loginBackLink: '← უკან დაბრუნება',
    portalLogout: 'გასვლა',
    portalWelcome: 'გამარჯობა,',
    portalActiveCases: 'აქტიური საქმეები',
    portalDocuments: 'დოკუმენტები',
    portalMessages: 'შეტყობინებები',
    portalSend: 'გაგზავნა',
    clientDashNavCases: 'საქმეები',
    clientDashNavInvoices: 'ინვოისები',
    clientDashNavDocuments: 'დოკუმენტები',
    clientDashNavMessages: 'შეტყობინებები',
    clientDashLogout: 'გასვლა',
    clientDashWelcome: 'გამარჯობა,',
    clientDashDownload: 'ჩამოტვირთვა',
    clientDashSend: 'გაგზავნა',
    findLawyer: 'იპოვეთ ადვოკატი',
    lawyersSearchSub: 'მოძებნეთ 5,700+ ადვოკატი, რეგისტრირებული საქართველოს ადვოკატთა ასოციაციაში',
    searchBtn: 'ძებნა',
    viewAll: 'ყველას ნახვა',
    lawyerPortal: 'ადვოკატის პორტალი',
    aiFeature: 'AI',
    aiChip1: 'ნოტარიული ხელშეკრულების გაბათილება',
    aiChip1Question: 'რა არის ნოტარიული ხელშეკრულების გაბათილების პირობები?',
    aiChip2: 'სამოქალაქო კოდექსი 317-ე მუხლი',
    aiChip2Question: 'სამოქალაქო კოდექსის 317-ე მუხლის განმარტება',
    aiChip3: 'გარიგების ბათილობა',
    aiChip3Question: 'ბოლო 3 წლის სასამართლო პრაქტიკა გარიგების ბათილობაზე',
    aiDeadlinesData: '• მომსახურების დაწყება: ხელშეკრულებიდან 10 დღე\n• პირველი გადახდა: 2026 წლის 1 აპრილი\n• ხელშეკრულების ვადა: 12 თვე',
    aiEmptyChatSub: 'AI — დასვით კითხვა და მიიღეთ პასუხი ქართულ სამართალზე',
    aiObligationsData: '1. მომსახურების გაწევა 30 კალენდარული დღის ვადაში\n2. ანაზღაურება 15 სამუშაო დღეში\n3. კონფიდენციალურობის დაცვა 3 წლის განმავლობაში',
    aiPartiesData: 'მხარე 1: შპს „ბარათელი და პარტნიორები"\nმხარე 2: შპს „დელტა ჯგუფი"',
    aiRecommendationsData: '1. დაამატეთ პირგასამტეხლოს მუხლი (საქ. სამ. კოდ. 417-ე მუხლი)\n2. განსაზღვრეთ დავის გადაწყვეტა არბიტრაჟით\n3. გააფართოვეთ ფორს-მაჟორის მუხლი',
    aiRisksData: '• ვადაგადაცილების პირგასამტეხლო არ არის განსაზღვრული\n• დავის გადაწყვეტის მექანიზმი არ არის მითითებული\n• ფორს-მაჟორის მუხლი არ მოიცავს პანდემიას',
    address: 'მისამართი',
    addressVal: 'თბილისი, ჭავჭავაძის 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'გიორგი მამულაშვილი',
    billingClient2: 'მარიამ კვარაცხელია',
    billingClient3: 'ლელა გოგიაშვილი',
    billingClientName: 'შპს „დელტა ჯგუფი"',
    billingDue1: '25 მარ',
    billingDue2: '15 მარ',
    billingDue3: '10 მარ',
    billingEmailNotification: 'შეტყობინება ელ.ფოსტაზე',
    billingLastCheck: 'ბოლო შემოწმება: დღეს',
    billingNoDebt: 'დავალიანება არ აქვს',
    billingRsBanner: 'rs.ge ინტეგრაცია — კლიენტის საგადასახადო დავალიანება და ე-ინვოისი ერთი კლიკით',
    billingRsTaxSystem: 'rs.ge — საგადასახადო სისტემა',
    billingStatusPaid: 'გადახდილი',
    billingStatusSent: 'გაგზავნილი',
    billingViewFull: 'სრულად ნახვა →',
    billingViewInvoices: 'ინვოისების ნახვა →',
    billingWeeklyEnabled: 'ჩართულია ყოველკვირეული',
    caseRow1Title: '#2024-047 — გიორგი მამულაშვილი',
    caseRow2Title: '#2024-046 — მარიამ კვარაცხელია',
    caseRow3Title: '#2024-045 — ლელა გოგიაშვილი',
    change1Date: '15 მარტი — ძალაში: 1 აპრილი',
    change1Desc: 'ვადა 30-დან 45 დღემდე გაიზარდა',
    change1Name: 'სამოქალაქო კოდექსი — მუხ. 316',
    change2Date: '12 მარტი — ძალაში: 1 მაისი',
    change2Desc: 'სააპელაციო ვადა 14-დან 21 დღემდე',
    change2Name: 'საპროცესო კოდექსი — ვადები',
    claimAccepted: 'სარჩელი მიღებულია — 17 მარტი',
    claimFiled: 'სარჩელი წარდგენილი — 15 მარტი',
    claimFiledDoc: 'სარჩელი — წარდგენილი',
    clientName1: 'გიორგი მამულაშვილი',
    clientName2: 'მარიამ კვარაცხელია',
    clientName3: 'ლელა გოგიაშვილი',
    companyExtractLoaded: 'კომპანიის ამონაწერი — ჩატვირთული',
    companyName: 'შპს „დელტა ჯგუფი"',
    clientsActiveCases1: '1 აქტიური საქმე',
    clientsActiveCases2: '1 აქტიური საქმე',
    clientsActiveCases3: '0 აქტიური საქმე',
    clientsAvatar1: 'გმ',
    clientsAvatar2: 'მკ',
    clientsAvatar3: 'ლგ',
    clientsCaseLink1: '#2024-047 — სამოქალაქო',
    clientsCaseLink2: '#2024-046 — ადმინისტრაციული',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'აქტიური საქმეები არ არის',
    clientsPaid1: '₾2,400 გადახდილი',
    clientsPaid2: '₾800 გადახდილი',
    clientsPaid3: '₾1,800 გადახდილი',
    dashAlertText: '2 ვადაგასული საქმე და ₾1,840 გადაუხდელი ინვოისი',
    dashBooking1Time: '10:00 — სამოქალაქო',
    dashBooking2Time: '11:30 — ადმინისტრაციული',
    dashBooking3Time: '14:00 — სისხლის სამართალი',
    dashCaseMeta1: 'სამოქალაქო · 18 მარ',
    dashCaseMeta2: 'ადმინისტრაციული · 17 მარ',
    dashCaseMeta3: 'სისხლის სამართალი · 15 მარ',
    dashClient3Name: 'დავით ჩიქოვანი',
    dashDate: '18 მარტი, 2026',
    dashGreeting: 'გამარჯობა, ნინო',
    dateMar15: '15 მარ',
    dateMar17: '17 მარ',
    dateMar18: '18 მარ',
    disabledStatus: '— გამორთული',
    docsContractScanPdf: 'ხელშეკრულება_სკანი.pdf',
    docsDemoClaimText: 'საქართველო, ქ. თბილისი\n\nსარჩელი\n\nმოსარჩელე: შპს „ბარათელი და პარტნიორები"\nმოპასუხე: შპს „დელტა ჯგუფი"\n\nფაქტობრივი გარემოებები:\n\nწინამდებარე სარჩელით მოსარჩელე ითხოვს მოპასუხისაგან ვალდებულების შესრულებას.\n\nმოთხოვნა:\n\n1. მოპასუხის დავალდებულებას 12,500 ლარის გადახდაზე\n2. პირგასამტეხლოს დაკისრებას 1,875 ლარის ოდენობით\n3. სასამართლო ხარჯების ანაზღაურებას\n\nთარიღი: 2026 წლის 18 მარტი\nხელმოწერა: ________________',
    docsDocument: 'დოკუმენტი',
    docsFile1Meta: 'PDF · 124 KB · 15 მარ 2026',
    docsFile1Name: 'სარჩელი - მამულაშვილი.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 მარ 2026',
    docsFile2Name: 'მინდობილობა - კვარაცხელია.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 მარ 2026',
    docsFile3Name: 'ხელშეკრულება №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 მარ 2026',
    docsFile4Name: 'პირადობის ასლი - მამულაშვილი.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 მარ 2026',
    docsFile5Name: 'შეტყობინება - გოგიაშვილი.pdf',
    docsFolder1Count: '3 ფაილი',
    docsFolder1Name: '#2024-047 მამულაშვილი',
    docsFolder2Count: '2 ფაილი',
    docsFolder2Name: '#2024-046 კვარაცხელია',
    docsFolder3Count: '1 ფაილი',
    docsFolder3Name: '#2024-045 გოგიაშვილი',
    docsFolder4Count: '5 ფაილი',
    docsFormatAnalysis: 'ფორმატის ანალიზი...',
    docsFreeText: 'თავისუფალი ტექსტი...',
    docsGeneratedClaimText: 'საქართველო, ქ. თბილისი\n\nსარჩელი\n\nმოსარჩელე: [მხარე 1]\nმოპასუხე: [მხარე 2]\n\nფაქტობრივი გარემოებები:\n\nწინამდებარე სარჩელით მოსარჩელე ითხოვს მოპასუხისაგან ვალდებულების შესრულებას საქართველოს სამოქალაქო კოდექსის შესაბამისად.\n\nსამართლებრივი საფუძვლები:\n\nსაქართველოს სამოქალაქო კოდექსის 316-ე მუხლის თანახმად, ვალდებულების შესრულება უნდა მოხდეს ჯეროვნად.\n\nმოთხოვნა:\n\nზემოაღნიშნულის გათვალისწინებით, მოსარჩელე ითხოვს სასამართლოსაგან მოპასუხის დავალდებულებას.\n\nთარიღი: 2026 წლის 18 მარტი\nხელმოწერა: ________________',
    docsGeorgianSymbols: 'ქართული სიმბოლოები',
    docsOcrNote: 'OCR სკანირება — ქაღალდის დოკუმენტების ავტომატური ციფრიზაცია, ხელით აკრეფა აღარ დაგჭირდებათ',
    docsOcrResultText: 'ხელშეკრულება №147\n\nქ. თბილისი, 2026 წლის 10 მარტი\n\nერთი მხრივ, შპს „ბარათელი და პარტნიორები" (ს/კ 404123456), წარმოდგენილი დირექტორის ნინო ბარათელის სახით (შემდგომში „შემსრულებელი") და მეორე მხრივ, შპს „დელტა ჯგუფი" (ს/კ 404789012), წარმოდგენილი დირექტორის გიორგი მამულაშვილის სახით (შემდგომში „დამკვეთი"), დადეს წინამდებარე ხელშეკრულება შემდეგზე:\n\nმუხლი 1. ხელშეკრულების საგანი\n1.1. შემსრულებელი იღებს ვალდებულებას გაუწიოს დამკვეთს სამართლებრივი მომსახურება.\n1.2. მომსახურების ღირებულება შეადგენს 12,500 (თორმეტი ათას ხუთასი) ლარს.',
    docsOcrSuccess: 'წარმატებით ამოიცნო — 98.5% სიზუსტე',
    docsRow1Meta: '#2024-047 · სარჩელი · 15 მარ',
    docsRow1Name: 'სარჩელი - მამულაშვილი.pdf',
    docsRow2Meta: '#2024-046 · მინდობილობა · 12 მარ',
    docsRow2Name: 'მინდობილობა - კვარაცხელია.pdf',
    docsRow3Meta: '#2024-045 · შეტყობინება · 8 მარ',
    docsRow3Name: 'შეტყობინება - გოგიაშვილი.pdf',
    docsTextRecognition: 'ტექსტის ამოცნობა',
    docsUploadFormats: 'JPG, PNG, PDF — მაქს. 10MB',
    docsUploadSub: 'გადაათრიეთ ფაილი ან დააჭირეთ არჩევისთვის',
    ecourt: 'ecourt',
    ecourtDesc: 'სარჩელის წარდგენა, საქმის სტატუსი და სხდომის განრიგი — სასამართლოში ვიზიტის გარეშე',
    enabledStatus: '✓ ჩართული',
    evidencePending: 'მტკიცებულება — მოლოდინში',
    extract: 'ამონაწერი',
    field1Text: 'სამოქალაქო: მუხ. 316 ცვლილება',
    field2Text: 'სამოქალაქო: მუხ. 259 ვადები',
    field3Text: 'ადმინისტრაციული: ელ. მომსახურება',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 მარ, 10:00 — თბილისის საქალაქო',
    hearingItem2: '📅 28 მარ, 14:30 — სააპელაციო',
    loginEmail: 'Email',
    matsne: 'matsne',
    matsneDesc: 'კანონმდებლობის ცვლილებები ავტომატურად — თქვენი პრაქტიკის სფეროში',
    outlook: 'Outlook',
    prepHearing: 'მოსამზადებელი სხდომა — 22 მარტი',
    propertyApartment: 'ბინა — ვაკე, 85 კვ.მ · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'ქონების ამონაწერი — დამატებული',
    registryDesc: 'კომპანიის და ქონების მონაცემები ავტომატურად — ხელით ამონაწერის გადმოტანა აღარ დაგჭირდებათ',
    timeEntry1Date: '18 მარ, 10:30',
    timeEntry1Text: 'საქმე გაიხსნა, საწყისი კონსულტაცია ჩატარდა',
    timeEntry2Date: '17 მარ, 14:00',
    timeEntry2Text: 'კლიენტმა მიაწოდა დოკუმენტაცია',
    timeEntry3Date: '15 მარ, 09:00',
    timeEntry3Text: 'კლიენტმა დაუკავშირდა ფირმას, პირველადი განაცხადი',
    typeCivil: 'სამოქალაქო',
    typeAdministrative: 'ადმინისტრაციული',
    typeCriminal: 'სისხლის სამართალი',
    pitchArpuMonth: 'საშუალო ARPU/თვე',
    pitchArpuYear: 'საშუალო ARPU/წელი',
    pitchAutoBackup: 'ავტომატური ბექაფი',
    pitchAutoNextSteps: 'ავტო შემდეგი ნაბიჯები',
    pitchAutoReminder: 'ავტომატური შეხსენება',
    pitchBooking: 'ჯავშანი',
    pitchCacOrganic: 'CAC (ორგანული ზრდა)',
    pitchCalcNote: '5000 ადვოკატი × ₾35/თვე საშუალო × 12 თვე',
    pitchCalendarSync: 'კალენდრის სინქრ.',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — სხდომები და ვადები ავტომატურად სინქრონდება',
    pitchCaseManagement: 'საქმის მართვა',
    pitchClientSchedule: 'კლიენტის განრიგი',
    pitchCloudDedicated: 'Cloud გამოყოფილი',
    pitchCloudDedicatedDesc: 'იზოლირებული სერვერი ღრუბელში — თქვენი მონაცემები სხვა კლიენტებისგან სრულად გამოყოფილია',
    pitchContractAnalysis: 'კონტრაქტის ანალიზი',
    pitchCtaSubtext: 'ჯავშანი + ოპერაციები + AI',
    pitchDedicatedServer: 'გამოყოფილი სერვერი',
    pitchDocDraftGeo: 'დოკ. შედგენა ქართულად',
    pitchEcourtDesc: 'სარჩელის წარდგენა, საქმის სტატუსი და სხდომის განრიგი — სასამართლოში ვიზიტის გარეშე',
    pitchGdprCompliant: 'GDPR თავსებადი',
    pitchHybrid: 'ჰიბრიდული',
    pitchHybridDesc: 'ღრუბელი + ლოკალური — სენსიტიური მონაცემები ლოკალურად, დანარჩენი ღრუბელში',
    pitchIntegrationsSub: 'სახელმწიფო სერვისები, კალენდრები და OCR — ერთი პლატფორმიდან',
    pitchInvoices: 'ინვოისები',
    pitchMatsneDesc: 'კანონმდებლობის ცვლილებები ავტომატურად — თქვენი პრაქტიკის სფეროში',
    pitchOcrDesc: 'ქაღალდის დოკუმენტების ავტომატური ციფრიზაცია — ხელით აკრეფა აღარ დაგჭირდებათ',
    pitchOnPremise: 'On-Premise სერვერი',
    pitchOnPremiseDesc: 'სრულიად ლოკალური — მონაცემები თქვენს ოფისში რჩება, ინტერნეტზე წვდომის გარეშე',
    pitchOperations: 'ოპერაციები',
    pitchPerkAiDocs: 'AI დოკუმენტები',
    pitchPerkBookings: 'ჯავშნების მართვა',
    pitchPerkClientPortal: 'კლიენტის პორტალი',
    pitchPerkCommunication: 'კომუნიკაცია',
    pitchPerkFileStorage: 'ფაილების შენახვა',
    pitchPerkResponsive: 'რესპონსივი',
    pitchPrivacySubtitle: 'სამართლებრივი მონაცემები მაქსიმალურ დაცვას მოითხოვს',
    pitchPublicRegistryDesc: 'კომპანიის და ქონების მონაცემები ავტომატურად — ხელით ამონაწერის გადმოტანა აღარ დაგჭირდებათ',
    pitchRateNote: '1 USD = 2.73 GEL — მარტი 2026',
    pitchRecurringModel: 'რეკურენტული მოდელი',
    pitchRsGeDesc: 'საგადასახადო დავალიანება და ე-ინვოისი — კლიენტის სტატუსი ერთი კლიკით',
    pitchScen250: '250 ადვოკატი',
    pitchScen500: '500 ადვოკატი',
    pitchScen1000: '1000 ადვოკატი',
    pitchServerCost: 'სერვერის ხარჯი/მომხ.',
    pitchTierBusiness10: '10+ იურისტი',
    pitchTierEnterpriseCustom: 'ინდივიდუალური',
    pitchTierEnterprisePrice: 'შეთავაზება',
    pitchTierPro310: '3-10 იურისტი',
    pitchTierStarter12: '1-2 იურისტი',
    pitchTitle: 'TrustLegal საქართველოსთვის',
    pitchTrustedAccounting: 'სანდო ბუღალტერია',
    pitchWhyAiCheap: 'AI ინსტრუმენტები ახლა საკმარისად იაფია',
    pitchWhyDigitizing: 'ქართული სამართლებრივი ბაზარი სწრაფად ციფრდება',
    pitchWhyNoCompetitor: 'ჩამოყალიბებული კონკურენტი არ არის',
    settingsFirmName: 'სამართლებრივი ჯგუფი "ბარათელი"',
    settingsMember1Name: 'ნინო ბარათელი',
    settingsMember2Name: 'გიგა ასლანიშვილი',
    settingsNotifyDeadlineReminder: 'ვადის შეხსენება',
    settingsNotifyNewBookingEmail: 'ახალი ჯავშანი — Email',
    settingsNotifyNewBookingWhatsapp: 'ახალი ჯავშანი — WhatsApp',
    settingsNotifyOverdueInvoice: 'ვადაგასული ინვოისი',
    settingsNotifyReminder24h: 'შეხსენება 24 სთ-ით ადრე',
    settingsProfileName: 'ნინო ბარათელი',
    settingsToggle3DaysBefore: '3 დღით ადრე',
    portalCaseTypeCivil: 'სამოქალაქო',
    portalDocDate1: '15 მარ',
    portalDocName1: 'სარჩელი - მამულაშვილი.pdf',
    portalFirmLogo: 'ბარათელი Legal',
    portalInvoiceDue: 'ვადა: 25 მარ',
    portalLastUpdate: 'ბოლო განახლება: 18 მარ',
    portalMsgFrom1: 'ნინო ბარათელი',
    portalMsgPlaceholder: 'შეტყობინების გაგზავნა...',
    portalMsgText1: 'გამარჯობა გიორგი, საქმეზე ახალი განახლება გვაქვს.',
    portalMsgText2: 'მადლობა, ველოდები დეტალებს.',
    portalNextHearing: 'სასამართლო სხდომა 25 მარტს',
    portalPay: 'გადახდა',
    portalPendingInvoices: 'გადასახდელი ინვოისები',
    portalProgressLabel: 'პროგრესი: 3/5 ეტაპი',
    portalStatusActive: 'აქტიური',
    clientDashCaseTypeCivil: 'სამოქალაქო',
    clientDashDocMeta1: 'საქმე #2024-047 · 15 მარ',
    clientDashDocMeta2: 'საქმე #2024-046 · 12 მარ',
    clientDashDocName1: 'სარჩელი - მამულაშვილი.pdf',
    clientDashDocName2: 'მინდობილობა - კვარაცხელია.pdf',
    clientDashDocumentsTitle: 'დოკუმენტები',
    clientDashInvCase1: 'საქმე: #2024-047',
    clientDashInvCase2: 'საქმე: #2024-046',
    clientDashInvDue1: 'ვადა: 25 მარტი, 2026',
    clientDashInvoicesTitle: 'ინვოისები',
    clientDashInvPaidDate: 'გადახდილი: 14 მარტი, 2026',
    clientDashLawyerInitials: 'ნბ',
    clientDashLawyerName: 'ნინო ბარათელი',
    clientDashLawyerRole: 'თქვენი ადვოკატი',
    clientDashMessagesTitle: 'შეტყობინებები',
    clientDashMsgFrom1: 'ნინო ბარათელი',
    clientDashMsgFrom3: 'ნინო ბარათელი',
    clientDashMsgPlaceholder: 'დაწერეთ შეტყობინება...',
    clientDashMsgText1: 'გამარჯობა გიორგი, საქმეზე ახალი განახლება გვაქვს. სასამართლომ სხდომა დანიშნა 25 მარტს.',
    clientDashMsgText2: 'მადლობა, ველოდები დეტალებს. რამე დოკუმენტი ხომ არ უნდა მოვამზადო?',
    clientDashMsgText3: 'არა, ყველაფერი მზადაა. სხდომამდე ერთი კვირით ადრე კიდევ დაგიკავშირდებით.',
    clientDashMsgTime1: '10:30 · დღეს',
    clientDashMsgTime2: '10:45 · დღეს',
    clientDashMsgTime3: '11:02 · დღეს',
    clientDashMyCases: 'ჩემი საქმეები',
    clientDashPaid: 'გადახდილი',
    clientDashPay: 'გადახდა',
    clientDashProgressLabel: 'პროგრესი: 3/5 ეტაპი დასრულებული',
    clientDashStatActiveCase: 'აქტიური საქმე',
    clientDashStatDocument: 'დოკუმენტი',
    clientDashStatNextHearing: 'მომდევნო სხდომა',
    clientDashStatNextHearingValue: '25 მარ',
    clientDashStatPayable: 'გადასახდელი',
    clientDashStatusActive: 'აქტიური',
    clientDashStep1Date: '5 მარ, 2026',
    clientDashStep1Title: 'კონსულტაცია ჩატარდა',
    clientDashStep2Date: '10 მარ, 2026',
    clientDashStep2Title: 'სარჩელი შედგენილია',
    clientDashStep3Date: '15 მარ, 2026',
    clientDashStep3Title: 'სარჩელი წარდგენილია სასამართლოში',
    clientDashStep4Date: '25 მარ, 2026 — მოლოდინში',
    clientDashStep4Title: 'სასამართლო სხდომა',
    clientDashStep5Title: 'გადაწყვეტილება',
    clientDashUnpaid: 'გადაუხდელი',
    clientDashWelcomeSub: 'აქ შეგიძლიათ თვალი ადევნოთ თქვენს საქმეებს, ინვოისებს და დოკუმენტებს.',
  },



  ru: {
    home: 'Главная',
    dashboard: 'Дашборд',
    bookings: 'Бронирования',
    bookingPage: 'Страница бронирования',
    aiDocuments: 'ИИ-документы',
    clientPortalNav: 'Клиентский портал',
    lawyersNav: 'Юристы',
    login: 'Войти',
    getStarted: 'Начать бесплатно',
    lawyersTitle: 'Юристы и юридические фирмы',
    lawyersSubtitle: 'зарегистрированные в Грузии',
    searchPlaceholder: 'Поиск по имени, фирме или специализации...',
    lawyersBtn: 'Юристы',
    firmsBtn: 'Фирмы',
    allFilter: 'Все',
    corporateLaw: 'Корпоративное право',
    criminalLaw: 'Уголовное право',
    familyLaw: 'Семейное право',
    realEstate: 'Недвижимость',
    taxLaw: 'Налоговое право',
    ipLaw: 'Интеллектуальная собственность',
    immigration: 'Иммиграция',
    laborLaw: 'Трудовое право',
    bankingFinance: 'Банки и финансы',
    firmsMatch: 'фирм найдено',
    lawyersMatch: 'юристов найдено',
    reviews: 'отзывов',
    loadingMore: 'Загрузка...',
    independent: 'Независимый',
    yearsExperience: 'лет опыта',
    languages: 'Языки',
    backToDirectory: '← Назад в каталог',
    about: 'Описание',
    bookConsultation: 'Записаться на консультацию',
    sendMessage: 'Отправить сообщение',
    call: 'Позвонить',
    reviewsRatings: 'Отзывы и оценки',
    reviewsComingSoon: 'Отзывы скоро появятся. Оставьте отзыв первым.',
    barId: 'Номер в реестре',
    ourTeam: 'Наша команда',
    contact: 'Контакты',
    website: 'Веб-сайт',
    established: 'Осн.',
    lawyersCount: 'юристов',
    georgian: 'Грузинский',
    english: 'Английский',
    russian: 'Русский',
    german: 'Немецкий',
    french: 'Французский',
    turkish: 'Турецкий',
    heroLine1: 'Ваша юридическая',
    heroLine2: 'команда. Одна',
    heroLine3: 'платформа.',
    heroSubtitle: 'TrustLegal — бронирования, дела, платежи и составление документов с ИИ для грузинских юридических фирм. Единая ежемесячная плата, без контракта.',
    tryFree: 'Попробовать бесплатно →',
    liveDemo: 'Живое демо',
    trustedBrands: 'Бренды, которым важно качество, работают с нами',
    howItWorks: 'Как это работает',
    processLabel: '// Процесс',
    step1Title: 'Регистрация',
    step1Desc: 'Создайте аккаунт и выберите тариф. Кредитная карта не требуется — первые 30 дней бесплатно.',
    step2Title: 'Управление делами',
    step2Desc: 'Доб��вляйте клиентов, дела и записи. Автоматические напоминания и синхронизация с календарем.',
    step3Title: 'Документы с ИИ',
    step3Desc: 'Составление документов на грузинском языке с помощью ИИ. Иски, доверенности, анализ договоров.',
    step4Title: 'Рост',
    step4Desc: 'Отслеживайте счета, доходы и продуктивность команды. Аналитика в реальном времени.',
    demoBadge: '// Живое демо',
    todaysBookings: 'Записи на сегодня',
    fullDemo: 'Полное демо →',
    onePlatformThreePillars: 'Одна платформа.\nТри основы.',
    capabilitiesLabel: '// Возможности',
    bookingFeature: 'Бронирование',
    bookingFeatureDesc: 'Клиенты сами выбирают время. Авто-напоминания. Синхронизация с календарем. Публичная страница бронирования.',
    operationsFeature: 'Операции',
    operationsFeatureDesc: 'Централизованное управление делами. Клиентски�� портал. Счета и платежи. Управление командой.',
    aiFeatureDesc: 'Составление документов на грузинском. Анализ договоров. Юридические исследования. Автоматические фоллоу-апы.',
    simplePricing: 'Простые тарифы',
    plansLabel: '// Тарифы',
    perMonth: '/ месяц',
    bookingMgmt: 'Управление записями',
    caseTracking: 'Отслеживание дел',
    calendarSync: 'Синхронизация календаря',
    emailReminders: 'Email-напоминания',
    starterPlan: 'Стартовый',
    startNow: 'Начать сейчас →',
    everythingStarter: 'Всё из тарифа Стартовый',
    aiDocDrafting: 'Составление документов с ИИ',
    invoicesPayments: 'Счета и платежи',
    clientPortalFeature: 'Клиентский портал',
    directSupport: 'Прямая поддержка',
    professionalPlan: 'Профессиональный',
    mostPopular: 'Самый популярный',
    everythingPro: 'Всё из тарифа Профессиональный',
    teamMgmt10: 'Управление командой (10+ юристов)',
    contractAnalysis: 'Анализ договоров',
    advancedAnalytics: 'Продвинутая аналитика',
    personalOnboarding: 'Персональный онбординг',
    businessPlan: 'Бизнес',
    spotsLeft: 'Осталось 3 места',
    enterpriseNote: 'Enterprise — свяжитесь с нами для индивидуального предложения.',
    readyQuestion: 'Готовы?',
    first30DaysFree: 'Первые 30 дней бесплатно. Без контракта. Отмена в любое время.',
    footerTagline: 'Грузинская юридическая SaaS-платформа.',
    productLabel: 'Продукт',
    companyLabel: 'Компания',
    bookingsLink: 'Записи',
    casesLink: 'Дела',
    aiDocsLink: 'ИИ-документы',
    aboutUs: 'О нас',
    careers: 'Карьера',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'Создано с Symbols',
    sidebarMain: 'Панель управления',
    sidebarBookings: 'Записи',
    sidebarCases: 'Дела',
    sidebarClients: 'Клиенты',
    sidebarDocs: 'Документы',
    sidebarPayments: 'Платежи',
    sidebarLawyers: 'Юристы',
    sidebarSettings: 'Настройки',
    sidebarLogout: 'Выйти',
    bookingsTitle: 'Записи',
    newBooking: '+ Новая запись',
    newBookingTitle: 'Новая запись',
    clientName: 'Имя клиента',
    phoneNumber: 'Телефон',
    civilLaw: 'Гражданское',
    criminalLaw2: 'Уголовное право',
    administrativeLaw: 'Административное',
    otherType: 'Другое',
    notesPlaceholder: 'Заметки...',
    confirmBooking: 'Подтвердить запись',
    cancelBtn: 'Отмена',
    calendarSyncNote: 'Синхронизация календаря — Google Calendar, Outlook, Apple Calendar синхронизируются автоматически',
    synced: 'Синхронизировано',
    calendarSync2: 'Синхронизация календаря',
    syncedStatus: 'Синхронизировано',
    bookingsToday: '3 записи сегодня',
    settingsLink: 'Настройки →',
    pendingStatus: 'В ожидании',
    connectionNeeded: 'Требуется подключение',
    connectLink: 'Подключить →',
    lastSync: 'Последняя синхронизация: 5 мин назад',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    bookingDetails: 'Детали записи',
    confirmed: 'Подтверждено',
    pending: 'В ожидании',
    upcomingBookings: 'Предстоящие записи',
    closeBtn: 'Закрыть',
    selectDateTime: 'Выберите дату и время',
    fillInfo: 'Заполните информацию — ',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phoneField: 'Телефон',
    emailField: 'Email',
    caseDescription: 'Краткое описание дела',
    confirmBookingPublic: 'Подтвердить бронирование',
    goBack: 'Назад',
    bookingConfirmedMsg: 'Бронирование подтверждено!',
    timeLabel: 'Время: ',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Нино Баратели',
    casesTitle: 'Дела',
    searchPlaceholder2: 'Поиск...',
    newCase: '+ Новое дело',
    allTab: 'Все',
    activeTab: 'Активные',
    pendingTab: 'В ожидании',
    closedTab: 'Закрытые',
    selectCasePrompt: 'Выберите дело для просмотра деталей',
    info: 'Информация',
    registry: 'Реестр',
    clientInfo: 'Информация о клиенте',
    chronology: 'Хронология',
    addNote: 'Добавить заметку',
    enterNote: 'Введите заметку...',
    addBtn: 'Добавить',
    documentsLabel: 'Документы',
    createBtn: '+ Создать',
    noDocs: 'Нет документов',
    hearingSchedule: 'График заседаний',
    caseStatus: 'Статус дела',
    electronicFiling: 'Электронная подача',
    idCode: 'ID код:',
    director: 'Директор:',
    addressLabel: 'Адрес:',
    statusLabel: 'Статус:',
    registeredProperty: 'Зарегистрированное имущество',
    extractLabel: 'Выписка',
    recentChanges: 'Последние изменения',
    yourFieldChanges: 'Изменения в вашей сфере',
    newLabel: 'Новое',
    notifications: 'Уведомления',
    clientsTitle: 'Клиенты',
    clientsSearchPlaceholder: 'Поиск клиентов...',
    clientsProfile: 'Профиль клиента',
    clientsContactLabel: 'Контакты',
    clientsInvoiceHistory: 'История счетов',
    clientsUnpaid: 'Неопл��ченные',
    clientsPaid: 'Оплаченные',
    clientsPortalInvite: 'Отправить доступ к клиентскому порталу',
    dashTodayBookings: 'Бронирования на сегодня',
    dashUnpaid: 'Неоплаченные',
    dashOverdue: 'Просроченные',
    dashAiGenerations: 'Генерации ИИ',
    dashTodaysBookings: 'Бронирования на сегодня',
    dashConfirmed: 'Подтвержденные',
    dashRecentCases: 'Недавние дела',
    dashNewBooking: '+ Новое бронирование',
    dashNewCase: '+ Новое дело',
    dashAiDocument: 'ИИ Документ',
    docsTitle: 'Документы',
    docsCreate: 'Создать',
    docsExisting: 'Существующие документы',
    docsFiles: 'Файлы',
    docsOcrScan: 'Сканировать',
    docsOcrTitle: 'OCR сканирование',
    docsUploadText: 'Загрузите фото документа или PDF',
    docsScanning: 'Сканирование документа...',
    docsFile: 'Файл',
    docsPages: 'Страницы',
    docsLanguage: 'Язык',
    docsGeorgian: 'Грузинский',
    docsAddToCase: 'Добавить к делу',
    docsCopy: 'Копировать',
    docsRescan: 'Пересканировать',
    docsClaim: 'Иск',
    docsPowerOfAttorney: 'Доверенность',
    docsNotification: 'Уведомление',
    docsContractReview: 'Анализ договора',
    docsFreeForm: 'Свободная форма',
    docsParty1: 'Сторона 1',
    docsNameCompany: 'Имя / Компания',
    docsParty2: 'Сторона 2',
    docsDate: 'Дата',
    docsAdditionalInfo: 'Дополнительная информация',
    docsGenerating: 'Генерация...',
    docsGenerate: 'Сгенерировать',
    docsGeneratedDocument: 'Сгенерированный документ',
    docsEmptyState: 'Сгенерированный документ появится здесь',
    docsShowDemo: 'Показать демо-документ',
    docsDownload: 'Скачать',
    docsSend: 'Отправить',
    docsCreatedDocuments: 'Созданные документы',
    docsSearch: 'Поиск...',
    docsFileManager: 'Файловый менеджер',
    docsUpload: 'Загрузить',
    docsCases: 'Дела',
    docsTemplates: 'Шаблоны',
    docsRecentFiles: 'Недавние файлы',
    billingTitle: 'Биллинг',
    billingNewInvoice: 'Новый счет',
    billingTotalSent: 'Всего отправлено',
    billingPaid: 'Оплачено',
    billingUnpaid: 'Не оплачено',
    billingOverdue: 'Просрочено',
    billingActive: 'Активно',
    billingClientStatus: 'Статус клиента',
    billingEInvoice: 'Электронный счет',
    billingAutoCheck: 'Автопроверка',
    billingSettings: 'Настройки →',
    billingInvoice: 'Счет',
    billingClient: 'Клиент',
    billingCase: 'Дело',
    billingAmount: 'Сумма',
    billingDue: 'Срок',
    billingStatus: 'Статус',
    aiTitle: 'ИИ-ассистент',
    aiPowered: 'На базе ИИ',
    aiDraftDocs: 'Составление документов',
    aiContractAnalysis: 'Анализ договоров',
    aiLegalResearch: 'Юридическое исследование',
    aiDraftAvailable: 'Составление документов доступно на странице документов',
    aiGoToDocuments: 'Перейти к документам →',
    aiPasteContract: 'Вставьте текст догово��а здесь...',
    aiAnalyze: 'Анализировать',
    aiReanalyze: 'Повторный анализ',
    aiParties: 'Стороны',
    aiObligations: 'Ключевые обязательства',
    aiRiskFactors: 'Факторы риска',
    aiDeadlines: 'Сроки',
    aiRecommendations: 'Рекомендации',
    aiAskQuestion: 'Задайте вопрос по законодательству Грузии',
    aiLegalResearchTitle: 'Юридическое исследование с ИИ',
    aiAskPlaceholder: 'Задайте вопрос...',
    aiSend: 'Отправить',
    pitchTagline: 'Юридический SaaS Грузии',
    pitchSubtitle: 'Бронирование · Операции · ИИ — для грузинских фирм',
    pitchCta: 'Смотреть возможности →',
    pitchMarketLabel: '// Рынок',
    pitchMarketTitle: '5000+ юристов в Грузии',
    pitchPopulation: 'Население',
    pitchTbilisi: 'Тбилиси',
    pitchConcentrated: 'Концентрированный рынок',
    pitchZeroCompetitor: 'Местный SaaS-конкурент',
    pitchProblemLabel: '// Проблема',
    pitchProblemTitle: 'Грузинские фирмы все еще работают в WhatsApp и Excel',
    pitchNoBooking: 'Нет системы бронирования клиентов',
    pitchManualCases: 'Ручное ведение дел',
    pitchNoAiTools: 'Нет ИИ-инструментов на грузинском',
    pitchCapabilitiesLabel: '// Возможности',
    pitchOnePlatform: 'Одна платформа. Три основы.',
    pitchProductLabel: '// Продукт',
    pitchProductTitle: 'Всё в одной платформе',
    pitchIntegrationsLabel: '// Интеграции',
    pitchIntegrationsTitle: 'Автоматизация, а не ручной труд',
    pitchPublicRegistry: 'Публичный реестр',
    pitchCalendarSyncTitle: 'Синхронизация календаря',
    pitchOcrTitle: 'OCR и сканирование',
    pitchPlansLabel: '// Тарифы',
    pitchPlansTitle: 'Цены для грузинского рынка',
    pitchTierStarter: 'Стартовый',
    pitchMostPopular: 'Самый популярный',
    pitchTierPro: 'Профессиональный',
    pitchTierBusiness: 'Бизнес',
    pitchTierEnterprise: 'Enterprise',
    pitchRevenueLabel: '// Доход',
    pitchRevenueTitle: 'Потенциал дохода',
    pitchFinanceLabel: '// Финансы',
    pitchFinanceTitle: 'Юнит-экономика',
    pitchTimeLabel: '// Время',
    pitchTimeTitle: 'Самое подходящее время',
    pitchPrivacyLabel: '// Конфиденциальность',
    pitchPrivacyTitle: 'Конфиденциальность — наш приоритет',
    pitchCtaLabel: '// Строим вместе',
    pitchCtaTitle: 'Давайте создавать правовую инфраструктуру Грузии вместе',
    pitchCtaLink: 'Главная страница →',
    pitchPerMonth: 'месяц',
    settingsTitle: 'Настройки',
    settingsTabProfile: 'Профиль',
    settingsTabFirm: 'Компания',
    settingsTabTeam: 'Команда',
    settingsTabNotifications: 'Уведомления',
    settingsUploadPhoto: 'Загрузить фото',
    settingsSave: 'Сохранить',
    settingsFirmAddress: 'Адрес',
    settingsFirmRegNumber: 'Регистрационный номер',
    settingsPublicBookingUrl: 'Публичная ссылка для записи',
    settingsTeamMembers: 'Участники команды',
    settingsInvite: '+ Пригласить',
    settingsRoleOwner: 'Владелец',
    settingsRoleLawyer: 'Юрист',
    settingsNotifyTitle: 'Настройки уведомлений',
    settingsToggleOn: 'Включено',
    settingsToggleOff: 'Отключено',
    loginSubtitle: 'Войдите в свой аккаунт',
    loginLawyer: 'Юрист',
    loginClient: 'Клиент',
    loginPassword: 'Пароль',
    loginSubmit: 'Войти →',
    loginCaseNumber: 'Номер дела',
    loginBackLink: '← Назад',
    portalLogout: 'Выйти',
    portalWelcome: 'Здравствуйте,',
    portalActiveCases: 'Активные де��а',
    portalDocuments: 'Документы',
    portalMessages: 'Сообщения',
    portalSend: 'Отправить',
    clientDashNavCases: 'Дела',
    clientDashNavInvoices: 'Счета',
    clientDashNavDocuments: 'Документы',
    clientDashNavMessages: 'Сообщения',
    clientDashLogout: 'Выйти',
    clientDashWelcome: 'Здравствуйте,',
    clientDashDownload: 'Скачать',
    clientDashSend: 'Отправить',
    findLawyer: 'Найти юриста',
    lawyersSearchSub: 'Поиск среди 5,700+ юристов, зарегистрированных в Georgian Bar Association',
    searchBtn: 'Поиск',
    viewAll: 'Смотреть все',
    lawyerPortal: 'Портал юриста',
    aiFeature: 'AI',
    aiChip1: 'Расторжение нотариального договора',
    aiChip1Question: 'Каковы условия расторжения нотариального договора?',
    aiChip2: 'Статья 317 Гражданского кодекса',
    aiChip2Question: 'Толкование статьи 317 Гражданского кодекса',
    aiChip3: 'Недействительность сделки',
    aiChip3Question: 'Су��ебная практика по недействительности сделок за последние 3 года',
    aiDeadlinesData: '• Начало услуг: 10 дней с даты договора\n• Первый платеж: 1 апреля 2026 г.\n• Срок договора: 12 месяцев',
    aiEmptyChatSub: 'AI — Задайте вопрос и получите ответ по законодательству Грузии',
    aiObligationsData: '1. Оказание услуг в течение 30 календарных дней\n2. Оплата в течение 15 рабочих дней\n3. Конфиденциальность в течение 3 лет',
    aiPartiesData: 'Сторона 1: ООО Barateli & Partners\nСторона 2: ООО Delta Group',
    aiRecommendationsData: '1. Добавить пункт о неустойке (ст. 417 ГК)\n2. Определить порядок разрешения споров через арбитраж\n3. Расширить пункт о форс-мажоре',
    aiRisksData: '• Не определена пеня за просрочку платежа\n• Не указан механизм разрешения споров\n• Пункт о форс-мажоре не покрывает пандемию',
    address: 'Адрес',
    addressVal: 'Тбилиси, Чавчавадзе 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'Георгий Мамулашвили',
    billingClient2: 'Мариам Кварацхелия',
    billingClient3: 'Лела Гогиашвили',
    billingClientName: 'ООО Delta Group',
    billingDue1: '25 мар',
    billingDue2: '15 мар',
    billingDue3: '10 мар',
    billingEmailNotification: 'Email-уведомление',
    billingLastCheck: 'Последняя проверка: сегодня',
    billingNoDebt: 'Нет задолженности',
    billingRsBanner: 'Интеграция с rs.ge — налоговая задолженность клиента и электронный счет в один клик',
    billingRsTaxSystem: 'rs.ge — Налоговая система',
    billingStatusPaid: 'Оплачено',
    billingStatusSent: 'Отправлено',
    billingViewFull: 'Смотреть полностью →',
    billingViewInvoices: 'Смотреть счета →',
    billingWeeklyEnabled: 'Еженедельно включено',
    caseRow1Title: '#2024-047 — Гиорги Мамулашвили',
    caseRow2Title: '#2024-046 — Мариам Кварацхелия',
    caseRow3Title: '#2024-045 — Лела Гогиашвили',
    change1Date: '15 марта — Вступает в силу: 1 апреля',
    change1Desc: 'Срок увеличен с 30 до 45 дней',
    change1Name: 'Гражданский кодекс — Ст. 316',
    change2Date: '12 марта — Вступает в силу: 1 мая',
    change2Desc: 'Срок апелляции с 14 до 21 дня',
    change2Name: 'Процессуальный кодекс — Сроки',
    claimAccepted: 'Иск принят — 17 марта',
    claimFiled: 'Иск подан — 15 марта',
    claimFiledDoc: 'Иск — Подан',
    clientName1: 'Гиорги Мамулашвили',
    clientName2: 'Мариам Кварацхелия',
    clientName3: 'Лела Гогиашвили',
    companyExtractLoaded: 'Выписка компании — Загружена',
    companyName: 'ООО Delta Group',
    clientsActiveCases1: '1 активное дело',
    clientsActiveCases2: '1 активное дело',
    clientsActiveCases3: '0 активных дел',
    clientsAvatar1: 'ГМ',
    clientsAvatar2: 'МК',
    clientsAvatar3: 'ЛГ',
    clientsCaseLink1: '#2024-047 — Граждан��кое',
    clientsCaseLink2: '#2024-046 — Административное',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'Нет активных дел',
    clientsPaid1: '₾2,400 оплачено',
    clientsPaid2: '₾800 оплачено',
    clientsPaid3: '₾1,800 оплачено',
    dashAlertText: '2 просроченных дела и неоплаченные счета на ₾1,840',
    dashBooking1Time: '10:00 — Гражданское',
    dashBooking2Time: '11:30 — Административное',
    dashBooking3Time: '14:00 — Уголовное',
    dashCaseMeta1: 'Гражданское · 18 мар',
    dashCaseMeta2: 'Административное · 17 мар',
    dashCaseMeta3: 'Уголовное · 15 мар',
    dashClient3Name: 'Давит Чиковани',
    dashDate: '18 марта 2026 г.',
    dashGreeting: 'Здравствуйте, Нино',
    dateMar15: '15 мар',
    dateMar17: '17 мар',
    dateMar18: '18 мар',
    disabledStatus: '— Отключено',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: 'Грузия, Тбилиси\n\nИск\n\nИстец: ООО Barateli & Partners\nОтветчик: ООО Delta Group\n\nФактические обстоятельства:\n\nНастоящим иском истец требует от ответчика выполнить свои обязательства.\n\nТребование:\n\n1. Обязать ответчика выплатить 12,500 GEL\n2. Назначить штраф в размере 1,875 GEL\n3. Возместить судебные издержки\n\nДата: 18 марта 2026 г.\nПодпись: ________________',
    docsDocument: 'Документ',
    docsFile1Meta: 'PDF · 124 KB · 15 мар 2026',
    docsFile1Name: 'Иск - Мамулашвили.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 мар 2026',
    docsFile2Name: 'Доверенность - Кварацхелия.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 мар 2026',
    docsFile3Name: 'Договор №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 мар 2026',
    docsFile4Name: 'Копия ID - Мамулашвили.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 мар 2026',
    docsFile5Name: 'Уведомление - Гогиашвили.pdf',
    docsFolder1Count: '3 файла',
    docsFolder1Name: '#2024-047 Мамулашвили',
    docsFolder2Count: '2 файла',
    docsFolder2Name: '#2024-046 Кварацхелия',
    docsFolder3Count: '1 файл',
    docsFolder3Name: '#2024-045 Гогиашвили',
    docsFolder4Count: '5 файлов',
    docsFormatAnalysis: 'Анализ формата...',
    docsFreeText: 'Свободный текст...',
    docsGeneratedClaimText: 'Грузия, Тбилиси\n\nИск\n\nИстец: [Сторона 1]\nОтветчик: [Сторона 2]\n\nФактические обстоятельства:\n\nНастоящим иском истец требует от ответчика выполнить свои обязательства согласно Гражданскому кодексу Грузии.\n\nПравовое основание:\n\nСогласно статье 316 Гражданского кодекса, обязательства должны исполняться надлежащим образом.\n\nТребование:\n\nУчитывая вышеизложенное, истец просит суд обязать ответчика.\n\nДата: 18 марта 2026 г.\nПодпись: ________________',
    docsGeorgianSymbols: 'Грузинские символы',
    docsOcrNote: 'OCR-сканирование — автоматическая оцифровка бумажных документов, ручной ввод не требуется',
    docsOcrResultText: 'Договор №147\n\nТбилиси, 10 марта 2026 г.\n\nС одной стороны, ООО Barateli & Partners (ИНН 404123456) в лице директора Нино Баратели (далее «Исполнитель») и с другой стороны, ООО Delta Group (ИНН 404789012) в лице директора Георгия Мамулашвили (далее «Заказчик»), заключили настоящий договор:\n\nСтатья 1. Предмет договора\n1.1. Исполнитель обязуется оказать юридические услуги Заказчику.\n1.2. Стоимость услуг составляет 12 500 (двенадцать тысяч пятьсот) GEL.',
    docsOcrSuccess: 'Успешно распо��нано — точность 98.5%',
    docsRow1Meta: '#2024-047 · Иск · 15 мар',
    docsRow1Name: 'Иск - Мамулашвили.pdf',
    docsRow2Meta: '#2024-046 · Доверенность · 12 мар',
    docsRow2Name: 'Доверенность - Кварацхелия.pdf',
    docsRow3Meta: '#2024-045 · Уведомление · 8 мар',
    docsRow3Name: 'Уведомление - Гогиашвили.pdf',
    docsTextRecognition: 'Распознавание текста',
    docsUploadFormats: 'JPG, PNG, PDF — макс. 10MB',
    docsUploadSub: 'Перетащите файл или нажмите для выбора',
    ecourt: 'ecourt',
    ecourtDesc: 'Подача исков, проверка статуса дела и расписания заседаний — без посещения суда',
    enabledStatus: '✓ Включено',
    evidencePending: 'Доказательства — В ожидании',
    extract: 'Выписка',
    field1Text: 'Гражданское: ст. 316 поправка',
    field2Text: 'Гражданское: ст. 259 сроки',
    field3Text: 'Административное: электронные услуги',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 мар, 10:00 — Тбилисский городской суд',
    hearingItem2: '📅 28 мар, 14:30 — Апелляционный суд',
    loginEmail: 'Email',
    matsne: 'matsne',
    matsneDesc: 'Изменения в законодательстве автоматически — в вашей сфере практики',
    outlook: 'Outlook',
    prepHearing: 'Предварительное слушание — 22 марта',
    propertyApartment: 'Квартира — Ваке, 85 кв.м · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'Выписка на имущество — Добавлена',
    registryDesc: 'Данные о компаниях и имуществе автоматически — больше никаких ручных скачиваний выписок',
    timeEntry1Date: '18 мар, 10:30',
    timeEntry1Text: 'Дело открыто, первичная консультация завершена',
    timeEntry2Date: '17 мар, 14:00',
    timeEntry2Text: 'Клиент предоставил документацию',
    timeEntry3Date: '15 мар, 09:00',
    timeEntry3Text: 'Клиент связался с фирмой, первичное обращение',
    typeCivil: 'Гражданское',
    typeAdministrative: 'Административное',
    typeCriminal: 'Уголовное',
    pitchArpuMonth: 'Средний ARPU/мес',
    pitchArpuYear: 'Средний ARPU/год',
    pitchAutoBackup: 'Автоматическое резервное копирование',
    pitchAutoNextSteps: 'Авто-следующие шаги',
    pitchAutoReminder: 'Авто-напоминание',
    pitchBooking: 'Бронирование',
    pitchCacOrganic: 'CAC (органический рост)',
    pitchCalcNote: '5000 юристов × ₾35/мес в ср. × 12 месяцев',
    pitchCalendarSync: 'Синхронизация календаря',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — слушания и сроки синхронизируются автоматически',
    pitchCaseManagement: 'Управление делами',
    pitchClientSchedule: 'Расписание клиентов',
    pitchCloudDedicated: 'Выделенное облако',
    pitchCloudDedicatedDesc: 'Изолированный облачный сервер — ваши данные полностью отделены от других клиентов',
    pitchContractAnalysis: 'Анализ договоров',
    pitchCtaSubtext: 'Бронирование + Операции + AI',
    pitchDedicatedServer: 'Выделенный сервер',
    pitchDocDraftGeo: 'Составление документов на грузинском',
    pitchEcourtDesc: 'Подача исков, статус дела и расписание заседаний — без посещения суда',
    pitchGdprCompliant: 'Соответствие GDPR',
    pitchHybrid: 'Гибрид',
    pitchHybridDesc: 'Облако + локально — конфиденциальные данные локально, остальное в облаке',
    pitchIntegrationsSub: 'Государственные сервисы, календари и OCR — с одной платформы',
    pitchInvoices: 'Счета',
    pitchMatsneDesc: 'Изменения в законодательстве автоматически — в вашей сфере практики',
    pitchOcrDesc: 'Автоматическая оцифровка бумажных документов — без ручного ввода',
    pitchOnPremise: 'Локальный сервер',
    pitchOnPremiseDesc: 'Полностью локально — данные остаются в вашем о��исе, без доступа в интернет',
    pitchOperations: 'Операции',
    pitchPerkAiDocs: 'AI Документы',
    pitchPerkBookings: 'Управление бронированием',
    pitchPerkClientPortal: 'Клиентский портал',
    pitchPerkCommunication: 'Коммуникация',
    pitchPerkFileStorage: 'Хранение файлов',
    pitchPerkResponsive: 'Адаптивность',
    pitchPrivacySubtitle: 'Юридические данные требуют максимальной защиты',
    pitchPublicRegistryDesc: 'Данные о компаниях и имуществе автоматически — без ручного скачивания выписок',
    pitchRateNote: '1 USD = 2.73 GEL — март 2026',
    pitchRecurringModel: 'Рекуррентная модель',
    pitchRsGeDesc: 'Налоговая задолженность и электронные счета — статус клиента в один клик',
    pitchScen250: '250 юристов',
    pitchScen500: '500 юристов',
    pitchScen1000: '1000 юристов',
    pitchServerCost: 'Стоимость сервера на пользователя',
    pitchTierBusiness10: '10+ юристов',
    pitchTierEnterpriseCustom: 'Индивидуальный',
    pitchTierEnterprisePrice: 'По запросу',
    pitchTierPro310: '3-10 юристов',
    pitchTierStarter12: '1-2 юриста',
    pitchTitle: 'TrustLegal для Грузии',
    pitchTrustedAccounting: 'Надежный учет',
    pitchWhyAiCheap: 'ИИ-инструменты теперь достаточно доступны',
    pitchWhyDigitizing: 'Грузинский юридический рынок быстро цифровизир��ется',
    pitchWhyNoCompetitor: 'Нет устоявшихся конкурентов',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'Нино Баратели',
    settingsMember2Name: 'Гига Асланишвили',
    settingsNotifyDeadlineReminder: 'Напоминание о сроке',
    settingsNotifyNewBookingEmail: 'Новое бронирование — Email',
    settingsNotifyNewBookingWhatsapp: 'Новое бронирование — WhatsApp',
    settingsNotifyOverdueInvoice: 'Просроченный счет',
    settingsNotifyReminder24h: 'Напоминание за 24 часа',
    settingsProfileName: 'Нино Баратели',
    settingsToggle3DaysBefore: 'За 3 дня',
    portalCaseTypeCivil: 'Гражданское',
    portalDocDate1: '15 мар',
    portalDocName1: 'Иск - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: 'Оплатить до: 25 мар',
    portalLastUpdate: 'Последнее обновление: 18 мар',
    portalMsgFrom1: 'Нино Баратели',
    portalMsgPlaceholder: 'Отправить сообщение...',
    portalMsgText1: 'Здравствуйте, Георгий, у нас новые обновлени�� по делу.',
    portalMsgText2: 'Спасибо, жду подробностей.',
    portalNextHearing: 'Судебное заседание 25 марта',
    portalPay: 'Оплатить',
    portalPendingInvoices: 'Неоплаченные счета',
    portalProgressLabel: 'Прогресс: 3/5 шагов',
    portalStatusActive: 'Активно',
    clientDashCaseTypeCivil: 'Гражданское',
    clientDashDocMeta1: 'Дело #2024-047 · 15 мар',
    clientDashDocMeta2: 'Дело #2024-046 · 12 мар',
    clientDashDocName1: 'Иск - Mamulashvili.pdf',
    clientDashDocName2: 'Доверенность - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: 'Документы',
    clientDashInvCase1: 'Дело: #2024-047',
    clientDashInvCase2: 'Дело: #2024-046',
    clientDashInvDue1: 'Оплатить до: 25 марта 2026',
    clientDashInvoicesTitle: 'Счета',
    clientDashInvPaidDate: 'Оплачено: 14 марта 2026',
    clientDashLawyerInitials: 'НБ',
    clientDashLawyerName: 'Нино Баратели',
    clientDashLawyerRole: 'Ваш юрист',
    clientDashMessagesTitle: 'Сообщения',
    clientDashMsgFrom1: 'Нино Баратели',
    clientDashMsgFrom3: '��ино Баратели',
    clientDashMsgPlaceholder: 'Написать сообщение...',
    clientDashMsgText1: 'Здравствуйте, Георгий, у нас новости по делу. Суд назначил заседание на 25 марта.',
    clientDashMsgText2: 'Спасибо, жду подробностей. Нужно ли мне подготовить какие-то документы?',
    clientDashMsgText3: 'Нет, все готово. Я свяжусь с вами за неделю до заседания.',
    clientDashMsgTime1: '10:30 · Сегодня',
    clientDashMsgTime2: '10:45 · Сегодня',
    clientDashMsgTime3: '11:02 · Сегодня',
    clientDashMyCases: 'Мои дела',
    clientDashPaid: 'Оплачено',
    clientDashPay: 'Оплатить',
    clientDashProgressLabel: 'Прогресс: пройдено 3/5 шагов',
    clientDashStatActiveCase: 'Активное дело',
    clientDashStatDocument: 'Документ',
    clientDashStatNextHearing: 'Следующее заседание',
    clientDashStatNextHearingValue: '25 мар',
    clientDashStatPayable: 'К оплате',
    clientDashStatusActive: 'Активно',
    clientDashStep1Date: '5 мар 2026',
    clientDashStep1Title: 'Консультация завершена',
    clientDashStep2Date: '10 мар 2026',
    clientDashStep2Title: 'Иск составлен',
    clientDashStep3Date: '15 мар 2026',
    clientDashStep3Title: 'Иск подан в суд',
    clientDashStep4Date: '25 мар 2026 — Ожидается',
    clientDashStep4Title: 'Судебное заседание',
    clientDashStep5Title: 'Решение',
    clientDashUnpaid: 'Не оплачено',
    clientDashWelcomeSub: 'Здесь вы можете отслеживать свои дела, счета и документы.',
  },

  uk: {
    home: 'Головна',
    dashboard: 'Дашборд',
    bookings: 'Бронювання',
    bookingPage: 'Сторінка бронювання',
    aiDocuments: 'AI Документи',
    clientPortalNav: 'Клієнтський портал',
    lawyersNav: 'Юристи',
    login: 'Увійти',
    getStarted: 'Почати безкоштовно',
    lawyersTitle: 'Юристи та юридичні фірми',
    lawyersSubtitle: 'зареєстровані в Грузії',
    searchPlaceholder: 'Пошук за ім\'ям, фірмою або сферою практики...',
    lawyersBtn: 'Юристи',
    firmsBtn: 'Фірми',
    allFilter: 'Всі',
    corporateLaw: 'Корпоративне право',
    criminalLaw: 'Кримінальне право',
    familyLaw: 'Сімейне право',
    realEstate: 'Нерухомість',
    taxLaw: 'Податкове право',
    ipLaw: 'IP',
    immigration: 'Імміграція',
    laborLaw: 'Трудове право',
    bankingFinance: 'Банківська справа та фінанси',
    firmsMatch: 'фірм знайдено',
    lawyersMatch: 'юристів знайдено',
    reviews: 'відгуків',
    loadingMore: 'Завантаження ще...',
    independent: 'Незалежний',
    yearsExperience: 'років досвіду',
    languages: 'Мови',
    backToDirectory: '← Назад до каталогу',
    about: 'Про нас',
    bookConsultation: 'Забронювати консультацію',
    sendMessage: 'Надіслати повідомлення',
    call: 'Зателефонувати',
    reviewsRatings: 'Відгуки та оцінки',
    reviewsComingSoon: 'Відгуки з\'являться незабаром. Будьте першим, хто залишить відгук.',
    barId: 'Bar ID',
    ourTeam: 'Наша команда',
    contact: 'Контакти',
    website: 'Вебсайт',
    established: 'Засн.',
    lawyersCount: 'юристів',
    georgian: 'Грузинська',
    english: 'Англійська',
    russian: 'Російська',
    german: 'Німецька',
    french: 'Французька',
    turkish: 'Турецька',
    heroLine1: 'Ваша юридична',
    heroLine2: 'команда. Одна',
    heroLine3: 'платформа.',
    heroSubtitle: 'TrustLegal — бронювання, справи, платежі та створення документів за допомогою AI для грузинських юридичних фірм. Одна щомісячна плата, без контрактів.',
    tryFree: 'Спробувати безкоштовно →',
    liveDemo: 'Live Demo',
    trustedBrands: 'Бренди, які дбають про якість, працюють з нами',
    howItWorks: 'Як це працює',
    processLabel: '// Процес',
    step1Title: 'Реєстрація',
    step1Desc: 'Створіть акаунт та виберіть тариф. Кредитна картка не потрібна — перші 30 днів безкоштовно.',
    step2Title: 'Керування справами',
    step2Desc: 'Додавай��е клієнтів, справи та бронювання. Автоматичні нагадування та синхронізація з календарем.',
    step3Title: 'Створення з AI',
    step3Desc: 'Створення документів грузинською мовою за допомогою AI. Позови, довіреності, аналіз договорів.',
    step4Title: 'Зростання',
    step4Desc: 'Відстежуйте рахунки, доходи та продуктивність команди. Аналітика в реальному часі.',
    demoBadge: '// Live Demo',
    todaysBookings: 'Сьогоднішні бронювання',
    fullDemo: 'Повне демо →',
    onePlatformThreePillars: 'Одна платформа.\nТри основи.',
    capabilitiesLabel: '// Можливості',
    bookingFeature: 'Бронювання',
    bookingFeatureDesc: 'Клієнти самі обирають час. Автоматичні нагадування. Синхронізація з календарем. Публічна сторінка бронювання.',
    operationsFeature: 'Операції',
    operationsFeatureDesc: 'Централізоване управління справами. Клієнтс��кий портал. Рахунки та платежі. Управління командою.',
    aiFeatureDesc: 'Створення документів грузинською мовою. Аналіз договорів. Юридичні дослідження. Автоматичні фоллоу-апи.',
    simplePricing: 'Прості тарифи',
    plansLabel: '// Тарифи',
    perMonth: '/ місяць',
    bookingMgmt: 'Управління бронюваннями',
    caseTracking: 'Відстеження справ',
    calendarSync: 'Синхронізація календаря',
    emailReminders: 'Email-нагадування',
    starterPlan: 'Стартовий',
    startNow: 'Почати зараз →',
    everythingStarter: 'Усе з плану Стартовий',
    aiDocDrafting: 'ШІ-створення документів',
    invoicesPayments: 'Рахунки та платежі',
    clientPortalFeature: 'Клієнтський портал',
    directSupport: 'Пряма підтримка',
    professionalPlan: 'Професійний',
    mostPopular: 'Найпопулярніший',
    everythingPro: 'Усе з плану Про��есійний',
    teamMgmt10: 'Управління командою (10+ юристів)',
    contractAnalysis: 'Аналіз договорів',
    advancedAnalytics: 'Розширена аналітика',
    personalOnboarding: 'Персональний онбординг',
    businessPlan: 'Бізнес',
    spotsLeft: 'Залишилося 3 місця',
    enterpriseNote: 'Enterprise — зв\'яжіться з нами для індивідуальної пропозиції.',
    readyQuestion: 'Готові?',
    first30DaysFree: 'Перші 30 днів безкоштовно. Без контракту. Скасувати можна будь-коли.',
    footerTagline: 'Грузинська юридична SaaS-платформа.',
    productLabel: 'Продукт',
    companyLabel: 'Компанія',
    bookingsLink: 'Бронювання',
    casesLink: 'Справи',
    aiDocsLink: 'ШІ-документи',
    aboutUs: 'Про нас',
    careers: 'Кар\'єра',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'Створено за допомогою Symbols',
    sidebarMain: 'Дашборд',
    sidebarBookings: 'Бронювання',
    sidebarCases: 'Справи',
    sidebarClients: 'Клієнти',
    sidebarDocs: 'Документи',
    sidebarPayments: 'Платежі',
    sidebarLawyers: 'Юристи',
    sidebarSettings: 'Налаштування',
    sidebarLogout: 'Вийти',
    bookingsTitle: 'Бронювання',
    newBooking: '+ Нове бронювання',
    newBookingTitle: 'Нове бронювання',
    clientName: 'Ім\'я клієнта',
    phoneNumber: 'Телефон',
    civilLaw: 'Цивільне',
    criminalLaw2: 'Кримінальне право',
    administrativeLaw: 'Адміністративне',
    otherType: 'Інше',
    notesPlaceholder: 'Примітки...',
    confirmBooking: 'Підтвердити бронювання',
    cancelBtn: 'Скасувати',
    calendarSyncNote: 'Синхронізація календаря — Google Calendar, Outlook, Apple Calendar синхронізуються автоматично',
    synced: 'Синхронізовано',
    calendarSync2: 'Синхронізація календаря',
    syncedStatus: 'Синхронізовано',
    bookingsToday: '3 бронювання сьогодні',
    settingsLink: 'Налаштування →',
    pendingStatus: 'В очікуванні',
    connectionNeeded: 'Потрібне підключення',
    connectLink: 'Підключити →',
    lastSync: 'Остання синхронізація: 5 хв тому',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    bookingDetails: 'Деталі бронювання',
    confirmed: 'Підтверджено',
    pending: 'В очікуванні',
    upcomingBookings: 'Майбутні бронювання',
    closeBtn: 'Закрити',
    selectDateTime: 'Виберіть дату та час',
    fillInfo: 'Заповніть інформацію — ',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    phoneField: 'Телефон',
    emailField: 'Email',
    caseDescription: 'Короткий опис справи',
    confirmBookingPublic: 'Підтвердити бронювання',
    goBack: 'Повернутися',
    bookingConfirmedMsg: 'Бронювання підтверджено!',
    timeLabel: 'Час: ',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Ніно Барателі',
    casesTitle: 'Справи',
    searchPlaceholder2: 'Пошук...',
    newCase: '+ Нова справа',
    allTab: 'Всі',
    activeTab: 'Активні',
    pendingTab: 'В очікуванні',
    closedTab: 'Закриті',
    selectCasePrompt: 'Виберіть справу для перегляду деталей',
    info: 'Інфо',
    registry: 'Реєстр',
    clientInfo: 'Інформація про клієнта',
    chronology: 'Хронологія',
    addNote: 'Додати нотатку',
    enterNote: 'Введіть нотатку...',
    addBtn: 'Додати',
    documentsLabel: 'Документи',
    createBtn: '+ Створити',
    noDocs: 'Немає документів',
    hearingSchedule: 'Розклад засідань',
    caseStatus: 'Статус справи',
    electronicFiling: 'Електронне подання',
    idCode: 'ІД код:',
    director: 'Директор:',
    addressLabel: 'Адреса:',
    statusLabel: 'Статус:',
    registeredProperty: 'Зареєстроване майно',
    extractLabel: 'Витяг',
    recentChanges: 'Останні зміни',
    yourFieldChanges: 'Зміни у вашій сфері',
    newLabel: 'Нове',
    notifications: 'Сповіщення',
    clientsTitle: 'Клієнти',
    clientsSearchPlaceholder: 'Пошук клієнтів...',
    clientsProfile: 'Профіль клієнта',
    clientsContactLabel: 'Контакт',
    clientsInvoiceHistory: 'Історія рахунків',
    clientsUnpaid: 'Неоплачено',
    clientsPaid: 'О��лачено',
    clientsPortalInvite: 'Надіслати доступ до порталу клієнта',
    dashTodayBookings: 'Бронювання на сьогодні',
    dashUnpaid: 'Неоплачено',
    dashOverdue: 'Прострочено',
    dashAiGenerations: 'Генерації ШІ',
    dashTodaysBookings: 'Сьогоднішні бронювання',
    dashConfirmed: 'Підтверджено',
    dashRecentCases: 'Останні справи',
    dashNewBooking: '+ Нове бронювання',
    dashNewCase: '+ Нова справа',
    dashAiDocument: 'ШІ Документ',
    docsTitle: 'Документи',
    docsCreate: 'Створити',
    docsExisting: 'Існуючі документи',
    docsFiles: 'Файли',
    docsOcrScan: 'Сканувати',
    docsOcrTitle: 'OCR Сканування',
    docsUploadText: 'Завантажте фото документа або PDF',
    docsScanning: 'Сканування документа...',
    docsFile: 'Файл',
    docsPages: 'Сторінки',
    docsLanguage: 'Мова',
    docsGeorgian: 'Грузинська',
    docsAddToCase: 'Додати до справи',
    docsCopy: 'Копіювати',
    docsRescan: 'Пересканувати',
    docsClaim: 'Позов',
    docsPowerOfAttorney: 'Довіреність',
    docsNotification: 'Повідомлення',
    docsContractReview: 'Аналіз договору',
    docsFreeForm: 'Вільна форма',
    docsParty1: 'Сторона 1',
    docsNameCompany: 'Ім\'я / Компанія',
    docsParty2: 'Сторона 2',
    docsDate: 'Дата',
    docsAdditionalInfo: 'Додаткова інформація',
    docsGenerating: 'Генерування...',
    docsGenerate: 'Згенерувати',
    docsGeneratedDocument: 'Згенерований документ',
    docsEmptyState: 'Згенерований документ з\'явиться тут',
    docsShowDemo: 'Показати демо-документ',
    docsDownload: 'Завантажити',
    docsSend: 'Надіслати',
    docsCreatedDocuments: 'Створені документи',
    docsSearch: 'Пошук...',
    docsFileManager: 'Файловий менеджер',
    docsUpload: 'Вивантажити',
    docsCases: 'Справи',
    docsTemplates: 'Шаблони',
    docsRecentFiles: 'Останні фа��ли',
    billingTitle: 'Білінг',
    billingNewInvoice: 'Новий рахунок',
    billingTotalSent: 'Всього надіслано',
    billingPaid: 'Оплачено',
    billingUnpaid: 'Неоплачено',
    billingOverdue: 'Прострочено',
    billingActive: 'Активні',
    billingClientStatus: 'Статус клієнта',
    billingEInvoice: 'Е-рахунок',
    billingAutoCheck: 'Автоперевірка',
    billingSettings: 'Налаштування →',
    billingInvoice: 'Рахунок',
    billingClient: 'Клієнт',
    billingCase: 'Справа',
    billingAmount: 'Сума',
    billingDue: 'Термін',
    billingStatus: 'Статус',
    aiTitle: 'AI Асистент',
    aiPowered: 'Powered by AI',
    aiDraftDocs: 'Складання документів',
    aiContractAnalysis: 'Аналіз договорів',
    aiLegalResearch: 'Юридичні дослідження',
    aiDraftAvailable: 'Складання документів доступне на сторінці документів',
    aiGoToDocuments: 'Перейти до документів →',
    aiPasteContract: 'Вставте текст договору сюди...',
    aiAnalyze: 'Аналізувати',
    aiReanalyze: 'Повторний аналіз',
    aiParties: 'Сторони',
    aiObligations: 'Ключові зобов\'язання',
    aiRiskFactors: 'Фактори ризику',
    aiDeadlines: 'Дедлайни',
    aiRecommendations: 'Рекомендації',
    aiAskQuestion: 'Поставте запитання щодо законодавства Грузії',
    aiLegalResearchTitle: 'AI Юридичні дослідження',
    aiAskPlaceholder: 'Поставте запитання...',
    aiSend: 'Надіслати',
    pitchTagline: 'Legal SAAS Грузії',
    pitchSubtitle: 'Бронювання · Операції · AI — для грузинських фірм',
    pitchCta: 'Побачити можливість →',
    pitchMarketLabel: '// Ринок',
    pitchMarketTitle: '5000+ юристів у Грузії',
    pitchPopulation: 'Населення',
    pitchTbilisi: 'Тбілісі',
    pitchConcentrated: 'Концентрований ринок',
    pitchZeroCompetitor: 'Місцевий SaaS конкурент',
    pitchProblemLabel: '// Проблема',
    pitchProblemTitle: 'Грузинські фірми досі працюють у WhatsApp т�� Excel',
    pitchNoBooking: 'Немає системи бронювання клієнтів',
    pitchManualCases: 'Ручне управління справами',
    pitchNoAiTools: 'Немає AI інструментів грузинською',
    pitchCapabilitiesLabel: '// Можливості',
    pitchOnePlatform: 'Одна платформа. Три основи.',
    pitchProductLabel: '// Продукт',
    pitchProductTitle: 'Все в одній платформі',
    pitchIntegrationsLabel: '// Інтеграції',
    pitchIntegrationsTitle: 'Автоматизація, а не ручна робота',
    pitchPublicRegistry: 'Публічний реєстр',
    pitchCalendarSyncTitle: 'Синхронізація календаря',
    pitchOcrTitle: 'OCR та сканування',
    pitchPlansLabel: '// Тарифи',
    pitchPlansTitle: 'Ціноутворення для грузинського ринку',
    pitchTierStarter: 'Starter',
    pitchMostPopular: 'Найпопулярніший',
    pitchTierPro: 'Professional',
    pitchTierBusiness: 'Business',
    pitchTierEnterprise: 'Корпоративний',
    pitchRevenueLabel: '// Дохід',
    pitchRevenueTitle: 'Потенціал доходу',
    pitchFinanceLabel: '// Фінанси',
    pitchFinanceTitle: 'Юніт-економіка',
    pitchTimeLabel: '// Час',
    pitchTimeTitle: 'Слушний час',
    pitchPrivacyLabel: '// Конфіденційність',
    pitchPrivacyTitle: 'Конфіденційність — це пріоритет',
    pitchCtaLabel: '// Будуємо разом',
    pitchCtaTitle: 'Побудуймо правову інфраструктуру Грузії',
    pitchCtaLink: 'Головна сторінка →',
    pitchPerMonth: 'місяць',
    settingsTitle: 'Налаштування',
    settingsTabProfile: 'Профіль',
    settingsTabFirm: 'Фірма',
    settingsTabTeam: 'Команда',
    settingsTabNotifications: 'Сповіщення',
    settingsUploadPhoto: 'Завантажити фото',
    settingsSave: 'Зберегти',
    settingsFirmAddress: 'Адреса',
    settingsFirmRegNumber: 'Реєстраційний номер',
    settingsPublicBookingUrl: 'Публічний URL для бронювання',
    settingsTeamMembers: 'Учасники команди',
    settingsInvite: '+ Запросити',
    settingsRoleOwner: 'Власник',
    settingsRoleLawyer: 'Юрист',
    settingsNotifyTitle: 'Налаштування сповіщень',
    settingsToggleOn: 'Увімкнено',
    settingsToggleOff: 'Вимкнено',
    loginSubtitle: 'Увійдіть до свого акаунта',
    loginLawyer: 'Юрист',
    loginClient: 'Клієнт',
    loginPassword: 'Пароль',
    loginSubmit: 'Увійти →',
    loginCaseNumber: 'Номер справи',
    loginBackLink: '← Назад',
    portalLogout: 'Вийти',
    portalWelcome: 'Вітаємо,',
    portalActiveCases: 'Активні справи',
    portalDocuments: 'Документ��',
    portalMessages: 'Повідомлення',
    portalSend: 'Надіслати',
    clientDashNavCases: 'Справи',
    clientDashNavInvoices: 'Рахунки',
    clientDashNavDocuments: 'Документи',
    clientDashNavMessages: 'Повідомлення',
    clientDashLogout: 'Вийти',
    clientDashWelcome: 'Вітаємо,',
    clientDashDownload: 'Завантажити',
    clientDashSend: 'Надіслати',
    findLawyer: 'Знайти юриста',
    lawyersSearchSub: 'Шукайте серед 5,700+ юристів, зареєстрованих у Georgian Bar Association',
    searchBtn: 'Пошук',
    viewAll: 'Переглянути всі',
    lawyerPortal: 'Портал юриста',
    aiFeature: 'AI',
    aiChip1: 'Скасування нотаріального договору',
    aiChip1Question: 'Які умови скасування нотаріального договору?',
    aiChip2: 'Стаття 317 Цивільного кодексу',
    aiChip2Question: 'Тлумачення статті 317 Цивільного кодексу',
    aiChip3: 'Недійсність правочину',
    aiChip3Question: 'Судова практика щодо недійсності ��равочину за останні 3 роки',
    aiDeadlinesData: '• Початок надання послуг: 10 днів від дати договору\n• Перший платіж: 1 квітня 2026 року\n• Термін дії договору: 12 місяців',
    aiEmptyChatSub: 'AI — Поставте запитання та отримайте відповідь щодо законодавства Грузії',
    aiObligationsData: '1. Надання послуг протягом 30 календарних днів\n2. Оплата протягом 15 робочих днів\n3. Конфіденційність протягом 3 років',
    aiPartiesData: 'Сторона 1: ТОВ Barateli & Partners\nСторона 2: ТОВ Delta Group',
    aiRecommendationsData: '1. Додати пункт про штрафні санкції (ст. 417 Цивільного кодексу)\n2. Визначити вирішення спорів через арбітраж\n3. Розширити пункт про форс-мажор',
    aiRisksData: '• Штраф за прострочення платежу не визначено\n• Механізм вирішення спорів не вказано\n• Пункт про форс-мажор не охоплює пандемію',
    address: 'Адреса',
    addressVal: 'Тбілісі, Чавчавадзе 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'Гіоргі Мамулашвілі',
    billingClient2: 'Маріам Кварацхелія',
    billingClient3: 'Лела Гогіашвілі',
    billingClientName: 'ТОВ Delta Group',
    billingDue1: '25 бер',
    billingDue2: '15 бер',
    billingDue3: '10 бер',
    billingEmailNotification: 'Сповіщення електронною поштою',
    billingLastCheck: 'Остання перевірка: сьогодні',
    billingNoDebt: 'Заборгованість відсутня',
    billingRsBanner: 'Інтеграція з rs.ge — податкова заборгованість клієнта та електронний рахунок-фактура в один клік',
    billingRsTaxSystem: 'rs.ge — Податкова система',
    billingStatusPaid: 'Оплачено',
    billingStatusSent: 'Надіслано',
    billingViewFull: 'Переглянути повністю →',
    billingViewInvoices: 'Переглянути рахунки →',
    billingWeeklyEnabled: 'Щотижнево увімкнено',
    caseRow1Title: '#2024-047 — Гіоргі Мамулашвілі',
    caseRow2Title: '#2024-046 — Маріам Кварацхелія',
    caseRow3Title: '#2024-045 — Лела Гогіашвілі',
    change1Date: '15 березня — Набуває чинності: 1 квітня',
    change1Desc: 'Термін збільшено з 30 до 45 днів',
    change1Name: 'Цивільний кодекс — ст. 316',
    change2Date: '12 березня — Набуває чинності: 1 травня',
    change2Desc: 'Термін апеляції з 14 до 21 дня',
    change2Name: 'Процесуальний кодекс — Терміни',
    claimAccepted: 'Позов прийнято — 17 березня',
    claimFiled: 'Позов подано — 15 березня',
    claimFiledDoc: 'Позов — Подано',
    clientName1: 'Гіоргі Мамулашвілі',
    clientName2: 'Маріам Кварацхелія',
    clientName3: 'Лела Гогіашвілі',
    companyExtractLoaded: 'Виписка компанії — Завантажено',
    companyName: 'ТОВ Delta Group',
    clientsActiveCases1: '1 активна справа',
    clientsActiveCases2: '1 активна справа',
    clientsActiveCases3: '0 активних справ',
    clientsAvatar1: 'ГМ',
    clientsAvatar2: 'МК',
    clientsAvatar3: 'ЛГ',
    clientsCaseLink1: '#2024-047 — Цивільна',
    clientsCaseLink2: '#2024-046 — Адміністративна',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'Немає активних справ',
    clientsPaid1: '₾2,400 оплачено',
    clientsPaid2: '₾800 оплачено',
    clientsPaid3: '₾1,800 оплачено',
    dashAlertText: '2 прострочені справи та ₾1,840 неоплачених рахунків',
    dashBooking1Time: '10:00 — Цивільна',
    dashBooking2Time: '11:30 — Адміністративна',
    dashBooking3Time: '14:00 — Кримінальна',
    dashCaseMeta1: 'Цивільна · 18 бер',
    dashCaseMeta2: 'Адміністративна · 17 бер',
    dashCaseMeta3: 'Кримінальна · 15 бер',
    dashClient3Name: 'Давіт Чіковані',
    dashDate: '18 березня 2026',
    dashGreeting: 'Привіт, Ніно',
    dateMar15: '15 бер',
    dateMar17: '17 бер',
    dateMar18: '18 бер',
    disabledStatus: '— В��мкнено',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: 'Грузія, Тбілісі\n\nПозов\n\nПозивач: ТОВ Barateli & Partners\nВідповідач: ТОВ Delta Group\n\nФактичні обставини:\n\nЦим позовом позивач вимагає від відповідача виконати свої зобов\'язання.\n\nВимога:\n\n1. Зобов\'язати відповідача виплатити 12,500 GEL\n2. Накласти штраф у розмірі 1,875 GEL\n3. Відшкодувати судові витрати\n\nДата: 18 березня 2026\nПідпис: ________________',
    docsDocument: 'Документ',
    docsFile1Meta: 'PDF · 124 KB · 15 бер 2026',
    docsFile1Name: 'Позов - Мамулашвілі.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 бер 2026',
    docsFile2Name: 'Довіреність - Кварацхелія.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 бер 2026',
    docsFile3Name: 'Договір №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 бер 2026',
    docsFile4Name: 'Копія ID - Мамулашвілі.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 бер 2026',
    docsFile5Name: 'Повідомлення - Гогіашвілі.pdf',
    docsFolder1Count: '3 файли',
    docsFolder1Name: '#2024-047 Мамулашвілі',
    docsFolder2Count: '2 файли',
    docsFolder2Name: '#2024-046 Кварацхелія',
    docsFolder3Count: '1 файл',
    docsFolder3Name: '#2024-045 Гогіашвілі',
    docsFolder4Count: '5 файлів',
    docsFormatAnalysis: 'Аналіз формату...',
    docsFreeText: 'Вільний текст...',
    docsGeneratedClaimText: 'Грузія, Тбілісі\n\nПозов\n\nПозивач: [Сторона 1]\nВідповідач: [Сторона 2]\n\nФактичні обставини:\n\nЦим позовом позивач вимагає від відповідача виконати свої зобов\'язання відповідно до Цивільного кодексу Грузії.\n\nПравова основа:\n\nВідповідно до статті 316 Цивільного кодексу, зобов\'язання повинні виконуватися належним чином.\n\nВимога:\n\nВраховуючи вищевикладене, позивач просить суд зобов\'язати відповідача.\n\nДата: 18 березня 2026\nПідпис: ________________',
    docsGeorgianSymbols: 'Грузинські символи',
    docsOcrNote: 'OCR-сканування — автоматичне оцифрування паперових документів, ручне введення не потрібне',
    docsOcrResultText: 'Договір №147\n\nТбілісі, 10 березня 2026 року\n\nЗ однієї сторони, ТОВ «Barateli & Partners» (ІН 404123456) в особі директора Ніно Барателі (надалі «Виконавець»), та з іншої сторони, ТОВ «Delta Group» (ІН 404789012) в особі директора Гіоргі Мамулашвілі (надалі «Клієнт»), уклали цей договір:\n\nСтаття 1. Предмет договору\n1.1. Виконавець зобов\'язується надати Клієнту юридичні послуги.\n1.2. Вартість послуг становить 12 500 (дванадцять тисяч п\'ятсот) GEL.',
    docsOcrSuccess: 'Успішно розпізнан�� — точність 98.5%',
    docsRow1Meta: '#2024-047 · Позов · 15 бер',
    docsRow1Name: 'Позов - Mamulashvili.pdf',
    docsRow2Meta: '#2024-046 · Довіреність · 12 бер',
    docsRow2Name: 'Довіреність - Kvaratskhelia.pdf',
    docsRow3Meta: '#2024-045 · Повідомлення · 8 бер',
    docsRow3Name: 'Повідомлення - Gogiashvili.pdf',
    docsTextRecognition: 'Розпізнавання тексту',
    docsUploadFormats: 'JPG, PNG, PDF — макс. 10MB',
    docsUploadSub: 'Перетягніть файл або натисніть, щоб вибрати',
    ecourt: 'ecourt',
    ecourtDesc: 'Подавайте позови, перевіряйте статус справи та розклад засідань — без візиту до суду',
    enabledStatus: '✓ Увімкнено',
    evidencePending: 'Докази — Очікується',
    extract: 'Витяг',
    field1Text: 'Цивільне: ст. 316 зміна',
    field2Text: 'Цивільне: ст. 259 строки',
    field3Text: 'Адміністративне: е-послуги',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 бер, 10:00 — Тбіліський міський су��',
    hearingItem2: '📅 28 бер, 14:30 — Апеляційний суд',
    loginEmail: 'Email',
    matsne: 'matsne',
    matsneDesc: 'Зміни в законодавстві автоматично — у вашій галузі практики',
    outlook: 'Outlook',
    prepHearing: 'Підготовче засідання — 22 березня',
    propertyApartment: 'Квартира — Ваке, 85 кв.м · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'Витяг на майно — Додано',
    registryDesc: 'Дані про компанії та майно автоматично — більше ніяких завантажень витягів вручну',
    timeEntry1Date: '18 бер, 10:30',
    timeEntry1Text: 'Справу відкрито, первинну консультацію завершено',
    timeEntry2Date: '17 бер, 14:00',
    timeEntry2Text: 'Клієнт надав документацію',
    timeEntry3Date: '15 бер, 09:00',
    timeEntry3Text: 'Клієнт звернувся до фірми, первинна заявка',
    typeCivil: 'Цивільне',
    typeAdministrative: 'Адміністративне',
    typeCriminal: 'Кримінальне',
    pitchArpuMonth: 'Середній ARPU/міс',
    pitchArpuYear: 'Середній ARPU/рік',
    pitchAutoBackup: 'Автоматичне резервне копіювання',
    pitchAutoNextSteps: 'Автоматичні наступні кроки',
    pitchAutoReminder: 'Автоматичне нагадування',
    pitchBooking: 'Бронювання',
    pitchCacOrganic: 'CAC (органічне зростання)',
    pitchCalcNote: '5000 юристів × ₾35/міс у середньому × 12 місяців',
    pitchCalendarSync: 'Синхронізація календаря',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — засідання та дедлайни синхронізуються автоматично',
    pitchCaseManagement: 'Управління справами',
    pitchClientSchedule: 'Розклад клієнта',
    pitchCloudDedicated: 'Виділена хмара',
    pitchCloudDedicatedDesc: 'Ізольований хмарний сервер — ваші дані повністю відокремлені від інших клієнтів',
    pitchContractAnalysis: 'Аналіз договорів',
    pitchCtaSubtext: 'Бронювання + Операції + AI',
    pitchDedicatedServer: 'Виділений сервер',
    pitchDocDraftGeo: 'Складання документів грузинською',
    pitchEcourtDesc: 'Подавайте позови, статус справи та розклад засідань — без візиту до суду',
    pitchGdprCompliant: 'Відповідає вимогам GDPR',
    pitchHybrid: 'Гібридний',
    pitchHybridDesc: 'Хмара + локально — конфіденційні дані локально, решта у хмарі',
    pitchIntegrationsSub: 'Державні сервіси, календарі та OCR — з однієї платформи',
    pitchInvoices: 'Рахунки',
    pitchMatsneDesc: 'Зміни в законодавстві автоматично — у вашій галузі практики',
    pitchOcrDesc: 'Автоматичне оцифрування паперових документів — без ручного введення',
    pitchOnPremise: 'Локальний сервер (On-Premise)',
    pitchOnPremiseDesc: 'Повністю локально — дані залишаються у вашому офісі, без доступу до інтернету',
    pitchOperations: 'Операції',
    pitchPerkAiDocs: 'AI Документи',
    pitchPerkBookings: 'Управління бронюваннями',
    pitchPerkClientPortal: 'Клієнтський портал',
    pitchPerkCommunication: 'Комунікація',
    pitchPerkFileStorage: 'Зберігання файлів',
    pitchPerkResponsive: 'Адаптивність',
    pitchPrivacySubtitle: 'Юридичні дані потребують максимального захисту',
    pitchPublicRegistryDesc: 'Дані про компанії та майно автоматично — без завантажень витягів вручну',
    pitchRateNote: '1 USD = 2.73 GEL — Березень 2026',
    pitchRecurringModel: 'Рекурентна модель',
    pitchRsGeDesc: 'Податковий борг та е-рахунки — статус клієнта в один клік',
    pitchScen250: '250 юристів',
    pitchScen500: '500 юристів',
    pitchScen1000: '1000 юристів',
    pitchServerCost: 'Вартість сервера/користувач',
    pitchTierBusiness10: '10+ юристів',
    pitchTierEnterpriseCustom: 'Індивідуальний',
    pitchTierEnterprisePrice: 'За запитом',
    pitchTierPro310: '3-10 юристів',
    pitchTierStarter12: '1-2 юристи',
    pitchTitle: 'TrustLegal для Грузії',
    pitchTrustedAccounting: 'Надійний облік',
    pitchWhyAiCheap: 'Інструменти ШІ тепер достатньо доступні',
    pitchWhyDigitizing: 'Грузинський юридичний ринок швидко цифровізується',
    pitchWhyNoCompetitor: 'Немає визнаних конкурентів',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'Ніно Барателі',
    settingsMember2Name: 'Гіга Асланішвілі',
    settingsNotifyDeadlineReminder: 'Нагадування про дедлайн',
    settingsNotifyNewBookingEmail: 'Нове бронювання — Email',
    settingsNotifyNewBookingWhatsapp: 'Нове бронювання — WhatsApp',
    settingsNotifyOverdueInvoice: 'Прострочений рахунок',
    settingsNotifyReminder24h: 'Нагадування за 24 год',
    settingsProfileName: 'Ніно Барателі',
    settingsToggle3DaysBefore: 'За 3 дні',
    portalCaseTypeCivil: 'Цивільна',
    portalDocDate1: '15 бер',
    portalDocName1: 'Позов - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: 'Оплатити до: 25 бер',
    portalLastUpdate: 'Останнє оновлення: 18 бер',
    portalMsgFrom1: 'Ніно Барателі',
    portalMsgPlaceholder: 'Надіслати повідомлення...',
    portalMsgText1: 'Вітаю, Гіоргі, у нас є нове оновлення у справі.',
    portalMsgText2: 'Дякую, чекаю на деталі.',
    portalNextHearing: 'Судове засідання 25 березня',
    portalPay: 'Оплатити',
    portalPendingInvoices: 'Неоплачені рахунки',
    portalProgressLabel: 'Прогрес: 3/5 кроків',
    portalStatusActive: 'Активна',
    clientDashCaseTypeCivil: 'Цивільна',
    clientDashDocMeta1: 'Справа #2024-047 · 15 бер',
    clientDashDocMeta2: 'Справа #2024-046 · 12 бер',
    clientDashDocName1: 'Позов - Mamulashvili.pdf',
    clientDashDocName2: 'Довіреність - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: 'Документи',
    clientDashInvCase1: 'Справа: #2024-047',
    clientDashInvCase2: 'Справа: #2024-046',
    clientDashInvDue1: 'Оплатити до: 25 березня 2026',
    clientDashInvoicesTitle: 'Рахунки',
    clientDashInvPaidDate: 'Оплачено: 14 березня 2026',
    clientDashLawyerInitials: 'НБ',
    clientDashLawyerName: 'Ніно Барателі',
    clientDashLawyerRole: 'Ваш юрист',
    clientDashMessagesTitle: 'Повідомлення',
    clientDashMsgFrom1: 'Ніно Барателі',
    clientDashMsgFrom3: 'Ніно Ба��ателі',
    clientDashMsgPlaceholder: 'Написати повідомлення...',
    clientDashMsgText1: 'Вітаю, Гіоргі, у нас є оновлення у справі. Суд призначив засідання на 25 березня.',
    clientDashMsgText2: 'Дякую, чекаю на деталі. Чи потрібно мені підготувати якісь документи?',
    clientDashMsgText3: 'Ні, все готово. Зв\'яжуся з вами за тиждень до засідання.',
    clientDashMsgTime1: '10:30 · Сьогодні',
    clientDashMsgTime2: '10:45 · Сьогодні',
    clientDashMsgTime3: '11:02 · Сьогодні',
    clientDashMyCases: 'Мої справи',
    clientDashPaid: 'Оплачено',
    clientDashPay: 'Оплатити',
    clientDashProgressLabel: 'Прогрес: 3/5 кроків завершено',
    clientDashStatActiveCase: 'Активна справа',
    clientDashStatDocument: 'Документ',
    clientDashStatNextHearing: 'Наступне засідання',
    clientDashStatNextHearingValue: '25 бер',
    clientDashStatPayable: 'До оплати',
    clientDashStatusActive: 'Активна',
    clientDashStep1Date: '5 бер 2026',
    clientDashStep1Title: 'Консультацію завершено',
    clientDashStep2Date: '10 бер 2026',
    clientDashStep2Title: 'Позов складено',
    clientDashStep3Date: '15 бер 2026',
    clientDashStep3Title: 'Позов подано до суду',
    clientDashStep4Date: '25 бер 2026 — Очікується',
    clientDashStep4Title: 'Судове засідання',
    clientDashStep5Title: 'Рішення',
    clientDashUnpaid: 'Неоплачено',
    clientDashWelcomeSub: 'Тут ви можете відстежувати свої справи, рахунки та документи.',
  },

  tr: {
    home: 'Ana Sayfa',
    dashboard: 'Panel',
    bookings: 'Randevular',
    bookingPage: 'Randevu Sayfası',
    aiDocuments: 'AI Belgeleri',
    clientPortalNav: 'Müvekkil Portalı',
    lawyersNav: 'Avukatlar',
    login: 'Giriş Yap',
    getStarted: 'Ücretsiz Başla',
    lawyersTitle: 'Avukatlar ve Hukuk Büroları',
    lawyersSubtitle: 'Gürcistan\'da kayıtlı',
    searchPlaceholder: 'İsim, büro veya uzmanlık alanına göre ara...',
    lawyersBtn: 'Avukatlar',
    firmsBtn: 'Bürolar',
    allFilter: 'Tümü',
    corporateLaw: 'Şirketler Hukuku',
    criminalLaw: 'Ceza Hukuku',
    familyLaw: 'Aile Hukuku',
    realEstate: 'Gayrimenkul Hukuku',
    taxLaw: 'Vergi Hukuku',
    ipLaw: 'Fikri Mülkiyet',
    immigration: 'Göçmenlik',
    laborLaw: 'İş Hukuku',
    bankingFinance: 'Bankacılık ve Finans',
    firmsMatch: 'eşleşen büro',
    lawyersMatch: 'eşleşen avukat',
    reviews: 'değerlendirme',
    loadingMore: 'Daha fazla yükleniyor...',
    independent: 'Bağımsız',
    yearsExperience: 'yıllık deneyim',
    languages: 'Diller',
    backToDirectory: '← Rehbere dön',
    about: 'Hakkında',
    bookConsultation: 'Randevu Al',
    sendMessage: 'Mesaj Gönder',
    call: 'Ara',
    reviewsRatings: 'Değerlendirmeler ve Puanlar',
    reviewsComingSoon: 'Değerlendirmeler yakında. İlk değerlendiren siz olun.',
    barId: 'Baro Sicil No',
    ourTeam: 'Ekibimiz',
    contact: 'İletişim',
    website: 'Web Sitesi',
    established: 'Kur.',
    lawyersCount: 'avukat',
    georgian: 'Gürcüce',
    english: 'İngilizce',
    russian: 'Rusça',
    german: 'Almanca',
    french: 'Fransızca',
    turkish: 'Türkçe',
    heroLine1: 'Hukuk',
    heroLine2: 'ekibiniz. Tek',
    heroLine3: 'platform.',
    heroSubtitle: 'TrustLegal — Gürcistan hukuk büroları için randevular, davalar, ödemeler ve AI belge taslağı oluşturma. Tek aylık ücret, sözleşme yok.',
    tryFree: '��cretsiz Dene →',
    liveDemo: 'Canlı Demo',
    trustedBrands: 'Kaliteye önem veren markalar bizimle çalışıyor',
    howItWorks: 'Nasıl çalışır',
    processLabel: '// Süreç',
    step1Title: 'Kayıt ol',
    step1Desc: 'Hesap oluşturun ve bir plan seçin. Kredi kartı gerekmez — ilk 30 gün ücretsiz.',
    step2Title: 'Davaları yönet',
    step2Desc: 'Müvekkilleri, davaları ve randevuları ekleyin. Otomatik hatırlatıcılar ve takvim senkronizasyonu.',
    step3Title: 'AI ile taslak oluştur',
    step3Desc: 'Gürcüce AI destekli belge taslağı oluşturma. Dilekçeler, vekaletnameler, sözleşme analizi.',
    step4Title: 'Büyü',
    step4Desc: 'Faturaları, gelirleri ve ekip verimliliğini takip edin. Gerçek zamanlı analizler.',
    demoBadge: '// Canlı Demo',
    todaysBookings: 'Bugünün randevuları',
    fullDemo: 'Tam demo →',
    onePlatformThreePillars: 'Tek platform.\nÜç temel yapı.',
    capabilitiesLabel: '// Yetenekler',
    bookingFeature: 'Randevu',
    bookingFeatureDesc: 'Müvekkiller kendi zamanlarını seçer. Otomatik hatırlatıcılar. Takvim senkronizasyonu. Herkese açık randevu sayfası.',
    operationsFeature: 'Operasyonlar',
    operationsFeatureDesc: 'Merkezi dava yönetimi. Müvekkil portalı. Faturalar ve ödemeler. Ekip yönetimi.',
    aiFeatureDesc: 'Gürcüce belge taslağı oluşturma. Sözleşme analizi. Hukuki araştırma. Otomatik takip.',
    simplePricing: 'Basit fiyatlandırma',
    plansLabel: '// Planlar',
    perMonth: '/ ay',
    bookingMgmt: 'Randevu yönetimi',
    caseTracking: 'Dava takibi',
    calendarSync: 'Takvim senkronizasyonu',
    emailReminders: 'E-posta hatırlatıcıları',
    starterPlan: 'Başlangıç',
    startNow: 'Hemen başla →',
    everythingStarter: 'Başlangıç planındaki her şey',
    aiDocDrafting: 'Yapay zeka belge taslağı',
    invoicesPayments: 'Faturalar ve ödemeler',
    clientPortalFeature: 'Müvekkil portalı',
    directSupport: 'Doğrudan destek',
    professionalPlan: 'Profesyonel',
    mostPopular: 'En popüler',
    everythingPro: 'Profesyonel planındaki her şey',
    teamMgmt10: 'Ekip yönetimi (10+ avukat)',
    contractAnalysis: 'Sözleşme analizi',
    advancedAnalytics: 'Gelişmiş analitik',
    personalOnboarding: 'Kişisel oryantasyon',
    businessPlan: 'İşletme',
    spotsLeft: '3 yer kaldı',
    enterpriseNote: 'Kurumsal — özel bir teklif için bizimle iletişime geçin.',
    readyQuestion: 'Hazır mısınız?',
    first30DaysFree: 'İlk 30 gün ücretsiz. Sözleşme yok. İstediğiniz zaman iptal edin.',
    footerTagline: 'Gürcü hukuki SaaS platformu.',
    productLabel: 'Ürün',
    companyLabel: 'Şirket',
    bookingsLink: 'Randevular',
    casesLink: 'Davalar',
    aiDocsLink: 'Yapay Zeka Belgeleri',
    aboutUs: 'Hakkımızda',
    careers: 'Kariyer',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'Symbols ile oluşturuldu',
    sidebarMain: 'Kontrol Paneli',
    sidebarBookings: 'Randevular',
    sidebarCases: 'Davalar',
    sidebarClients: 'Müvekkiller',
    sidebarDocs: 'Belgeler',
    sidebarPayments: 'Ödemeler',
    sidebarLawyers: 'Avukatlar',
    sidebarSettings: 'Ayarlar',
    sidebarLogout: 'Çıkış yap',
    bookingsTitle: 'Randevular',
    newBooking: '+ Yeni Randevu',
    newBookingTitle: 'Yeni Randevu',
    clientName: 'Müvekkil adı',
    phoneNumber: 'Telefon',
    civilLaw: 'Medeni',
    criminalLaw2: 'Ceza Hukuku',
    administrativeLaw: 'İdare',
    otherType: 'Diğer',
    notesPlaceholder: 'Notlar...',
    confirmBooking: 'Randevuyu Onayla',
    cancelBtn: 'İptal',
    calendarSyncNote: 'Takvim senkronizasyonu — Google Calendar, Outlook, Apple Calendar otomatik olarak senkronize edilir',
    synced: 'Senkronize edildi',
    calendarSync2: 'Takvim Senkronizasyonu',
    syncedStatus: 'Senkronize',
    bookingsToday: 'Bugün 3 randevu',
    settingsLink: 'Ayarlar →',
    pendingStatus: 'Bekliyor',
    connectionNeeded: 'Bağlantı gerekli',
    connectLink: 'Bağlan →',
    lastSync: 'Son senkronizasyon: 5 dk önce',
    mon: 'Pzt',
    tue: 'Sal',
    wed: 'Çar',
    thu: 'Per',
    fri: 'Cum',
    bookingDetails: 'Randevu Detayları',
    confirmed: 'Onaylandı',
    pending: 'Bekliyor',
    upcomingBookings: 'Yaklaşan Randevular',
    closeBtn: 'Kapat',
    selectDateTime: 'Tarih ve saat seçin',
    fillInfo: 'Bilgileri doldurun — ',
    firstName: 'Ad',
    lastName: 'Soyad',
    phoneField: 'Telefon',
    emailField: 'E-posta',
    caseDescription: 'Kısa dava açıklaması',
    confirmBookingPublic: 'Randevuyu Onayla',
    goBack: 'Geri dön',
    bookingConfirmedMsg: 'Randevu onaylandı!',
    timeLabel: 'Saat: ',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Nino Barateli',
    casesTitle: 'Davalar',
    searchPlaceholder2: 'Ara...',
    newCase: '+ Yeni Dava',
    allTab: 'Tümü',
    activeTab: 'Aktif',
    pendingTab: 'Bekleyen',
    closedTab: 'Kapalı',
    selectCasePrompt: 'Ayrıntıları görmek için bir dava seçin',
    info: 'Bilgi',
    registry: 'Sicil',
    clientInfo: 'Müvekkil Bilgileri',
    chronology: 'Kronoloji',
    addNote: 'Not ekle',
    enterNote: 'Bir not girin...',
    addBtn: 'Ekle',
    documentsLabel: 'Belgeler',
    createBtn: '+ Oluştur',
    noDocs: 'Belge yok',
    hearingSchedule: 'Duruşma Takvimi',
    caseStatus: 'Dava Durumu',
    electronicFiling: 'Elektronik Dosyalama',
    idCode: 'Kimlik Kodu:',
    director: 'Yönetici:',
    addressLabel: 'Adres:',
    statusLabel: 'Durum:',
    registeredProperty: 'Kayıtlı Mülk',
    extractLabel: 'Özet',
    recentChanges: 'Son Değişiklikler',
    yourFieldChanges: 'Alanınızdaki değişiklikler',
    newLabel: 'Yeni',
    notifications: 'Bildirimler',
    clientsTitle: 'Müvekkiller',
    clientsSearchPlaceholder: 'Müvekkil ara...',
    clientsProfile: 'Müvekkil Profili',
    clientsContactLabel: 'İletişim',
    clientsInvoiceHistory: 'Fatura Geçmişi',
    clientsUnpaid: 'Ödenmemiş',
    clientsPaid: 'Ödendi',
    clientsPortalInvite: 'Müvekkil portalı erişimi gönder',
    dashTodayBookings: 'Bugünkü randevular',
    dashUnpaid: 'Ödenmemiş',
    dashOverdue: 'Gecikmiş',
    dashAiGenerations: 'AI üretimleri',
    dashTodaysBookings: 'Bugünün randevuları',
    dashConfirmed: 'Onaylandı',
    dashRecentCases: 'Son davalar',
    dashNewBooking: '+ Yeni Randevu',
    dashNewCase: '+ Yeni Dava',
    dashAiDocument: 'AI Belgesi',
    docsTitle: 'Belgeler',
    docsCreate: 'Oluştur',
    docsExisting: 'Mevcut Belgeler',
    docsFiles: 'Dosyalar',
    docsOcrScan: 'Tara',
    docsOcrTitle: 'OCR Taraması',
    docsUploadText: 'Bir belge fotoğrafı veya PDF yükleyin',
    docsScanning: 'Belge taranıyor...',
    docsFile: 'Dosya',
    docsPages: 'Sayfalar',
    docsLanguage: 'Dil',
    docsGeorgian: 'Gürcüce',
    docsAddToCase: 'Davaya ekle',
    docsCopy: 'Kopyala',
    docsRescan: 'Yeniden tara',
    docsClaim: 'Talep',
    docsPowerOfAttorney: 'Vekaletname',
    docsNotification: 'Bildirim',
    docsContractReview: 'Sözleşme İncelemesi',
    docsFreeForm: 'Serbest Form',
    docsParty1: 'Taraf 1',
    docsNameCompany: 'İsim / Şirket',
    docsParty2: 'Taraf 2',
    docsDate: 'Tarih',
    docsAdditionalInfo: 'Ek Bilgiler',
    docsGenerating: 'Oluşturuluyor...',
    docsGenerate: 'Oluştur',
    docsGeneratedDocument: 'Oluşturulan Belge',
    docsEmptyState: 'Oluşturulan belge burada görünecek',
    docsShowDemo: 'Demo belgeyi göster',
    docsDownload: 'İndir',
    docsSend: 'Gönder',
    docsCreatedDocuments: 'Oluşturulan Belgeler',
    docsSearch: 'Ara...',
    docsFileManager: 'Dosya Yöneticisi',
    docsUpload: 'Yükle',
    docsCases: 'Davalar',
    docsTemplates: 'Şablonlar',
    docsRecentFiles: 'Son Dosyalar',
    billingTitle: 'Faturalandırma',
    billingNewInvoice: 'Yeni Fatura',
    billingTotalSent: 'Toplam Gönderilen',
    billingPaid: 'Ödendi',
    billingUnpaid: 'Ödenmedi',
    billingOverdue: 'Gecikmiş',
    billingActive: 'Aktif',
    billingClientStatus: 'Müvekkil Durumu',
    billingEInvoice: 'e-Fatura',
    billingAutoCheck: 'Otomatik kontrol',
    billingSettings: 'Ayarlar →',
    billingInvoice: 'Fatura',
    billingClient: 'Müvekkil',
    billingCase: 'Dava',
    billingAmount: 'Tutar',
    billingDue: 'Vade',
    billingStatus: 'Durum',
    aiTitle: 'AI Asistanı',
    aiPowered: 'AI Destekli',
    aiDraftDocs: 'Belge Hazırlama',
    aiContractAnalysis: 'Sözleşme Analizi',
    aiLegalResearch: 'Hukuki Araştırma',
    aiDraftAvailable: 'Belge hazırlama belgeler sayfasında mevcuttur',
    aiGoToDocuments: 'Belgelere git →',
    aiPasteContract: 'Sözleşme metnini buraya yapıştırın...',
    aiAnalyze: 'Analiz Et',
    aiReanalyze: 'Yeniden Analiz Et',
    aiParties: 'Taraflar',
    aiObligations: 'Temel Yükümlülükler',
    aiRiskFactors: 'Risk Faktörleri',
    aiDeadlines: 'Son Tarihler',
    aiRecommendations: 'Öneriler',
    aiAskQuestion: 'Gürcistan hukuku hakkında bir soru sorun',
    aiLegalResearchTitle: 'AI Hukuki Araştırma',
    aiAskPlaceholder: 'Bir soru sorun...',
    aiSend: 'Gönder',
    pitchTagline: 'Gürcistan\'ın Hukuk SAAS\'ı',
    pitchSubtitle: 'Randevu · Operasyonlar · AI — Gürcü firmalar için',
    pitchCta: 'Fırsatı görün →',
    pitchMarketLabel: '// Pazar',
    pitchMarketTitle: 'Gürcistan\'da 5000+ avukat',
    pitchPopulation: 'Nüfus',
    pitchTbilisi: 'Tiflis',
    pitchConcentrated: 'Yoğunlaşmış pazar',
    pitchZeroCompetitor: 'Yerel SaaS rakibi',
    pitchProblemLabel: '// Problem',
    pitchProblemTitle: 'Gürcü firmalar hala WhatsApp ve Excel ile çalışıyor',
    pitchNoBooking: 'Müvekkil randevu sistemi yok',
    pitchManualCases: 'Manuel dava yönetimi',
    pitchNoAiTools: 'Gürcüce AI araçları yok',
    pitchCapabilitiesLabel: '// Yetenekler',
    pitchOnePlatform: 'Tek platform. Üç temel yapı.',
    pitchProductLabel: '// Ürün',
    pitchProductTitle: 'Her şey tek bir platformda',
    pitchIntegrationsLabel: '// Entegrasyonlar',
    pitchIntegrationsTitle: 'Manuel iş değil, otomasyon',
    pitchPublicRegistry: 'Kamu Sicili',
    pitchCalendarSyncTitle: 'Takvim Senkronizasyonu',
    pitchOcrTitle: 'OCR & Tarama',
    pitchPlansLabel: '// Planlar',
    pitchPlansTitle: 'Gürcistan pazarı için fiyatlandırma',
    pitchTierStarter: 'Başlangıç',
    pitchMostPopular: 'En Popüler',
    pitchTierPro: 'Profesyonel',
    pitchTierBusiness: 'Kurumsal',
    pitchTierEnterprise: 'Kurumsal',
    pitchRevenueLabel: '// Gelir',
    pitchRevenueTitle: 'Gelir Potansiyeli',
    pitchFinanceLabel: '// Finans',
    pitchFinanceTitle: 'Birim Ekonomisi',
    pitchTimeLabel: '// Zamanlama',
    pitchTimeTitle: 'Zamanlama doğru',
    pitchPrivacyLabel: '// Gizlilik',
    pitchPrivacyTitle: 'Gizlilik bir önceliktir',
    pitchCtaLabel: '// Birlikte İnşa Edelim',
    pitchCtaTitle: 'Gürcistan\'ın yasal altyapısını inşa edelim',
    pitchCtaLink: 'Ana sayfa →',
    pitchPerMonth: 'ay',
    settingsTitle: 'Ayarlar',
    settingsTabProfile: 'Profil',
    settingsTabFirm: 'Firma',
    settingsTabTeam: 'Ekip',
    settingsTabNotifications: 'Bildirimler',
    settingsUploadPhoto: 'Fotoğraf Yükle',
    settingsSave: 'Kaydet',
    settingsFirmAddress: 'Adres',
    settingsFirmRegNumber: 'Sicil Numarası',
    settingsPublicBookingUrl: 'Herkese Açık Rezervasyon URL\'si',
    settingsTeamMembers: 'Ekip Üyeleri',
    settingsInvite: '+ Davet Et',
    settingsRoleOwner: 'Sahip',
    settingsRoleLawyer: 'Avukat',
    settingsNotifyTitle: 'Bildirim Ayarları',
    settingsToggleOn: 'Etkin',
    settingsToggleOff: 'Devre Dışı',
    loginSubtitle: 'Hesabınıza giriş yapın',
    loginLawyer: 'Avukat',
    loginClient: 'Müvekkil',
    loginPassword: 'Şifre',
    loginSubmit: 'Giriş yap →',
    loginCaseNumber: 'Dosya Numarası',
    loginBackLink: '← Geri dön',
    portalLogout: 'Çıkış yap',
    portalWelcome: 'Merhaba,',
    portalActiveCases: 'Aktif Davalar',
    portalDocuments: 'Belgeler',
    portalMessages: 'Mesajlar',
    portalSend: 'Gönder',
    clientDashNavCases: 'Davalar',
    clientDashNavInvoices: 'Faturalar',
    clientDashNavDocuments: 'Belgeler',
    clientDashNavMessages: 'Mesajlar',
    clientDashLogout: 'Çıkış yap',
    clientDashWelcome: 'Merhaba,',
    clientDashDownload: 'İndir',
    clientDashSend: 'Gönder',
    findLawyer: 'Avukat Bul',
    lawyersSearchSub: 'Georgian Bar Association\'a kayıtlı 5.700+ avukat arasında arama yapın',
    searchBtn: 'Ara',
    viewAll: 'Tümünü gör',
    lawyerPortal: 'Avukat Portalı',
    aiFeature: 'AI',
    aiChip1: 'Noter sözleşmesi iptali',
    aiChip1Question: 'Bir noter sözleşmesini iptal etmenin şartları nelerdir?',
    aiChip2: 'Medeni Kanun Madde 317',
    aiChip2Question: 'Medeni Kanun Madde 317\'nin yorumlanması',
    aiChip3: 'İşlem geçersizliği',
    aiChip3Question: 'Son 3 yılda işlem geçersizliği üzerine mahkeme uygulaması',
    aiDeadlinesData: '• Hizmet başlangıcı: Sözleşmeden itibaren 10 gün\n• İlk ödeme: 1 Nisan 2026\n• Sözleşme süresi: 12 ay',
    aiEmptyChatSub: 'AI — Gürcistan hukuku hakkında bir soru sorun ve cevap alın',
    aiObligationsData: '1. 30 takvim günü içinde hizmet teslimi\n2. 15 iş günü içinde ödeme\n3. 3 yıl boyunca gizlilik',
    aiPartiesData: 'Taraf 1: Barateli & Partners LLC\nTaraf 2: Delta Group LLC',
    aiRecommendationsData: '1. Ceza şartı ekleyin (Medeni Kanun Mad. 417)\n2. Tahkim yoluyla uyuşmazlık çözümünü tanımlayın\n3. Mücbir sebep maddesini genişletin',
    aiRisksData: '• Gecikme cezası tanımlanmamış\n• Uyuşmazlık çözüm mekanizması belirtilmemiş\n�� Mücbir sebep maddesi pandemiyi kapsamıyor',
    address: 'Adres',
    addressVal: 'Tiflis, Chavchavadze 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'Giorgi Mamulashvili',
    billingClient2: 'Mariam Kvaratskhelia',
    billingClient3: 'Lela Gogiashvili',
    billingClientName: 'Delta Group LLC',
    billingDue1: '25 Mar',
    billingDue2: '15 Mar',
    billingDue3: '10 Mar',
    billingEmailNotification: 'E-posta bildirimi',
    billingLastCheck: 'Son kontrol: bugün',
    billingNoDebt: 'Ödenmemiş borç yok',
    billingRsBanner: 'rs.ge entegrasyonu — tek tıkla müşteri vergi borcu ve e-fatura',
    billingRsTaxSystem: 'rs.ge — Vergi Sistemi',
    billingStatusPaid: 'Ödendi',
    billingStatusSent: 'Gönderildi',
    billingViewFull: 'Tamamını görüntüle →',
    billingViewInvoices: 'Faturaları görüntüle →',
    billingWeeklyEnabled: 'Haftalık etkin',
    caseRow1Title: '#2024-047 — Giorgi Mamulashvili',
    caseRow2Title: '#2024-046 — Mariam Kvaratskhelia',
    caseRow3Title: '#2024-045 — Lela Gogiashvili',
    change1Date: '15 Mart — Yürürlük: 1 Nisan',
    change1Desc: 'Süre 30 günden 45 güne çıkarıldı',
    change1Name: 'Medeni Kanun — Madde 316',
    change2Date: '12 Mart — Yürürlük: 1 Mayıs',
    change2Desc: 'İtiraz süresi 14 günden 21 güne çıkarıldı',
    change2Name: 'Usul Kanunu — Süreler',
    claimAccepted: 'Dava kabul edildi — 17 Mart',
    claimFiled: 'Dava açıldı — 15 Mart',
    claimFiledDoc: 'Dava — Açıldı',
    clientName1: 'Giorgi Mamulashvili',
    clientName2: 'Mariam Kvaratskhelia',
    clientName3: 'Lela Gogiashvili',
    companyExtractLoaded: 'Şirket sicil özeti — Yüklendi',
    companyName: 'Delta Group LLC',
    clientsActiveCases1: '1 aktif dava',
    clientsActiveCases2: '1 aktif dava',
    clientsActiveCases3: '0 aktif dava',
    clientsAvatar1: 'GM',
    clientsAvatar2: 'MK',
    clientsAvatar3: 'LG',
    clientsCaseLink1: '#2024-047 — Hukuk',
    clientsCaseLink2: '#2024-046 — İdare',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'Aktif dava yok',
    clientsPaid1: '₾2,400 ödendi',
    clientsPaid2: '₾800 ödendi',
    clientsPaid3: '₾1,800 ödendi',
    dashAlertText: '2 gecikmiş dava ve ₾1,840 ödenmemiş fatura',
    dashBooking1Time: '10:00 — Hukuk',
    dashBooking2Time: '11:30 — İdare',
    dashBooking3Time: '14:00 — Ceza',
    dashCaseMeta1: 'Hukuk · 18 Mart',
    dashCaseMeta2: 'İdare · 17 Mart',
    dashCaseMeta3: 'Ceza · 15 Mart',
    dashClient3Name: 'Davit Chikovani',
    dashDate: '18 Mart 2026',
    dashGreeting: 'Merhaba, Nino',
    dateMar15: '15 Mart',
    dateMar17: '17 Mart',
    dateMar18: '18 Mart',
    disabledStatus: '— Devre dışı',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: 'Gürcistan, Tiflis\n\nDava Dilekçesi\n\nDavacı: Barateli & Partners LLC\nDavalı: Delta Group LLC\n\nMaddi Vakıalar:\n\nBu dava ile davacı, davalının yükümlülüklerini yerine getirmesini talep etmektedir.\n\nTalep:\n\n1. Davalının 12,500 GEL ödemeye mahkum edilmesi\n2. 1,875 GEL ceza uygulanması\n3. Mahkeme masraflarının karşılanması\n\nTarih: 18 Mart 2026\nİmza: ________________',
    docsDocument: 'Belge',
    docsFile1Meta: 'PDF · 124 KB · 15 Mart 2026',
    docsFile1Name: 'Dava Dilekçesi - Mamulashvili.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 Mart 2026',
    docsFile2Name: 'Vekaletname - Kvaratskhelia.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 Mart 2026',
    docsFile3Name: 'Sözleşme №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 Mart 2026',
    docsFile4Name: 'Kimlik Fotokopisi - Mamulashvili.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 Mart 2026',
    docsFile5Name: 'Bildirim - Gogiashvili.pdf',
    docsFolder1Count: '3 dosya',
    docsFolder1Name: '#2024-047 Mamulashvili',
    docsFolder2Count: '2 dosya',
    docsFolder2Name: '#2024-046 Kvaratskhelia',
    docsFolder3Count: '1 dosya',
    docsFolder3Name: '#2024-045 Gogiashvili',
    docsFolder4Count: '5 dosya',
    docsFormatAnalysis: 'Format analizi...',
    docsFreeText: 'Serbest metin...',
    docsGeneratedClaimText: 'Gürcistan, Tiflis\n\nDava Dilekçesi\n\nDavacı: [Taraf 1]\nDavalı: [Taraf 2]\n\nMaddi Vakıalar:\n\nBu dava ile davacı, davalının Gürcistan Medeni Kanunu kapsamındaki yükümlülüklerini yerine getirmesini talep etmektedir.\n\nHukuki Dayanak:\n\nMedeni Kanun\'un 316. Maddesi uyarınca, yükümlülükler usulüne uygun olarak yerine getirilmelidir.\n\nTalep:\n\nYukarıdakiler göz önüne alınarak, davacı mahkemeden davalıyı yükümlü kılmasını talep etmektedir.\n\nTarih: 18 Mart 2026\nİmza: ________________',
    docsGeorgianSymbols: 'Gürcüce karakterler',
    docsOcrNote: 'OCR Tarama — kağıt belgelerin otomatik dijitalleştirilmesi, manuel yazmaya gerek yok',
    docsOcrResultText: 'Sözleşme №147\n\nTiflis, 10 Mart 2026\n\nBir tarafta, yönetici Nino Barateli tarafından temsil edilen Barateli & Partners LLC (Kimlik 404123456) (bundan böyle "Yüklenici" olarak anılacaktır) ve diğer tarafta, yönetici Giorgi Mamulashvili tarafından temsil edilen Delta Group LLC (Kimlik 404789012) (bundan böyle "Müşteri" olarak anılacaktır) arasında bu sözleşme akdedilmiştir:\n\nMadde 1. Sözleşmenin Konusu\n1.1. Yüklenici, Müşteriye hukuki hizmetler sunmayı taahhüt eder.\n1.2. Hizmet bedeli 12.500 (on iki bin beş yüz) GEL\'dir.',
    docsOcrSuccess: 'Başarıyla tanındı — %98.5 doğruluk',
    docsRow1Meta: '#2024-047 · Dava Dilekçesi · 15 Mar',
    docsRow1Name: 'Dava Dilekçesi - Mamulashvili.pdf',
    docsRow2Meta: '#2024-046 · Vekaletname · 12 Mar',
    docsRow2Name: 'Vekaletname - Kvaratskhelia.pdf',
    docsRow3Meta: '#2024-045 · Tebligat · 8 Mar',
    docsRow3Name: 'Tebligat - Gogiashvili.pdf',
    docsTextRecognition: 'Metin tanıma',
    docsUploadFormats: 'JPG, PNG, PDF — maks 10MB',
    docsUploadSub: 'Bir dosyayı sürükleyin veya seçmek için tıklayın',
    ecourt: 'ecourt',
    ecourtDesc: 'Dava açın, dava durumunu ve duruşma takvimini kontrol edin — mahkemeye gitmeden',
    enabledStatus: '✓ Etkin',
    evidencePending: 'Delil — Bekliyor',
    extract: 'Kayıt Özeti',
    field1Text: 'Hukuk: Madde 316 değişikliği',
    field2Text: 'Hukuk: Madde 259 süreleri',
    field3Text: 'İdare: e-tebligat',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 Mar, 10:00 — Tiflis Şehir Mahkemesi',
    hearingItem2: '📅 28 Mar, 14:30 — Temyiz Mahkemesi',
    loginEmail: 'E-posta',
    matsne: 'matsne',
    matsneDesc: 'Mevzuat değişiklikleri otomatik olarak — çalışma alanınızda',
    outlook: 'Outlook',
    prepHearing: 'Ön inceleme duruşması — 22 Mart',
    propertyApartment: 'Daire — Vake, 85 m² · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'Tapu kaydı — Eklendi',
    registryDesc: 'Şirket ve mülk verileri otomatik olarak — artık manuel kayıt indirmeye son',
    timeEntry1Date: '18 Mar, 10:30',
    timeEntry1Text: 'Dosya açıldı, ilk görüşme tamamlandı',
    timeEntry2Date: '17 Mar, 14:00',
    timeEntry2Text: 'Müvekkil belgeleri sağladı',
    timeEntry3Date: '15 Mar, 09:00',
    timeEntry3Text: 'Müvekkil firmayla iletişime geçti, ilk başvuru',
    typeCivil: 'Hukuk',
    typeAdministrative: 'İdare',
    typeCriminal: 'Ceza',
    pitchArpuMonth: 'Ortalama ARPU/ay',
    pitchArpuYear: 'Ortalama ARPU/yıl',
    pitchAutoBackup: 'Otomatik yedekleme',
    pitchAutoNextSteps: 'Otomatik sonraki adımlar',
    pitchAutoReminder: 'Otomatik hatırlatıcı',
    pitchBooking: 'Randevu',
    pitchCacOrganic: 'CAC (organik büyüme)',
    pitchCalcNote: '5000 avukat × ort. ₾35/ay × 12 ay',
    pitchCalendarSync: 'Takvim senkronizasyonu',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — duruşmalar ve son tarihler otomatik olarak senkronize edilir',
    pitchCaseManagement: 'Dava yönetimi',
    pitchClientSchedule: 'Müvekkil takvimi',
    pitchCloudDedicated: 'Özel Bulut',
    pitchCloudDedicatedDesc: 'İzole bulut sunucusu — verileriniz diğer müşterilerden tamamen ayrılır',
    pitchContractAnalysis: 'Sözleşme analizi',
    pitchCtaSubtext: 'Randevu + Operasyonlar + AI',
    pitchDedicatedServer: 'Özel sunucu',
    pitchDocDraftGeo: 'Gürcüce belge taslağı oluşturma',
    pitchEcourtDesc: 'Dava açın, dava durumu ve duruşma takvimi — mahkemeye gitmeden',
    pitchGdprCompliant: 'GDPR uyumlu',
    pitchHybrid: 'Hibrit',
    pitchHybridDesc: 'Bulut + yerel — hassas veriler yerelde, geri kalanı bulutta',
    pitchIntegrationsSub: 'Devlet hizmetleri, takvimler ve OCR — tek bir platformdan',
    pitchInvoices: 'Faturalar',
    pitchMatsneDesc: 'Mevzuat değişiklikleri otomatik olarak — çalışma alanınızda',
    pitchOcrDesc: 'Otomatik kağıt belge dijitalleştirme — manuel yazmaya gerek yok',
    pitchOnPremise: 'Şirket İçi Sunucu',
    pitchOnPremiseDesc: 'Tamamen yerel — veriler ofisinizde kalır, internet erişimi yoktur',
    pitchOperations: 'Operasyonlar',
    pitchPerkAiDocs: 'AI Belgeleri',
    pitchPerkBookings: 'Randevu yönetimi',
    pitchPerkClientPortal: 'Müvekkil portalı',
    pitchPerkCommunication: 'İletişim',
    pitchPerkFileStorage: 'Dosya depolama',
    pitchPerkResponsive: 'Mobil Uyumlu',
    pitchPrivacySubtitle: 'Hukuki veriler maksimum koruma gerektirir',
    pitchPublicRegistryDesc: 'Şirket ve mülk verileri otomatik olarak — manuel kayıt indirmeye son',
    pitchRateNote: '1 USD = 2.73 GEL — Mart 2026',
    pitchRecurringModel: 'Abonelik modeli',
    pitchRsGeDesc: 'Vergi borcu ve e-fatura — tek tıkla müvekkil durumu',
    pitchScen250: '250 avukat',
    pitchScen500: '500 avukat',
    pitchScen1000: '1000 avukat',
    pitchServerCost: 'Sunucu maliyeti/kullanıcı',
    pitchTierBusiness10: '10+ avukat',
    pitchTierEnterpriseCustom: 'Özel',
    pitchTierEnterprisePrice: 'Teklif',
    pitchTierPro310: '3-10 avukat',
    pitchTierStarter12: '1-2 avukat',
    pitchTitle: 'Gürcistan için TrustLegal',
    pitchTrustedAccounting: 'Güvenilir muhasebe',
    pitchWhyAiCheap: 'Yapay zeka araçları artık yeterince uygun fiyatlı',
    pitchWhyDigitizing: 'Gürcistan hukuk pazarı hızla dijitalleşiyor',
    pitchWhyNoCompetitor: 'Yerleşik bir rakip yok',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'Nino Barateli',
    settingsMember2Name: 'Giga Aslanishvili',
    settingsNotifyDeadlineReminder: 'Son tarih hatırlatıcısı',
    settingsNotifyNewBookingEmail: 'Yeni rezervasyon — E-posta',
    settingsNotifyNewBookingWhatsapp: 'Yeni rezervasyon — WhatsApp',
    settingsNotifyOverdueInvoice: 'Gecikmiş fatura',
    settingsNotifyReminder24h: '24 saat önce hatırlatma',
    settingsProfileName: 'Nino Barateli',
    settingsToggle3DaysBefore: '3 gün önce',
    portalCaseTypeCivil: 'Hukuk',
    portalDocDate1: '15 Mar',
    portalDocName1: 'Dava Dilekçesi - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: 'Son Ödeme: 25 Mar',
    portalLastUpdate: 'Son güncelleme: 18 Mar',
    portalMsgFrom1: 'Nino Barateli',
    portalMsgPlaceholder: 'Bir mesaj gönder...',
    portalMsgText1: 'Merhaba Giorgi, davayla ilgili yeni bir güncellememiz var.',
    portalMsgText2: 'Teşekkürler, detayları bekliyorum.',
    portalNextHearing: 'Mahkeme duruşması 25 Mart',
    portalPay: 'Öde',
    portalPendingInvoices: 'Bekleyen Faturalar',
    portalProgressLabel: 'İlerleme: 3/5 adım',
    portalStatusActive: 'Aktif',
    clientDashCaseTypeCivil: 'Hukuk',
    clientDashDocMeta1: 'Dava #2024-047 · 15 Mar',
    clientDashDocMeta2: 'Dava #2024-046 · 12 Mar',
    clientDashDocName1: 'Dava Dilekçesi - Mamulashvili.pdf',
    clientDashDocName2: 'Vekaletname - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: 'Belgeler',
    clientDashInvCase1: 'Dava: #2024-047',
    clientDashInvCase2: 'Dava: #2024-046',
    clientDashInvDue1: 'Son Ödeme: 25 Mart 2026',
    clientDashInvoicesTitle: 'Faturalar',
    clientDashInvPaidDate: 'Ödendi: 14 Mart 2026',
    clientDashLawyerInitials: 'NB',
    clientDashLawyerName: 'Nino Barateli',
    clientDashLawyerRole: 'Avukatınız',
    clientDashMessagesTitle: 'Mesajlar',
    clientDashMsgFrom1: 'Nino Barateli',
    clientDashMsgFrom3: 'Nino Barateli',
    clientDashMsgPlaceholder: 'Bir mesaj yaz...',
    clientDashMsgText1: 'Merhaba Giorgi, yeni bir dava güncellememiz var. Mahkeme duruşmayı 25 Mart\'a planladı.',
    clientDashMsgText2: 'Teşekkürler, detayları bekliyorum. Herhangi bir belge hazırlamalı mıyım?',
    clientDashMsgText3: 'Hayır, her şey hazır. Duruşmadan bir hafta önce sizinle iletişime geçeceğim.',
    clientDashMsgTime1: '10:30 · Bugün',
    clientDashMsgTime2: '10:45 · Bugün',
    clientDashMsgTime3: '11:02 · Bugün',
    clientDashMyCases: 'Davalarım',
    clientDashPaid: 'Ödendi',
    clientDashPay: 'Öde',
    clientDashProgressLabel: 'İlerleme: 3/5 adım tamamlandı',
    clientDashStatActiveCase: 'Aktif dava',
    clientDashStatDocument: 'Belge',
    clientDashStatNextHearing: 'Sonraki duruşma',
    clientDashStatNextHearingValue: '25 Mar',
    clientDashStatPayable: 'Ödenecek',
    clientDashStatusActive: 'Aktif',
    clientDashStep1Date: '5 Mar 2026',
    clientDashStep1Title: 'Danışmanlık tamamlandı',
    clientDashStep2Date: '10 Mar 2026',
    clientDashStep2Title: 'Dava dilekçesi hazırlandı',
    clientDashStep3Date: '15 Mar 2026',
    clientDashStep3Title: 'Dava dilekçesi mahkemeye sunuldu',
    clientDashStep4Date: '25 Mar 2026 — Bekliyor',
    clientDashStep4Title: 'Duruşma',
    clientDashStep5Title: 'Karar',
    clientDashUnpaid: 'Ödenmemiş',
    clientDashWelcomeSub: 'Buradan davalarınızı, faturalarınızı ve belgelerinizi takip edebilirsiniz.',
  },

  zh: {
    home: '首页',
    dashboard: '仪表盘',
    bookings: '预约',
    bookingPage: '预约页面',
    aiDocuments: 'AI 文档',
    clientPortalNav: '客户门户',
    lawyersNav: '律师',
    login: '登录',
    getStarted: '免费开始',
    lawyersTitle: '律师与律所',
    lawyersSubtitle: '在格鲁吉亚注册',
    searchPlaceholder: '按姓名、律所或业务领域搜索...',
    lawyersBtn: '律师',
    firmsBtn: '律所',
    allFilter: '全部',
    corporateLaw: '公司法',
    criminalLaw: '刑法',
    familyLaw: '家庭法',
    realEstate: '房地产',
    taxLaw: '税法',
    ipLaw: '知识产权',
    immigration: '移民',
    laborLaw: '劳动法',
    bankingFinance: '银行与金���',
    firmsMatch: '家律所匹配',
    lawyersMatch: '名律师匹配',
    reviews: '条评价',
    loadingMore: '加载更多...',
    independent: '独立',
    yearsExperience: '年经验',
    languages: '语言',
    backToDirectory: '← 返回目录',
    about: '关于',
    bookConsultation: '预约咨询',
    sendMessage: '发送消息',
    call: '致电',
    reviewsRatings: '评价与评分',
    reviewsComingSoon: '评价即将推出。成为第一个评价的人。',
    barId: '执业证号',
    ourTeam: '我们的团队',
    contact: '联系方式',
    website: '网站',
    established: '创办于',
    lawyersCount: '名律师',
    georgian: '格鲁吉亚语',
    english: '英语',
    russian: '俄语',
    german: '德语',
    french: '法语',
    turkish: '土耳其语',
    heroLine1: '您的法律',
    heroLine2: '团队。一个',
    heroLine3: '平台。',
    heroSubtitle: 'TrustLegal — 专为格鲁吉亚律所提供的预约、案件、支付和 AI 文档起草服务。按月收费，无合约绑定。',
    tryFree: '免费试用 →',
    liveDemo: '实时演示',
    trustedBrands: '注重质量的品牌与我们合作',
    howItWorks: '��作方式',
    processLabel: '// 流程',
    step1Title: '注册',
    step1Desc: '创建账户并选择套餐。无需信用卡 — 前 30 天免费。',
    step2Title: '管理案件',
    step2Desc: '添加客户、案件和预约。自动提醒和日历同步。',
    step3Title: 'AI 起草',
    step3Desc: '使用 AI 起草格鲁吉亚语文档。索赔、授权书、合同分析。',
    step4Title: '业务增长',
    step4Desc: '跟踪发票、收入和团队生产力。实时分析。',
    demoBadge: '// 实时演示',
    todaysBookings: '今日预约',
    fullDemo: '完整演示 →',
    onePlatformThreePillars: '一个平台。\n三大支柱。',
    capabilitiesLabel: '// 功能',
    bookingFeature: '预约',
    bookingFeatureDesc: '客户自主选择时间。自动提醒。日历同步。公开预约页面。',
    operationsFeature: '运营',
    operationsFeatureDesc: '集中式案件管理。客户门户。发票与支付。团队管理。',
    aiFeatureDesc: '格鲁吉亚语文档起草。合同分析。法律研究。自动跟进。',
    simplePricing: '简单定价',
    plansLabel: '// 套餐',
    perMonth: '/ 月',
    bookingMgmt: '预约管理',
    caseTracking: '案件追踪',
    calendarSync: '日历同步',
    emailReminders: '邮件提醒',
    starterPlan: '入门版',
    startNow: '立即开始 →',
    everythingStarter: '包含入门版所有功能',
    aiDocDrafting: 'AI 文档起草',
    invoicesPayments: '发票与支付',
    clientPortalFeature: '客户门户',
    directSupport: '直接支持',
    professionalPlan: '专业版',
    mostPopular: '最受欢迎',
    everythingPro: '包含专业版所有功能',
    teamMgmt10: '团队管理 (10+ 律师)',
    contractAnalysis: '合同分析',
    advancedAnalytics: '高级分析',
    personalOnboarding: '专属入职引导',
    businessPlan: '商业版',
    spotsLeft: '仅剩 3 个名额',
    enterpriseNote: '企业版 — 请联系我们获取定制报价。',
    readyQuestion: '准备好了吗？',
    first30DaysFree: '前 30 天免费。无合约限制。随时取消。',
    footerTagline: '格鲁吉亚法律 SaaS 平台。',
    productLabel: '产品',
    companyLabel: '公司',
    bookingsLink: '预约',
    casesLink: '案件',
    aiDocsLink: 'AI 文档',
    aboutUs: '关于我们',
    careers: '招聘',
    copyrightText: '© 2026 TrustLegal',
    builtWith: '使用 Symbols 构建',
    sidebarMain: '仪表盘',
    sidebarBookings: '预约',
    sidebarCases: '案件',
    sidebarClients: '客户',
    sidebarDocs: '文档',
    sidebarPayments: '支付',
    sidebarLawyers: '律师',
    sidebarSettings: '设置',
    sidebarLogout: '退出登录',
    bookingsTitle: '预约',
    newBooking: '+ 新建预约',
    newBookingTitle: '新建预约',
    clientName: '客户姓名',
    phoneNumber: '电话',
    civilLaw: '民事',
    criminalLaw2: '刑事',
    administrativeLaw: '行政',
    otherType: '其他',
    notesPlaceholder: '备注...',
    confirmBooking: '确认预约',
    cancelBtn: '取消',
    calendarSyncNote: '日历同步 — 自动同步 Google Calendar、Outlook、Apple Calendar',
    synced: '已同步',
    calendarSync2: '日历同步',
    syncedStatus: '已同步',
    bookingsToday: '今日 3 个预约',
    settingsLink: '设置 →',
    pendingStatus: '待处理',
    connectionNeeded: '需要连接',
    connectLink: '连接 →',
    lastSync: '上次同步：5 分钟前',
    mon: '周一',
    tue: '周二',
    wed: '周三',
    thu: '周四',
    fri: '周五',
    bookingDetails: '预约详情',
    confirmed: '已确认',
    pending: '待处理',
    upcomingBookings: '即将到来的预约',
    closeBtn: '关闭',
    selectDateTime: '选择日期和时间',
    fillInfo: '填写信息 — ',
    firstName: '名字',
    lastName: '姓氏',
    phoneField: '电话',
    emailField: '邮箱',
    caseDescription: '案件简介',
    confirmBookingPublic: '确认预约',
    goBack: '返回',
    bookingConfirmedMsg: '预约已确认！',
    timeLabel: '时间：',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Nino Barateli',
    casesTitle: '案件',
    searchPlaceholder2: '搜索...',
    newCase: '+ 新建案件',
    allTab: '全部',
    activeTab: '进行中',
    pendingTab: '待处理',
    closedTab: '已结案',
    selectCasePrompt: '选择一个案件以查看详情',
    info: '信息',
    registry: '登记册',
    clientInfo: '客户信息',
    chronology: '时间线',
    addNote: '添加备注',
    enterNote: '输入备注...',
    addBtn: '添加',
    documentsLabel: '文���',
    createBtn: '+ 创建',
    noDocs: '暂无文档',
    hearingSchedule: '开庭日程',
    caseStatus: '案件状态',
    electronicFiling: '电子立案',
    idCode: '识别码：',
    director: '负责人：',
    addressLabel: '地址：',
    statusLabel: '状态：',
    registeredProperty: '登记财产',
    extractLabel: '摘录',
    recentChanges: '最近更改',
    yourFieldChanges: '您所在领域的动态',
    newLabel: '新',
    notifications: '通知',
    clientsTitle: '客户',
    clientsSearchPlaceholder: '搜索客户...',
    clientsProfile: '客户资料',
    clientsContactLabel: '联系方式',
    clientsInvoiceHistory: '账单历史',
    clientsUnpaid: '未支付',
    clientsPaid: '已支付',
    clientsPortalInvite: '发送客户门户访问权限',
    dashTodayBookings: '今日预约',
    dashUnpaid: '未支付',
    dashOverdue: '逾期',
    dashAiGenerations: 'AI 生成',
    dashTodaysBookings: '今日预约',
    dashConfirmed: '已确认',
    dashRecentCases: '最近案件',
    dashNewBooking: '+ 新建预约',
    dashNewCase: '+ 新建案件',
    dashAiDocument: 'AI 文档',
    docsTitle: '文档',
    docsCreate: '创建',
    docsExisting: '现有文档',
    docsFiles: '文件',
    docsOcrScan: '扫描',
    docsOcrTitle: 'OCR 扫描',
    docsUploadText: '上传文档照片或 PDF',
    docsScanning: '文档扫描中...',
    docsFile: '文件',
    docsPages: '页数',
    docsLanguage: '语言',
    docsGeorgian: '格鲁吉亚语',
    docsAddToCase: '添加到案件',
    docsCopy: '复制',
    docsRescan: '重新扫描',
    docsClaim: '诉状',
    docsPowerOfAttorney: '授权委托书',
    docsNotification: '通知',
    docsContractReview: '合同审查',
    docsFreeForm: '自由格式',
    docsParty1: '甲方',
    docsNameCompany: '姓名 / 公司',
    docsParty2: '乙方',
    docsDate: '日期',
    docsAdditionalInfo: '附加信息',
    docsGenerating: '生成中...',
    docsGenerate: '生成',
    docsGeneratedDocument: '生成的文档',
    docsEmptyState: '生成的文档将显示在此处',
    docsShowDemo: '显示演示文档',
    docsDownload: '下载',
    docsSend: '发送',
    docsCreatedDocuments: '已创建文档',
    docsSearch: '搜索...',
    docsFileManager: '文件管理器',
    docsUpload: '上传',
    docsCases: '案件',
    docsTemplates: '模板',
    docsRecentFiles: '最近文件',
    billingTitle: '账单',
    billingNewInvoice: '新建发票',
    billingTotalSent: '发送总计',
    billingPaid: '已付款',
    billingUnpaid: '未付款',
    billingOverdue: '已逾期',
    billingActive: '活跃',
    billingClientStatus: '客户状态',
    billingEInvoice: '电子发票',
    billingAutoCheck: '自动检查',
    billingSettings: '设置 →',
    billingInvoice: '发票',
    billingClient: '客户',
    billingCase: '案件',
    billingAmount: '金额',
    billingDue: '到期',
    billingStatus: '状态',
    aiTitle: 'AI 助手',
    aiPowered: '由 AI 驱动',
    aiDraftDocs: '文档起草',
    aiContractAnalysis: '合同分析',
    aiLegalResearch: '法律检索',
    aiDraftAvailable: '文档起草功能可在文档页面使用',
    aiGoToDocuments: '前往文档 →',
    aiPasteContract: '在此粘贴合同文本...',
    aiAnalyze: '分析',
    aiReanalyze: '重新分析',
    aiParties: '当事人',
    aiObligations: '主要义务',
    aiRiskFactors: '风险因素',
    aiDeadlines: '期限',
    aiRecommendations: '建议',
    aiAskQuestion: '提问关于格鲁吉亚法律的问题',
    aiLegalResearchTitle: 'AI 法律检索',
    aiAskPlaceholder: '提问...',
    aiSend: '发送',
    pitchTagline: '格鲁吉亚法律 SAAS',
    pitchSubtitle: '预约 · 运营 · AI — 专为格鲁吉亚律所打造',
    pitchCta: '发现机遇 →',
    pitchMarketLabel: '// 市场',
    pitchMarketTitle: '格鲁吉亚有 5000+ 名律师',
    pitchPopulation: '人口',
    pitchTbilisi: '第比利斯',
    pitchConcentrated: '集中化市场',
    pitchZeroCompetitor: '本地 SaaS 竞争对手',
    pitchProblemLabel: '// 问题',
    pitchProblemTitle: '格鲁吉亚律所仍在使用 WhatsApp 和 Excel 办公',
    pitchNoBooking: '无客户预约系统',
    pitchManualCases: '手动案件管理',
    pitchNoAiTools: '无格鲁吉亚语 AI 工具',
    pitchCapabilitiesLabel: '// 功能',
    pitchOnePlatform: '一个平台。三大支柱。',
    pitchProductLabel: '// 产品',
    pitchProductTitle: '一站式平台',
    pitchIntegrationsLabel: '// 集成',
    pitchIntegrationsTitle: '自动化，告别手动工作',
    pitchPublicRegistry: '公共登记处',
    pitchCalendarSyncTitle: '日历同步',
    pitchOcrTitle: 'OCR 与扫描',
    pitchPlansLabel: '// 套餐',
    pitchPlansTitle: '专为格鲁吉亚市场定价',
    pitchTierStarter: '入门版',
    pitchMostPopular: '最受欢迎',
    pitchTierPro: '专业版',
    pitchTierBusiness: '商业版',
    pitchTierEnterprise: '企业版',
    pitchRevenueLabel: '// 收入',
    pitchRevenueTitle: '收入潜力',
    pitchFinanceLabel: '// 财务',
    pitchFinanceTitle: '单位经济效益',
    pitchTimeLabel: '// 时机',
    pitchTimeTitle: '时机正好',
    pitchPrivacyLabel: '// 隐私',
    pitchPrivacyTitle: '隐私优先',
    pitchCtaLabel: '// 共同建设',
    pitchCtaTitle: '让我们共建格鲁吉亚的法律基础设施',
    pitchCtaLink: '首页 →',
    pitchPerMonth: '月',
    settingsTitle: '设置',
    settingsTabProfile: '个人资料',
    settingsTabFirm: '律所',
    settingsTabTeam: '团队',
    settingsTabNotifications: '通知',
    settingsUploadPhoto: '上传照片',
    settingsSave: '保存',
    settingsFirmAddress: '地址',
    settingsFirmRegNumber: '注册号',
    settingsPublicBookingUrl: '公开预约 URL',
    settingsTeamMembers: '团队成员',
    settingsInvite: '+ 邀请',
    settingsRoleOwner: '所有者',
    settingsRoleLawyer: '律师',
    settingsNotifyTitle: '通知设置',
    settingsToggleOn: '已启用',
    settingsToggleOff: '已禁用',
    loginSubtitle: '登录您的账户',
    loginLawyer: '律师',
    loginClient: '客户',
    loginPassword: '密码',
    loginSubmit: '登录 →',
    loginCaseNumber: '案件编号',
    loginBackLink: '← 返回',
    portalLogout: '退出登录',
    portalWelcome: '你好，',
    portalActiveCases: '活跃案件',
    portalDocuments: '文档',
    portalMessages: '消息',
    portalSend: '发送',
    clientDashNavCases: '案件',
    clientDashNavInvoices: '发票',
    clientDashNavDocuments: '文档',
    clientDashNavMessages: '消息',
    clientDashLogout: '退出登录',
    clientDashWelcome: '你好，',
    clientDashDownload: '下载',
    clientDashSend: '发送',
    findLawyer: '寻找律师',
    lawyersSearchSub: '搜索 5,700+ 名在格鲁吉亚律师协会注册的律师',
    searchBtn: '搜索',
    viewAll: '查看全部',
    lawyerPortal: '律师门户',
    aiFeature: 'AI',
    aiChip1: '公证合同取消',
    aiChip1Question: '取消公证合同的条件是什么？',
    aiChip2: '民法典第 317 条',
    aiChip2Question: '民法典第 317 条的解释',
    aiChip3: '交易无效',
    aiChip3Question: '过去 3 年关于交易无效的法院实践',
    aiDeadlinesData: '• 服务开始：合同签订后 10 天\n• 首次付款：2026 年 4 月 1 日\n• 合同期限：12 个月',
    aiEmptyChatSub: 'AI — 提问并获取有关格鲁吉亚法律的解答',
    aiObligationsData: '1. 30 个日历日内交付服务\n2. 15 个工作日内付款\n3. 保密期 3 年',
    aiPartiesData: '甲方：Barateli & Partners LLC\n乙方：Delta Group LLC',
    aiRecommendationsData: '1. 增加违约金条款（民法典第 417 条）\n2. 明确通过仲裁解决争议\n3. 扩展不可抗力条款',
    aiRisksData: '• 未明确逾期付款违约金\n• 未指定争议解决机制\n• 不可抗力条款未涵盖大流行病',
    address: '地址',
    addressVal: '第比利斯，Chavchavadze 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'Giorgi Mamulashvili',
    billingClient2: 'Mariam Kvaratskhelia',
    billingClient3: 'Lela Gogiashvili',
    billingClientName: 'Delta Group LLC',
    billingDue1: '3月25日',
    billingDue2: '3月15日',
    billingDue3: '3月10日',
    billingEmailNotification: '电子邮件通知',
    billingLastCheck: '最后检查：今天',
    billingNoDebt: '无未结债务',
    billingRsBanner: 'rs.ge 集成 — 一键获取客户税务债务和电子发票',
    billingRsTaxSystem: 'rs.ge — 税务系统',
    billingStatusPaid: '已付款',
    billingStatusSent: '已发送',
    billingViewFull: '查看全部 →',
    billingViewInvoices: '查看发票 →',
    billingWeeklyEnabled: '每周启用',
    caseRow1Title: '#2024-047 — Giorgi Mamulashvili',
    caseRow2Title: '#2024-046 — Mariam Kvaratskhelia',
    caseRow3Title: '#2024-045 — Lela Gogiashvili',
    change1Date: '3月15日 — 生效：4月1日',
    change1Desc: '期限从30天增加到45天',
    change1Name: '民法典 — 第316条',
    change2Date: '3月12日 — 生��：5月1日',
    change2Desc: '上诉期限从14天增加到21天',
    change2Name: '诉讼法 — 期限',
    claimAccepted: '起诉已受理 — 3月17日',
    claimFiled: '已提交起诉 — 3月15日',
    claimFiledDoc: '起诉状 — 已提交',
    clientName1: 'Giorgi Mamulashvili',
    clientName2: 'Mariam Kvaratskhelia',
    clientName3: 'Lela Gogiashvili',
    companyExtractLoaded: '公司登记摘要 — 已加载',
    companyName: 'Delta Group LLC',
    clientsActiveCases1: '1个活跃案件',
    clientsActiveCases2: '1个活跃案件',
    clientsActiveCases3: '0个活跃案件',
    clientsAvatar1: 'GM',
    clientsAvatar2: 'MK',
    clientsAvatar3: 'LG',
    clientsCaseLink1: '#2024-047 — 民事',
    clientsCaseLink2: '#2024-046 — 行政',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: '无活跃案件',
    clientsPaid1: '已支付 ₾2,400',
    clientsPaid2: '已支付 ₾800',
    clientsPaid3: '已支付 ₾1,800',
    dashAlertText: '2个逾期案件和 ₾1,840 未付发票',
    dashBooking1Time: '10:00 — 民事',
    dashBooking2Time: '11:30 ��� 行政',
    dashBooking3Time: '14:00 — 刑事',
    dashCaseMeta1: '民事 · 3月18日',
    dashCaseMeta2: '行政 · 3月17日',
    dashCaseMeta3: '刑事 · 3月15日',
    dashClient3Name: 'Davit Chikovani',
    dashDate: '2026年3月18日',
    dashGreeting: '你好，Nino',
    dateMar15: '3月15日',
    dateMar17: '3月17日',
    dateMar18: '3月18日',
    disabledStatus: '— 已禁用',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: '格鲁吉亚，第比利斯\n\n起诉状\n\n原告：Barateli & Partners LLC\n被告：Delta Group LLC\n\n事实情况：\n\n通过本起诉状，原告要求被告履行其义务。\n\n诉求：\n\n1. 责令被告支付 12,500 GEL\n2. 处以 1,875 GEL 罚款\n3. 偿还诉讼费用\n\n日期：2026年3月18日\n签名：________________',
    docsDocument: '文档',
    docsFile1Meta: 'PDF · 124 KB · 2026年3月15日',
    docsFile1Name: '起诉状 - Mamulashvili.pdf',
    docsFile2Meta: 'PDF · 89 KB · 2026年3月12日',
    docsFile2Name: '授权委托书 - Kvaratskhelia.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 2026年3月10日',
    docsFile3Name: '合同 №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 2026年3月8日',
    docsFile4Name: '身份证复印件 - Mamulashvili.jpg',
    docsFile5Meta: 'PDF · 67 KB · 2026年3月5日',
    docsFile5Name: '通知 - Gogiashvili.pdf',
    docsFolder1Count: '3个文件',
    docsFolder1Name: '#2024-047 Mamulashvili',
    docsFolder2Count: '2个文件',
    docsFolder2Name: '#2024-046 Kvaratskhelia',
    docsFolder3Count: '1个文件',
    docsFolder3Name: '#2024-045 Gogiashvili',
    docsFolder4Count: '5个文件',
    docsFormatAnalysis: '格式分析...',
    docsFreeText: '自由文本...',
    docsGeneratedClaimText: '格鲁吉亚，第比利斯\n\n起诉状\n\n原告：[Party 1]\n被告：[Party 2]\n\n事实情况：\n\n通过本起诉状，原告要求被告履行《格鲁吉亚民法典》规定的义务。\n\n法律依据：\n\n根据《民法典》第316条，必须适当履行义务。\n\n诉求：\n\n鉴于上述情况，原告请求法院责令被告履行义务。\n\n日期：2026年3月18日\n签名：________________',
    docsGeorgianSymbols: '格鲁吉亚字符',
    docsOcrNote: 'OCR 扫描 — 纸质文档自动数字化，无需手动输入',
    docsOcrResultText: '合同 №147\n\n第比利斯，2026年3月10日\n\n一方面，Barateli & Partners LLC（ID 404123456），由总监 Nino Barateli 代表（以下简称“承包商”），另一方面，Delta Group LLC（ID 404789012），由总监 Giorgi Mamulashvili 代表（以下简称“客户”），签订本合同：\n\n第一条 合同标的\n1.1. 承包商承诺向客户提供法律服务。\n1.2. 服务费用为 12,500（一万二千五百）GEL。',
    docsOcrSuccess: '识别成功 — 准确率 98.5%',
    docsRow1Meta: '#2024-047 · 索赔 · 3月15日',
    docsRow1Name: '索赔 - Mamulashvili.pdf',
    docsRow2Meta: '#2024-046 · 授权委托书 · 3月12日',
    docsRow2Name: '授权委托书 - Kvaratskhelia.pdf',
    docsRow3Meta: '#2024-045 · 通知 · 3月8日',
    docsRow3Name: '通知 - Gogiashvili.pdf',
    docsTextRecognition: '文本识别',
    docsUploadFormats: 'JPG, PNG, PDF — 最大 10MB',
    docsUploadSub: '拖拽文件或点击选择',
    ecourt: 'ecourt',
    ecourtDesc: '提交索赔、查看案件状态和听证会日程 — 无需亲自前往法院',
    enabledStatus: '✓ 已启用',
    evidencePending: '证据 — 待处理',
    extract: '摘录',
    field1Text: '民事：第316条修正案',
    field2Text: '民事：第259条期限',
    field3Text: '行政：电子服务',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 3月22日, 10:00 — 第比利斯市法院',
    hearingItem2: '📅 3月28日, 14:30 — 上诉法院',
    loginEmail: '邮箱',
    matsne: 'matsne',
    matsneDesc: '立法变更自动更新 — 针对您的执业领域',
    outlook: 'Outlook',
    prepHearing: '预备听证会 — 3月22日',
    propertyApartment: '公寓 — Vake, 85 平方米 · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: '财产摘录 — 已添加',
    registryDesc: '自动获取公司和财产数据 — 无需再手动下载摘录',
    timeEntry1Date: '3月18日, 10:30',
    timeEntry1Text: '案件已立案，初步咨询已完成',
    timeEntry2Date: '3月17日, 14:00',
    timeEntry2Text: '客户已提供文件',
    timeEntry3Date: '3月15日, 09:00',
    timeEntry3Text: '客户联系律所，初步申请',
    typeCivil: '民事',
    typeAdministrative: '行政',
    typeCriminal: '刑事',
    pitchArpuMonth: '平均 ARPU/月',
    pitchArpuYear: '平均 ARPU/年',
    pitchAutoBackup: '自动备份',
    pitchAutoNextSteps: '自动下一步',
    pitchAutoReminder: '自动提醒',
    pitchBooking: '预约',
    pitchCacOrganic: 'CAC（自然增长）',
    pitchCalcNote: '5000 名律师 × 平均 ₾35/月 × 12 个月',
    pitchCalendarSync: '日历同步',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — 听证会和截止日期自动同步',
    pitchCaseManagement: '案件管理',
    pitchClientSchedule: '客户日程',
    pitchCloudDedicated: '专属云',
    pitchCloudDedicatedDesc: '隔离的云服务器 — 您的数据与其他客户完全分离',
    pitchContractAnalysis: '合同分析',
    pitchCtaSubtext: '预约 + 运营 + AI',
    pitchDedicatedServer: '独立服务器',
    pitchDocDraftGeo: '格鲁吉亚语文档起草',
    pitchEcourtDesc: '提交索赔、案���状态和听证会日程 — 无需亲自前往法院',
    pitchGdprCompliant: '符合 GDPR',
    pitchHybrid: '混合部署',
    pitchHybridDesc: '云端 + 本地 — 敏感数据存本地，其余存云端',
    pitchIntegrationsSub: '政府服务、日历和 OCR — 尽在一个平台',
    pitchInvoices: '发票',
    pitchMatsneDesc: '立法变更自动更新 — 针对您的执业领域',
    pitchOcrDesc: '纸质文档自动数字化 — 无需手动输入',
    pitchOnPremise: '本地服务器',
    pitchOnPremiseDesc: '完全本地化 — 数据留在您的办公室，无需互联网访问',
    pitchOperations: '运营',
    pitchPerkAiDocs: 'AI 文档',
    pitchPerkBookings: '预约管理',
    pitchPerkClientPortal: '客户门户',
    pitchPerkCommunication: '沟通',
    pitchPerkFileStorage: '文件存储',
    pitchPerkResponsive: '响应式',
    pitchPrivacySubtitle: '法律数据需要最高级别的保护',
    pitchPublicRegistryDesc: '自动获取公司和财产数据 — 无需手动下载摘录',
    pitchRateNote: '1 USD = 2.73 GEL — 2026年3月',
    pitchRecurringModel: '订阅模式',
    pitchRsGeDesc: '税务欠款和电子发票 — 一键查看客户状态',
    pitchScen250: '250名律师',
    pitchScen500: '500名律师',
    pitchScen1000: '1000名律师',
    pitchServerCost: '服务器成本/用户',
    pitchTierBusiness10: '10+名律师',
    pitchTierEnterpriseCustom: '定制',
    pitchTierEnterprisePrice: '报价',
    pitchTierPro310: '3-10名律师',
    pitchTierStarter12: '1-2名律师',
    pitchTitle: 'TrustLegal 格鲁吉亚',
    pitchTrustedAccounting: '可信赖的财务',
    pitchWhyAiCheap: 'AI工具现在已经足够实惠',
    pitchWhyDigitizing: '格鲁吉亚法律市场正在快速数字化',
    pitchWhyNoCompetitor: '没有成熟的竞争对手',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'Nino Barateli',
    settingsMember2Name: 'Giga Aslanishvili',
    settingsNotifyDeadlineReminder: '截止日期提醒',
    settingsNotifyNewBookingEmail: '新预约 — 电子邮件',
    settingsNotifyNewBookingWhatsapp: '新预约 — WhatsApp',
    settingsNotifyOverdueInvoice: '逾期发票',
    settingsNotifyReminder24h: '提前24小时提醒',
    settingsProfileName: 'Nino Barateli',
    settingsToggle3DaysBefore: '提前3天',
    portalCaseTypeCivil: '民事',
    portalDocDate1: '3月15日',
    portalDocName1: 'Claim - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: '截止日期: 3月25日',
    portalLastUpdate: '最后更新: 3月18日',
    portalMsgFrom1: 'Nino Barateli',
    portalMsgPlaceholder: '发送消息...',
    portalMsgText1: '你好 Giorgi，我们的案件有了新进展。',
    portalMsgText2: '谢谢，等待详细信息。',
    portalNextHearing: '3月25日法庭听证会',
    portalPay: '支付',
    portalPendingInvoices: '待处理发票',
    portalProgressLabel: '进度: 3/5 步',
    portalStatusActive: '进行中',
    clientDashCaseTypeCivil: '民事',
    clientDashDocMeta1: '案件 #2024-047 · 3月15日',
    clientDashDocMeta2: '案件 #2024-046 · 3月12日',
    clientDashDocName1: 'Claim - Mamulashvili.pdf',
    clientDashDocName2: 'Power of Attorney - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: '文档',
    clientDashInvCase1: '案件: #2024-047',
    clientDashInvCase2: '案件: #2024-046',
    clientDashInvDue1: '截止日期: 2026年3月25日',
    clientDashInvoicesTitle: '发票',
    clientDashInvPaidDate: '已支付: 2026年3月14日',
    clientDashLawyerInitials: 'NB',
    clientDashLawyerName: 'Nino Barateli',
    clientDashLawyerRole: '您的律师',
    clientDashMessagesTitle: '消息',
    clientDashMsgFrom1: 'Nino Barateli',
    clientDashMsgFrom3: 'Nino Barateli',
    clientDashMsgPlaceholder: '写消息...',
    clientDashMsgText1: '你好 Giorgi，我们有新的案件进展。法院已将听证会安排在3月25日。',
    clientDashMsgText2: '谢谢，等待详细信息。我需要准备什么文件吗？',
    clientDashMsgText3: '不需要，一切都准备好了。我们会在听证会前一周联系您。',
    clientDashMsgTime1: '10:30 · 今天',
    clientDashMsgTime2: '10:45 · 今天',
    clientDashMsgTime3: '11:02 · 今天',
    clientDashMyCases: '我的案件',
    clientDashPaid: '已支付',
    clientDashPay: '支付',
    clientDashProgressLabel: '进度: 已完成 3/5 步',
    clientDashStatActiveCase: '进行中的案件',
    clientDashStatDocument: '文档',
    clientDashStatNextHearing: '下次听证会',
    clientDashStatNextHearingValue: '3月25日',
    clientDashStatPayable: '应付',
    clientDashStatusActive: '进行中',
    clientDashStep1Date: '2026年3月5日',
    clientDashStep1Title: '咨询已完成',
    clientDashStep2Date: '2026年3月10日',
    clientDashStep2Title: '起诉书已起草',
    clientDashStep3Date: '2026年3月15日',
    clientDashStep3Title: '起诉书已提交法院',
    clientDashStep4Date: '2026年3月25日 — 待处理',
    clientDashStep4Title: '庭审',
    clientDashStep5Title: '裁决',
    clientDashUnpaid: '未支付',
    clientDashWelcomeSub: '您可以在此追踪您的案件、发票和文件。',
  },

  hi: {
    home: 'होम',
    dashboard: 'डैशबोर्ड',
    bookings: 'बुकिंग्स',
    bookingPage: 'बुकिंग पेज',
    aiDocuments: 'AI दस्तावेज़',
    clientPortalNav: 'क्लाइंट पोर्टल',
    lawyersNav: 'वकील',
    login: 'लॉग इन',
    getStarted: 'मुफ़्त में शुरू करें',
    lawyersTitle: 'वकील और लॉ फर्म',
    lawyersSubtitle: 'जॉर्जिया में पंजीकृत',
    searchPlaceholder: 'नाम, फर्म या प्रैक्टिस एरिया से खोजें...',
    lawyersBtn: 'वकील',
    firmsBtn: 'फर्म',
    allFilter: 'सभी',
    corporateLaw: 'कॉर्पोरेट लॉ',
    criminalLaw: 'क्रिमिनल लॉ',
    familyLaw: 'फैमिली लॉ',
    realEstate: 'रियल एस्टेट',
    taxLaw: 'टैक्स लॉ',
    ipLaw: 'आईपी',
    immigration: 'इमिग्रेशन',
    laborLaw: 'लेबर लॉ',
    bankingFinance: 'बैंकिंग और फाइनेंस',
    firmsMatch: 'फर्म मिलीं',
    lawyersMatch: 'वकील मिले',
    reviews: 'रिव्यू',
    loadingMore: 'और लोड हो रहा है...',
    independent: 'स्वतंत्र',
    yearsExperience: 'साल का अनुभव',
    languages: 'भाषाएं',
    backToDirectory: '← डायरेक्टरी पर वापस जाएं',
    about: 'बारे में',
    bookConsultation: 'परामर्श बुक करें',
    sendMessage: 'मैसेज भेजें',
    call: 'कॉल करें',
    reviewsRatings: 'रिव्यू और रेटिंग',
    reviewsComingSoon: 'रिव्यू जल्द आ रहे हैं। सबसे पहले रिव्यू दें।',
    barId: 'बार ID',
    ourTeam: 'हमारी टीम',
    contact: 'संपर्क',
    website: 'वेबसाइट',
    established: 'स्था.',
    lawyersCount: 'वकील',
    georgian: 'जॉर्जियाई',
    english: 'अंग्रेज़ी',
    russian: 'रूसी',
    german: 'जर्मन',
    french: 'फ़्रेंच',
    turkish: 'तुर्की',
    heroLine1: 'आपकी लीगल',
    heroLine2: 'टीम। एक',
    heroLine3: 'प्लेटफ़ॉर्म।',
    heroSubtitle: 'TrustLegal — जॉर्जियाई लॉ फर्मों के लिए बुकिंग्स, केस, पेमेंट और AI दस्तावेज़ ड्राफ्टिंग। एक मासिक शुल्क, कोई कॉन्ट्रैक्ट नहीं।',
    tryFree: 'मुफ़्त में आज़माएं →',
    liveDemo: 'लाइव डेमो',
    trustedBrands: 'क्वालिटी की परवाह करने वाले ब्रांड हमारे साथ काम करते हैं',
    howItWorks: 'यह कैसे काम करता है',
    processLabel: '// ��्रक्रिया',
    step1Title: 'साइन अप करें',
    step1Desc: 'अकाउंट बनाएं और प्लान चुनें। किसी क्रेडिट कार्ड की आवश्यकता नहीं — पहले 30 दिन मुफ़्त।',
    step2Title: 'केस मैनेज करें',
    step2Desc: 'क्लाइंट, केस और बुकिंग्स जोड़ें। ऑटोमैटिक रिमाइंडर और कैलेंडर सिंक।',
    step3Title: 'AI के साथ ड्राफ्ट करें',
    step3Desc: 'जॉर्जियाई में AI-पावर्ड दस्तावेज़ ड्राफ्टिंग। दावे, पावर ऑफ अटॉर्नी, कॉन्ट्रैक्ट विश्लेषण।',
    step4Title: 'विकास करें',
    step4Desc: 'इनवॉइस, रेवेन्यू और टीम की उत्पादकता ट्रैक करें। रियल-टाइम एनालिटिक्स।',
    demoBadge: '// लाइव डेमो',
    todaysBookings: 'आज की बुकिंग्स',
    fullDemo: 'पूरा डेमो →',
    onePlatformThreePillars: 'एक प्लेटफ़ॉर्म।\nतीन स्तंभ।',
    capabilitiesLabel: '// क्षमताएं',
    bookingFeature: 'बुकिंग',
    bookingFeatureDesc: 'क्लाइंट अपना समय खुद चुनते हैं। ऑटो रिमाइंडर। कैलेंडर सिंक। पब्लिक बुकिंग पेज।',
    operationsFeature: 'ऑपरेशन्स',
    operationsFeatureDesc: 'केंद्रीकृत केस मैनेजमेंट। क्लाइंट पोर्टल। इनवॉइस और पेमेंट। टीम मैनेजमेंट।',
    aiFeatureDesc: 'जॉर्जियाई में दस्तावेज़ ड्राफ्टिंग। कॉन्ट्रैक्ट विश्लेषण। लीगल रिसर्च। ऑटो फॉलो-अप।',
    simplePricing: 'सरल प्राइसिंग',
    plansLabel: '// प्लान',
    perMonth: '/ महीना',
    bookingMgmt: 'बुकिंग प्रबंधन',
    caseTracking: 'केस ट्रैकिंग',
    calendarSync: 'कैलेंडर सिंक',
    emailReminders: 'ईमेल रिमाइंडर',
    starterPlan: 'स्टार्टर',
    startNow: 'अभी शुरू करें →',
    everythingStarter: 'स्टार्टर से सब कुछ',
    aiDocDrafting: 'AI दस्तावेज़ ड्राफ्टिंग',
    invoicesPayments: 'इनवॉइस और भुगतान',
    clientPortalFeature: 'क्लाइंट पोर्टल',
    directSupport: 'डायरेक्ट सपोर्ट',
    professionalPlan: 'प्रोफेशनल',
    mostPopular: 'सबसे ���ोकप्रिय',
    everythingPro: 'प्रोफेशनल से सब कुछ',
    teamMgmt10: 'टीम प्रबंधन (10+ वकील)',
    contractAnalysis: 'अनुबंध विश्लेषण',
    advancedAnalytics: 'एडवांस्ड एनालिटिक्स',
    personalOnboarding: 'व्यक्तिगत ऑनबोर्डिंग',
    businessPlan: 'बिज़नेस',
    spotsLeft: '3 जगह बाकी',
    enterpriseNote: 'एंटरप्राइज़ — कस्टम ऑफ़र के लिए हमसे संपर्क करें।',
    readyQuestion: 'तैयार हैं?',
    first30DaysFree: 'पहले 30 दिन मुफ़्त। कोई अनुबंध नहीं। कभी भी रद्द करें।',
    footerTagline: 'जॉर्जियन लीगल SaaS प्लेटफ़ॉर्म।',
    productLabel: 'प्रोडक्ट',
    companyLabel: 'कंपनी',
    bookingsLink: 'बुकिंग',
    casesLink: 'केस',
    aiDocsLink: 'AI दस्तावेज़',
    aboutUs: 'हमारे बारे में',
    careers: 'करियर',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'Symbols के साथ निर्मित',
    sidebarMain: 'डैशबोर्ड',
    sidebarBookings: 'बुकिंग',
    sidebarCases: 'केस',
    sidebarClients: 'क्लाइंट',
    sidebarDocs: 'दस्तावेज़',
    sidebarPayments: 'भुगतान',
    sidebarLawyers: 'वकील',
    sidebarSettings: 'सेटिंग',
    sidebarLogout: 'लॉग आउट',
    bookingsTitle: 'बुकिंग',
    newBooking: '+ नई बुकिंग',
    newBookingTitle: 'नई बुकिंग',
    clientName: 'क्लाइंट का नाम',
    phoneNumber: 'फ़ोन',
    civilLaw: 'सिविल',
    criminalLaw2: 'आपराधिक कानून',
    administrativeLaw: 'प्रशासनिक',
    otherType: 'अन्य',
    notesPlaceholder: 'नोट्स...',
    confirmBooking: 'बुकिंग की पुष्टि करें',
    cancelBtn: 'रद्द करें',
    calendarSyncNote: 'कैलेंडर सिंक — Google Calendar, Outlook, Apple Calendar अपने आप सिंक होते हैं',
    synced: 'सिंक किया गया',
    calendarSync2: 'कैलेंडर सिंक',
    syncedStatus: 'सिंक किया गया',
    bookingsToday: 'आज 3 बुकिंग',
    settingsLink: 'सेटिंग →',
    pendingStatus: 'लंबित',
    connectionNeeded: 'कनेक्शन आवश्यक',
    connectLink: 'कनेक्ट करें →',
    lastSync: 'अंतिम सिंक: 5 मिनट पहले',
    mon: 'सोम',
    tue: 'मंगल',
    wed: 'बुध',
    thu: 'गुरु',
    fri: 'शुक्र',
    bookingDetails: 'बुकिंग विवरण',
    confirmed: 'पुष्टि की गई',
    pending: 'लंबित',
    upcomingBookings: 'आगामी बुकिंग',
    closeBtn: 'बंद करें',
    selectDateTime: 'दिनांक और समय चुनें',
    fillInfo: 'जानकारी भरें — ',
    firstName: 'पहला नाम',
    lastName: 'अंतिम नाम',
    phoneField: 'फ़ोन',
    emailField: 'ईमेल',
    caseDescription: 'केस का संक्षिप्त विवरण',
    confirmBookingPublic: 'बुकिंग की पुष्टि करें',
    goBack: 'वापस जाएं',
    bookingConfirmedMsg: 'बुकिंग की पुष्टि हो गई!',
    timeLabel: 'समय: ',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Nino Barateli',
    casesTitle: 'केस',
    searchPlaceholder2: 'खोजें...',
    newCase: '+ नया केस',
    allTab: 'सभी',
    activeTab: 'सक्रिय',
    pendingTab: 'लंबित',
    closedTab: 'बंद',
    selectCasePrompt: 'विवरण देखने के लिए एक केस चुनें',
    info: 'जानकारी',
    registry: 'रजिस्ट्री',
    clientInfo: 'क्लाइंट की जानकारी',
    chronology: 'कालक्रम',
    addNote: 'नोट जोड़ें',
    enterNote: 'एक नोट दर्ज करें...',
    addBtn: 'जोड़ें',
    documentsLabel: 'दस्तावेज़',
    createBtn: '+ बनाएं',
    noDocs: 'कोई दस्तावेज़ नहीं',
    hearingSchedule: 'सुनवाई का कार्यक्रम',
    caseStatus: 'केस की स्थिति',
    electronicFiling: 'इलेक्ट्रॉनिक फाइलिंग',
    idCode: 'आईडी कोड:',
    director: 'निदेशक:',
    addressLabel: 'पता:',
    statusLabel: 'स्थिति:',
    registeredProperty: 'पंजीकृत संपत्ति',
    extractLabel: 'उद्धरण',
    recentChanges: 'हाल के बदलाव',
    yourFieldChanges: 'आपके क्षेत्र में बदलाव',
    newLabel: 'नया',
    notifications: 'सूचनाएं',
    clientsTitle: 'क्लाइंट्स',
    clientsSearchPlaceholder: 'क्ला��ंट्स खोजें...',
    clientsProfile: 'क्लाइंट प्रोफ़ाइल',
    clientsContactLabel: 'संपर्क',
    clientsInvoiceHistory: 'इनवॉइस इतिहास',
    clientsUnpaid: 'बकाया',
    clientsPaid: 'भुगतान किया गया',
    clientsPortalInvite: 'क्लाइंट पोर्टल एक्सेस भेजें',
    dashTodayBookings: 'आज की बुकिंग',
    dashUnpaid: 'बकाया',
    dashOverdue: 'अतिदेय',
    dashAiGenerations: 'AI जनरेशन',
    dashTodaysBookings: 'आज की बुकिंग',
    dashConfirmed: 'पुष्टि की गई',
    dashRecentCases: 'हाल के केस',
    dashNewBooking: '+ नई बुकिंग',
    dashNewCase: '+ नया केस',
    dashAiDocument: 'AI दस्तावेज़',
    docsTitle: 'दस्तावेज़',
    docsCreate: 'बनाएं',
    docsExisting: 'मौजूदा दस्तावेज़',
    docsFiles: 'फ़ाइलें',
    docsOcrScan: 'स्कैन करें',
    docsOcrTitle: 'OCR स्कैनिंग',
    docsUploadText: 'दस्तावेज़ क�� फ़ोटो या PDF अपलोड करें',
    docsScanning: 'दस्तावेज़ स्कैन हो रहा है...',
    docsFile: 'फ़ाइल',
    docsPages: 'पृष्ठ',
    docsLanguage: 'भाषा',
    docsGeorgian: 'जॉर्जियाई',
    docsAddToCase: 'केस में जोड़ें',
    docsCopy: 'कॉपी करें',
    docsRescan: 'फिर से स्कैन करें',
    docsClaim: 'दावा',
    docsPowerOfAttorney: 'पावर ऑफ अटॉर्नी',
    docsNotification: 'अधिसूचना',
    docsContractReview: 'अनुबंध की समीक्षा',
    docsFreeForm: 'फ्री फॉर्म',
    docsParty1: 'पक्ष 1',
    docsNameCompany: 'नाम / कंपनी',
    docsParty2: 'पक्ष 2',
    docsDate: 'दिनांक',
    docsAdditionalInfo: 'अतिरिक्त जानकारी',
    docsGenerating: 'जेनरेट हो रहा है...',
    docsGenerate: 'जेनरेट करें',
    docsGeneratedDocument: 'जेनरेट किया गया दस्तावेज़',
    docsEmptyState: 'जेनरेट किया गया दस्तावेज़ यहाँ दिखाई देगा',
    docsShowDemo: 'डेमो दस्तावेज़ दिखाएं',
    docsDownload: 'डाउनलोड',
    docsSend: 'भेजें',
    docsCreatedDocuments: 'बनाए गए दस्तावेज़',
    docsSearch: 'खोजें...',
    docsFileManager: 'फ़ाइल मैनेजर',
    docsUpload: 'अपल��ड',
    docsCases: 'केस',
    docsTemplates: 'टेम्पलेट',
    docsRecentFiles: 'हाल की फ़ाइलें',
    billingTitle: 'बिलिंग',
    billingNewInvoice: 'नया इनवॉइस',
    billingTotalSent: 'कुल भेजा गया',
    billingPaid: 'भुगतान किया गया',
    billingUnpaid: 'बकाया',
    billingOverdue: 'ओवरड्यू',
    billingActive: 'सक्रिय',
    billingClientStatus: 'क्लाइंट की स्थिति',
    billingEInvoice: 'e-Invoice',
    billingAutoCheck: 'ऑटो-चेक',
    billingSettings: 'सेटिंग्स →',
    billingInvoice: 'इनवॉइस',
    billingClient: 'क्लाइंट',
    billingCase: 'केस',
    billingAmount: 'राशि',
    billingDue: 'देय',
    billingStatus: 'स्टेटस',
    aiTitle: 'AI असिस्टेंट',
    aiPowered: 'AI द्वारा संचालित',
    aiDraftDocs: 'दस्तावेज़ ड्राफ्टिंग',
    aiContractAnalysis: 'अनुबंध विश्लेषण',
    aiLegalResearch: 'कानूनी शोध',
    aiDraftAvailable: 'दस्तावेज़ ड्राफ्टिंग दस्तावेज़ पेज पर उपलब्ध है',
    aiGoToDocuments: 'दस्तावेज़ों पर जाएं →',
    aiPasteContract: 'कॉन्ट्रैक्ट का टेक्स्ट यहाँ पेस्ट करें...',
    aiAnalyze: 'विश्लेषण करें',
    aiReanalyze: 'फिर से विश्लेषण करें',
    aiParties: 'पक्ष',
    aiObligations: 'मुख्य दायित्व',
    aiRiskFactors: 'जोखिम कारक',
    aiDeadlines: 'डेडलाइन',
    aiRecommendations: 'सिफारिशें',
    aiAskQuestion: 'जॉर्जियाई कानून के बारे में एक प्रश्न पूछें',
    aiLegalResearchTitle: 'AI कानूनी शोध',
    aiAskPlaceholder: 'एक प्रश्न पूछें...',
    aiSend: 'भेजें',
    pitchTagline: 'जॉर्जिया का लीगल SaaS',
    pitchSubtitle: 'बुकिंग · ऑपरेशन्स · AI — जॉर्जियाई फर्मों के लिए',
    pitchCta: 'अवसर देखें →',
    pitchMarketLabel: '// मार्केट',
    pitchMarketTitle: 'जॉर्जिया में 5000+ वकील',
    pitchPopulation: 'आबादी',
    pitchTbilisi: 'त्बिलिसी',
    pitchConcentrated: 'केंद्रित बाज़ार',
    pitchZeroCompetitor: 'स्थानीय SaaS प्रतियोगी',
    pitchProblemLabel: '// समस्या',
    pitchProblemTitle: 'जॉर्जियाई फर्में अभी भी WhatsApp और Excel पर चलती हैं',
    pitchNoBooking: 'कोई क्लाइंट बुकिंग सिस्टम नहीं',
    pitchManualCases: 'मैनुअल केस मैनेजमेंट',
    pitchNoAiTools: 'जॉर्जियाई में कोई AI टूल नहीं',
    pitchCapabilitiesLabel: '// क्षमताएं',
    pitchOnePlatform: 'एक प्लेटफ़ॉर्म. तीन स्तंभ.',
    pitchProductLabel: '// प्रोडक्ट',
    pitchProductTitle: 'एक ही प्लेटफ़ॉर्म में सब कुछ',
    pitchIntegrationsLabel: '// इंटीग्रेशन',
    pitchIntegrationsTitle: 'ऑटोमेशन, मैनुअल काम नहीं',
    pitchPublicRegistry: 'पब्लिक रजिस्ट्री',
    pitchCalendarSyncTitle: 'कैलेंडर सिंक',
    pitchOcrTitle: 'OCR और स्कैनिंग',
    pitchPlansLabel: '// प्लान',
    pitchPlansTitle: 'जॉर्जियाई बाज़ार के लिए प्राइसिंग',
    pitchTierStarter: 'स्टार्टर',
    pitchMostPopular: 'सबसे लोकप्रिय',
    pitchTierPro: 'प्रोफेशनल',
    pitchTierBusiness: 'बिज़नेस',
    pitchTierEnterprise: 'एंटरप्राइज़',
    pitchRevenueLabel: '// राजस्व',
    pitchRevenueTitle: 'राजस्व क्षमता',
    pitchFinanceLabel: '// वित्तीय',
    pitchFinanceTitle: 'यूनिट इकोनॉमिक्स',
    pitchTimeLabel: '// समय',
    pitchTimeTitle: 'समय सही है',
    pitchPrivacyLabel: '// गोपनीयता',
    pitchPrivacyTitle: 'गोपनीयता प्राथमिकता है',
    pitchCtaLabel: '// साथ मिलकर बनाएं',
    pitchCtaTitle: 'आइए जॉर्जिया का कानूनी बुनियादी ढांचा बनाएं',
    pitchCtaLink: 'होम पेज →',
    pitchPerMonth: 'महीना',
    settingsTitle: 'सेटिंग्स',
    settingsTabProfile: 'प्रोफ़ाइल',
    settingsTabFirm: 'फ़र्म',
    settingsTabTeam: 'टीम',
    settingsTabNotifications: 'सूचनाएं',
    settingsUploadPhoto: 'फ़ोटो अपलोड करें',
    settingsSave: 'सहेजें',
    settingsFirmAddress: 'पता',
    settingsFirmRegNumber: 'पंजीकरण संख्या',
    settingsPublicBookingUrl: 'सार्वजनिक बुकिंग URL',
    settingsTeamMembers: 'टीम के सदस्य',
    settingsInvite: '+ आमंत्रित करें',
    settingsRoleOwner: 'मालिक',
    settingsRoleLawyer: 'वकील',
    settingsNotifyTitle: 'अधिसूचना सेटिंग्स',
    settingsToggleOn: 'सक्षम',
    settingsToggleOff: 'अक्षम',
    loginSubtitle: 'अपने खाते में साइन इन करें',
    loginLawyer: 'वकील',
    loginClient: 'क्लाइंट',
    loginPassword: 'पासवर्ड',
    loginSubmit: 'साइन इन करें →',
    loginCaseNumber: 'केस नंबर',
    loginBackLink: '← वापस जाएं',
    portalLogout: 'लॉग आउट करें',
    portalWelcome: 'नमस्ते,',
    portalActiveCases: 'सक्रिय केस',
    portalDocuments: 'दस्तावेज़',
    portalMessages: 'संदेश',
    portalSend: 'भेजें',
    clientDashNavCases: 'केस',
    clientDashNavInvoices: 'इनवॉइस',
    clientDashNavDocuments: 'दस्तावेज़',
    clientDashNavMessages: 'संदेश',
    clientDashLogout: 'लॉग आउट करें',
    clientDashWelcome: 'नमस्ते,',
    clientDashDownload: 'डाउनलोड करें',
    clientDashSend: 'भेजें',
    findLawyer: 'वकील खोजें',
    lawyersSearchSub: 'Georgian Bar Association के साथ पंजीकृत 5,700+ वकीलों को खोजें',
    searchBtn: 'खोजें',
    viewAll: 'सभी देखें',
    lawyerPortal: 'वकील पोर्टल',
    aiFeature: 'AI',
    aiChip1: 'नोटरी अनुबंध रद्दीकरण',
    aiChip1Question: 'नोटरी अनुबंध को रद्द करने की शर्तें क्या हैं?',
    aiChip2: 'नागरिक संहिता अनुच्छेद 317',
    aiChip2Question: 'नागरिक संहिता अनुच्छेद 317 की व्याख्या',
    aiChip3: 'लेनदेन शून्यता',
    aiChip3Question: 'पिछले 3 वर्षों में लेनदेन शून्यता पर न्यायालय का अभ्यास',
    aiDeadlinesData: '• सेवा प्रारंभ: अनुबंध से 10 दिन\n• पहला भुगतान: 1 अप्रैल, 2026\n• अनुबंध अवधि: 12 महीने',
    aiEmptyChatSub: 'AI — जॉर्जियाई कानून के बारे में प्रश्न पूछें और उत्तर प्राप्त करें',
    aiObligationsData: '1. 30 कैलेंडर दिनों के भीतर सेवा वितरण\n2. 15 कार्य दिवसों के भीतर भुगतान\n3. 3 वर्षों के लिए गोपनीयता',
    aiPartiesData: 'Party 1: Barateli & Partners LLC\nParty 2: Delta Group LLC',
    aiRecommendationsData: '1. जुर्माना खंड जोड़ें (नागरिक संहित�� अनु. 417)\n2. मध्यस्थता के माध्यम से विवाद समाधान को परिभाषित करें\n3. फोर्स मेज्योर खंड का विस्तार करें',
    aiRisksData: '• विलंबित भुगतान जुर्माना परिभाषित नहीं है\n• विवाद समाधान तंत्र निर्दिष्ट नहीं है\n• फोर्स मेज्योर खंड में महामारी शामिल नहीं है',
    address: 'पता',
    addressVal: 'त्बिलिसी, चावचावद्ज़े 12',
    appleCalendar: 'Apple Calendar',
    billingClient1: 'जियोर्गी ममुलाशविली',
    billingClient2: 'मरियम क्वारत्सखेलिया',
    billingClient3: 'लेला गोगियाशविली',
    billingClientName: 'Delta Group LLC',
    billingDue1: '25 मार्च',
    billingDue2: '15 मार्च',
    billingDue3: '10 मार्च',
    billingEmailNotification: 'ईमेल अधिसूचना',
    billingLastCheck: 'अंतिम जांच: आज',
    billingNoDebt: 'कोई बकाया ऋण नहीं',
    billingRsBanner: 'rs.ge एकीकरण — एक क्लिक में क्लाइंट का कर ऋण और ई-चालान',
    billingRsTaxSystem: 'rs.ge — कर प्रणाली',
    billingStatusPaid: 'भुगतान किया गया',
    billingStatusSent: 'भेजा गया',
    billingViewFull: 'पूरा देखें →',
    billingViewInvoices: 'चालान देखें →',
    billingWeeklyEnabled: 'साप्ताहिक सक्षम',
    caseRow1Title: '#2024-047 — जियोर्गी मामुलाशविली',
    caseRow2Title: '#2024-046 — मारियम क्वारत्सखेलिया',
    caseRow3Title: '#2024-045 — लेला गोगियाशविली',
    change1Date: '15 मार्च — प्रभावी: 1 अप्रैल',
    change1Desc: 'समय सीमा 30 से बढ़ाकर 45 दिन कर दी गई है',
    change1Name: 'नागरिक संहिता — अनुच्छेद 316',
    change2Date: '12 मार्च — प्रभावी: 1 मई',
    change2Desc: 'अपील की समय सीमा 14 से 21 दिन',
    change2Name: 'प्रक्रियात्मक संहिता — समय सीमाएं',
    claimAccepted: 'दावा स्वीकार किया गया — 17 मार्च',
    claimFiled: 'दावा दायर किया गया — 15 मार्च',
    claimFiledDoc: 'दावा — दायर किया गया',
    clientName1: 'जियोर्गी मामुलाशविली',
    clientName2: 'मारियम क्वारत्सखेलिया',
    clientName3: 'लेला गोगियाशविली',
    companyExtractLoaded: 'कंपनी का उद्धरण — लोड किया गय���',
    companyName: 'Delta Group LLC',
    clientsActiveCases1: '1 सक्रिय मामला',
    clientsActiveCases2: '1 सक्रिय मामला',
    clientsActiveCases3: '0 सक्रिय मामले',
    clientsAvatar1: 'GM',
    clientsAvatar2: 'MK',
    clientsAvatar3: 'LG',
    clientsCaseLink1: '#2024-047 — दीवानी',
    clientsCaseLink2: '#2024-046 — प्रशासनिक',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'कोई सक्रिय मामले नहीं',
    clientsPaid1: '₾2,400 का भुगतान किया गया',
    clientsPaid2: '₾800 का भुगतान किया गया',
    clientsPaid3: '₾1,800 का भुगतान किया गया',
    dashAlertText: '2 अतिदेय मामले और ₾1,840 के अवैतनिक चालान',
    dashBooking1Time: '10:00 — दीवानी',
    dashBooking2Time: '11:30 — प्रशासनिक',
    dashBooking3Time: '14:00 — आपराधिक',
    dashCaseMeta1: 'दीवानी · 18 मार्���',
    dashCaseMeta2: 'प्रशासनिक · 17 मार्च',
    dashCaseMeta3: 'आपराधिक · 15 मार्च',
    dashClient3Name: 'डेविट चिकोवानी',
    dashDate: '18 मार्च, 2026',
    dashGreeting: 'नमस्ते, नीनो',
    dateMar15: '15 मार्च',
    dateMar17: '17 मार्च',
    dateMar18: '18 मार्च',
    disabledStatus: '— अक्षम',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: 'जॉर्जिया, त्बिलिसी\n\nदावा\n\nवादी: Barateli & Partners LLC\nप्रतिवादी: Delta Group LLC\n\nतथ्यात्मक परिस्थितियां:\n\nइस दावे के द्वारा, वादी प्रतिवादी से अपने दायित्वों को पूरा करने का अनुरोध करता है।\n\nअनुरोध:\n\n1. प्रतिवादी को 12,500 GEL का भुगतान करने के लिए बाध्य करें\n2. 1,875 GEL का जुर्माना लगाएं\n3. अदालती खर्चों की प्रतिपूर्ति करें\n\nदिना���क: 18 मार्च, 2026\nहस्ताक्षर: ________________',
    docsDocument: 'दस्तावेज़',
    docsFile1Meta: 'PDF · 124 KB · 15 मार्च 2026',
    docsFile1Name: 'दावा - मामुलाशविली.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 मार्च 2026',
    docsFile2Name: 'मुख्तारनामा - क्वारत्सखेलिया.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 मार्च 2026',
    docsFile3Name: 'अनुबंध №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 मार्च 2026',
    docsFile4Name: 'आईडी कॉपी - मामुलाशविली.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 मार्च 2026',
    docsFile5Name: 'अधिसूचना - गोगियाशविली.pdf',
    docsFolder1Count: '3 फ़ाइलें',
    docsFolder1Name: '#2024-047 मामुलाशविली',
    docsFolder2Count: '2 फ़ाइलें',
    docsFolder2Name: '#2024-046 क्वारत्सखेलिया',
    docsFolder3Count: '1 फ़ाइल',
    docsFolder3Name: '#2024-045 गोगियाशविली',
    docsFolder4Count: '5 फ़ाइलें',
    docsFormatAnalysis: 'प��रारूप विश्लेषण...',
    docsFreeText: 'मुक्त पाठ...',
    docsGeneratedClaimText: 'जॉर्जिया, त्बिलिसी\n\nदावा\n\nवादी: [Party 1]\nप्रतिवादी: [Party 2]\n\nतथ्यात्मक परिस्थितियां:\n\nइस दावे के द्वारा, वादी प्रतिवादी से जॉर्जिया के नागरिक संहिता के तहत अपने दायित्वों को पूरा करने का अनुरोध करता है।\n\nकानूनी आधार:\n\nनागरिक संहिता के अनुच्छेद 316 के अनुसार, दायित्वों का ठीक से पालन किया जाना चाहिए।\n\nअनुरोध:\n\nउपरोक्त को ध्यान में रखते हुए, वादी अदालत से प्रतिवादी को बाध्य करने का अनुरोध करता है।\n\nदिनांक: 18 मार्च, 2026\nहस्ताक्षर: ________________',
    docsGeorgianSymbols: 'जॉर्जियाई वर्ण',
    docsOcrNote: 'OCR स्कैनिंग — कागजी दस्तावेज़ों का स्वचालित डिजिटलीकरण, मैन्युअल टाइपिंग की आवश्यकता नहीं',
    docsOcrResultText: 'अनुबंध №147\n\nTbilisi, 10 मार्च, 2026\n\nएक ओर, Barateli & Partners LLC (ID 404123456), जिसका प्रतिनिधित्व निदेशक Nino Barateli (इसके बाद "ठेकेदार") द्वारा किया गया है और दूसरी ओर, Delta Group LLC (ID 404789012), जिसका प्रतिनिधित्व निदेशक Giorgi Mamulashvili (इसके बाद "क्लाइंट") द्वारा किया गया है, ने इस अनुबंध में प्रवेश किया:\n\nअनुच्छेद 1. अनुबंध का विषय\n1.1. ठेकेदार क्लाइंट को कानूनी सेवाएं ��्रदान करने का वचन देता है।\n1.2. सेवा की लागत 12,500 (बारह हज़ार पाँच सौ) GEL है।',
    docsOcrSuccess: 'सफलतापूर्वक पहचाना गया — 98.5% सटीकता',
    docsRow1Meta: '#2024-047 · दावा · 15 मार्च',
    docsRow1Name: 'दावा - Mamulashvili.pdf',
    docsRow2Meta: '#2024-046 · मुख्तारनामा · 12 मार्च',
    docsRow2Name: 'मुख्तारनामा - Kvaratskhelia.pdf',
    docsRow3Meta: '#2024-045 · अधिसूचना · 8 मार्च',
    docsRow3Name: 'अधिसूचना - Gogiashvili.pdf',
    docsTextRecognition: 'टेक्स्ट रिकग्निशन',
    docsUploadFormats: 'JPG, PNG, PDF — अधिकतम 10MB',
    docsUploadSub: 'फ़ाइल खींचें या चुनने के लिए क्लिक करें',
    ecourt: 'ecourt',
    ecourtDesc: 'दावे दायर करें, केस की स्थिति और सुनवाई का शेड्यूल जांचें — बिना अदालत जाए',
    enabledStatus: '✓ सक्षम',
    evidencePending: 'सब��त — लंबित',
    extract: 'एक्सट्रैक्ट',
    field1Text: 'दीवानी: अनु. 316 संशोधन',
    field2Text: 'दीवानी: अनु. 259 समय सीमा',
    field3Text: 'प्रशासनिक: ई-सेवा',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 मार्च, 10:00 — Tbilisi City Court',
    hearingItem2: '📅 28 मार्च, 14:30 — Court of Appeals',
    loginEmail: 'ईमेल',
    matsne: 'matsne',
    matsneDesc: 'कानून में बदलाव स्वचालित रूप से — आपके प्रैक्टिस क्षेत्र में',
    outlook: 'Outlook',
    prepHearing: 'प्रारंभिक सुनवाई — 22 मार्च',
    propertyApartment: 'अपार्टमेंट — Vake, 85 वर्ग मीटर · ~₾180,000',
    propertyCar: 'BMW X5 — 2021, AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'संपत्ति एक्सट्रैक्ट — जोड़ा गया',
    registryDesc: 'कंपनी और संपत्ति डेटा स्वचालित रूप से — अब मैन्युअल एक्सट्रैक��ट डाउनलोड की आवश्यकता नहीं',
    timeEntry1Date: '18 मार्च, 10:30',
    timeEntry1Text: 'केस खोला गया, प्रारंभिक परामर्श पूरा हुआ',
    timeEntry2Date: '17 मार्च, 14:00',
    timeEntry2Text: 'क्लाइंट ने दस्तावेज़ प्रदान किए',
    timeEntry3Date: '15 मार्च, 09:00',
    timeEntry3Text: 'क्लाइंट ने फर्म से संपर्क किया, प्रारंभिक आवेदन',
    typeCivil: 'दीवानी',
    typeAdministrative: 'प्रशासनिक',
    typeCriminal: 'फौजदारी',
    pitchArpuMonth: 'औसत ARPU/माह',
    pitchArpuYear: 'औसत ARPU/वर्ष',
    pitchAutoBackup: 'स्वचालित बैकअप',
    pitchAutoNextSteps: 'ऑटो अगले कदम',
    pitchAutoReminder: 'ऑटो रिमाइंडर',
    pitchBooking: 'बुकिंग',
    pitchCacOrganic: 'CAC (ऑर्गेनिक ग्रोथ)',
    pitchCalcNote: '5000 वकील × ₾35/माह औसत × 12 महीने',
    pitchCalendarSync: 'कैलेंडर सिंक',
    pitchCalendarSyncDesc: 'Google Calendar, Outlook, Apple Calendar — सुनवाई और समय सीमा स्वचालित रूप से सिंक होती हैं',
    pitchCaseManagement: 'केस प्रबंधन',
    pitchClientSchedule: 'क्लाइंट शेड्यूल',
    pitchCloudDedicated: 'डेडिकेटेड क्लाउड',
    pitchCloudDedicatedDesc: 'आइसोलेटेड क्लाउड सर्वर — आपका डेटा अन्य क्लाइंट्स से पूरी तरह अलग',
    pitchContractAnalysis: 'अनुबंध विश्लेषण',
    pitchCtaSubtext: 'बुकिंग + ऑपरेशन्स + AI',
    pitchDedicatedServer: 'डेडिकेटेड सर्वर',
    pitchDocDraftGeo: 'जॉर्जियाई में दस्तावेज़ ड्राफ्टिंग',
    pitchEcourtDesc: 'दावे दायर करें, केस की स्थिति और सुनवाई का शेड्यूल — बिना अदालत जाए',
    pitchGdprCompliant: 'GDPR अनुपालक',
    pitchHybrid: 'हाइब्रिड',
    pitchHybridDesc: 'क्लाउड + लोक�� — संवेदनशील डेटा स्थानीय रूप से, बाकी क्लाउड में',
    pitchIntegrationsSub: 'सरकारी सेवाएं, कैलेंडर और OCR — एक ही प्लेटफॉर्म से',
    pitchInvoices: 'इनवॉइस',
    pitchMatsneDesc: 'कानून में बदलाव स्वचालित रूप से — आपके प्रैक्टिस क्षेत्र में',
    pitchOcrDesc: 'स्वचालित पेपर दस्तावेज़ डिजिटलीकरण — मैन्युअल टाइपिंग की आवश्यकता नहीं',
    pitchOnPremise: 'ऑन-प्रिमाइसेस सर्वर',
    pitchOnPremiseDesc: 'पूरी तरह से लोकल — डेटा आपके कार्यालय में रहता है, कोई इंटरनेट एक्सेस नहीं',
    pitchOperations: 'ऑपरेशन्स',
    pitchPerkAiDocs: 'AI दस्तावेज़',
    pitchPerkBookings: 'बुकिंग प्रबंधन',
    pitchPerkClientPortal: 'क्लाइंट पोर्टल',
    pitchPerkCommunication: 'संचार',
    pitchPerkFileStorage: 'फ़ाइल स्टोरेज',
    pitchPerkResponsive: 'रिस्पॉन्सिव',
    pitchPrivacySubtitle: 'कानूनी डेटा को अधिकतम सुरक्षा की आवश्यकता होती है',
    pitchPublicRegistryDesc: 'कंपनी और संपत्ति डेटा स्वचालित रूप से — कोई मैन्युअल एक्सट्रैक्ट डाउनलोड नहीं',
    pitchRateNote: '1 USD = 2.73 GEL — मार्च 2026',
    pitchRecurringModel: 'रिकरिंग मॉडल',
    pitchRsGeDesc: 'टैक्स ऋण और ई-इनवॉइस — एक क्लिक में क्लाइंट की स्थिति',
    pitchScen250: '250 वकील',
    pitchScen500: '500 वकील',
    pitchScen1000: '1000 वकील',
    pitchServerCost: 'सर्वर लागत/उपयोगकर्ता',
    pitchTierBusiness10: '10+ वकील',
    pitchTierEnterpriseCustom: 'कस्टम',
    pitchTierEnterprisePrice: 'कोट',
    pitchTierPro310: '3-10 वकील',
    pitchTierStarter12: '1-2 वकील',
    pitchTitle: 'जॉर्जिया के लिए TrustLegal',
    pitchTrustedAccounting: 'विश्वसनीय अकाउंटिंग',
    pitchWhyAiCheap: 'AI टूल अब काफी किफायती हैं',
    pitchWhyDigitizing: 'जॉर्जियाई कानूनी बाज़ार तेज़ी से डिजिटल हो रहा है',
    pitchWhyNoCompetitor: 'कोई स्थापित प्रतिस्पर्धी नहीं',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'Nino Barateli',
    settingsMember2Name: 'Giga Aslanishvili',
    settingsNotifyDeadlineReminder: 'डेडलाइन रिमाइंडर',
    settingsNotifyNewBookingEmail: 'नई बुकिंग — ईमेल',
    settingsNotifyNewBookingWhatsapp: 'नई बुकिंग — WhatsApp',
    settingsNotifyOverdueInvoice: 'बकाया इनवॉइस',
    settingsNotifyReminder24h: '24 घंटे पहले रिमाइंडर',
    settingsProfileName: 'Nino Barateli',
    settingsToggle3DaysBefore: '3 दिन पहले',
    portalCaseTypeCivil: 'सिविल',
    portalDocDate1: '15 मार्च',
    portalDocName1: 'Claim - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: 'देय: 25 मार्च',
    portalLastUpdate: 'अंतिम अपडेट: 18 मार्च',
    portalMsgFrom1: 'Nino Barateli',
    portalMsgPlaceholder: 'एक संदेश भेजें...',
    portalMsgText1: 'नमस्ते Giorgi, हमारे पास केस पर एक नया अपडेट है।',
    portalMsgText2: 'धन्यवाद, विवरण की प्रतीक्षा है।',
    portalNextHearing: 'कोर्ट की सुनवाई 25 मार्च',
    portalPay: 'भुगतान करें',
    portalPendingInvoices: 'लंबित इनवॉइस',
    portalProgressLabel: 'प्रगति: 3/5 चरण',
    portalStatusActive: 'सक्रिय',
    clientDashCaseTypeCivil: 'सिविल',
    clientDashDocMeta1: 'केस #2024-047 · 15 मार्च',
    clientDashDocMeta2: 'केस #2024-046 · 12 मार्च',
    clientDashDocName1: 'Claim - Mamulashvili.pdf',
    clientDashDocName2: 'Power of Attorney - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: 'दस्तावेज़',
    clientDashInvCase1: 'केस: #2024-047',
    clientDashInvCase2: 'केस: #2024-046',
    clientDashInvDue1: 'देय: 25 मार्च, 2026',
    clientDashInvoicesTitle: 'इनवॉइस',
    clientDashInvPaidDate: 'भुगतान किया गया: 14 मार्च, 2026',
    clientDashLawyerInitials: 'NB',
    clientDashLawyerName: 'Nino Barateli',
    clientDashLawyerRole: 'आपके ��कील',
    clientDashMessagesTitle: 'संदेश',
    clientDashMsgFrom1: 'Nino Barateli',
    clientDashMsgFrom3: 'Nino Barateli',
    clientDashMsgPlaceholder: 'एक संदेश लिखें...',
    clientDashMsgText1: 'नमस्ते Giorgi, हमारे पास केस का नया अपडेट है। कोर्ट ने 25 मार्च के लिए सुनवाई तय की है।',
    clientDashMsgText2: 'धन्यवाद, विवरण की प्रतीक्षा है। क्या मुझे कोई दस्तावेज़ तैयार करना चाहिए?',
    clientDashMsgText3: 'नहीं, सब कुछ तैयार है। सुनवाई से एक सप्ताह पहले आपसे संपर्क करेंगे।',
    clientDashMsgTime1: '10:30 · आज',
    clientDashMsgTime2: '10:45 · आज',
    clientDashMsgTime3: '11:02 · आज',
    clientDashMyCases: 'मेरे केस',
    clientDashPaid: 'भुगतान किया गया',
    clientDashPay: 'भुगतान करें',
    clientDashProgressLabel: 'प्रगति: 3/5 चरण पूरे हुए',
    clientDashStatActiveCase: 'सक्रिय केस',
    clientDashStatDocument: 'दस्तावेज़',
    clientDashStatNextHearing: 'अगली सुनवाई',
    clientDashStatNextHearingValue: '25 मार्च',
    clientDashStatPayable: 'देय',
    clientDashStatusActive: 'सक्रिय',
    clientDashStep1Date: '5 मार्च, 2026',
    clientDashStep1Title: 'परामर्श पूरा हुआ',
    clientDashStep2Date: '10 मार्च, 2026',
    clientDashStep2Title: 'दावा ड्राफ्ट किया गया',
    clientDashStep3Date: '15 मार्च, 2026',
    clientDashStep3Title: 'दावा कोर्ट में दायर किया गया',
    clientDashStep4Date: '25 मार्च, 2026 — लंबित',
    clientDashStep4Title: 'अदालत की सुनवाई',
    clientDashStep5Title: 'निर्णय',
    clientDashUnpaid: 'बकाया',
    clientDashWelcomeSub: 'यहाँ आप अपने मामलों, इनवॉइस और दस्तावेज़ों को ट्रैक कर सकते हैं।',
  },

  msa: {
    home: 'الرئيسية',
    dashboard: 'لوحة التحكم',
    bookings: 'الحجوزات',
    bookingPage: 'صفحة الحجز',
    aiDocuments: 'مستندات الذكاء الاصطناعي',
    clientPortalNav: 'بوابة العملاء',
    lawyersNav: 'المحامون',
    login: 'تسجيل الدخول',
    getStarted: 'ابدأ مجاناً',
    lawyersTitle: 'المحامون وشركات المحاماة',
    lawyersSubtitle: 'المسجلون في جورجيا',
    searchPlaceholder: 'البحث بالاسم، الشركة، أو مجال التخصص...',
    lawyersBtn: 'المحامون',
    firmsBtn: 'الشركات',
    allFilter: 'الكل',
    corporateLaw: 'قانون الشركات',
    criminalLaw: 'ال��انون الجنائي',
    familyLaw: 'قانون الأسرة',
    realEstate: 'العقارات',
    taxLaw: 'قانون الضرائب',
    ipLaw: 'الملكية الفكرية',
    immigration: 'الهجرة',
    laborLaw: 'قانون العمل',
    bankingFinance: 'البنوك والتمويل',
    firmsMatch: 'شركات مطابقة',
    lawyersMatch: 'محامون مطابقون',
    reviews: 'تقييمات',
    loadingMore: 'جاري تحميل المزيد...',
    independent: 'مستقل',
    yearsExperience: 'سنوات خبرة',
    languages: 'اللغات',
    backToDirectory: '← العودة إلى الدليل',
    about: 'نبذة',
    bookConsultation: 'حجز استشارة',
    sendMessage: 'إرسال رسالة',
    call: 'اتصال',
    reviewsRatings: 'التقييمات والمراجعات',
    reviewsComingSoon: 'التقييمات قريباً. كن أول من يقيّم.',
    barId: 'رقم النقابة',
    ourTeam: 'فريقنا',
    contact: 'تواصل',
    website: 'الموقع الإلكتروني',
    established: 'تأسست',
    lawyersCount: 'محامون',
    georgian: 'الجورجية',
    english: 'الإنجليزية',
    russian: 'الروسية',
    german: 'الألمانية',
    french: 'الفرنسية',
    turkish: 'التركية',
    heroLine1: 'فريقك',
    heroLine2: 'القانوني. منصة',
    heroLine3: 'واحدة.',
    heroSubtitle: 'TrustLegal — الحجوزات، القضايا، المدفوعات وصياغة المستندات بالذكاء الاصطناعي لشركات المحاماة الجورجية. رسوم شهرية واحدة، بدون عقد.',
    tryFree: 'جرب مجاناً →',
    liveDemo: 'عرض تجريبي حي',
    trustedBrands: 'العلامات التجارية التي تهتم بالجودة تعمل معنا',
    howItWorks: 'كيف تعمل',
    processLabel: '// العملية',
    step1Title: 'التسجيل',
    step1Desc: 'أنشئ حساباً واختر خطة. لا حاجة لبطاقة ائتمان — أول 30 يوماً مجاناً.',
    step2Title: 'إدارة القضايا',
    step2Desc: 'أضف العملاء، القضايا والحجوزات. تذكيرات تلقائية ومزامنة مع التقويم.',
    step3Title: 'الصياغة بالذكاء الاصطناعي',
    step3Desc: 'صياغة المستندات باللغة الجورجية مدعومة بالذكاء الاصطناعي. الدعاوى، التوكيلات، وتحليل العقود.',
    step4Title: 'النمو',
    step4Desc: 'تتبع الفواتير، الإيرادات وإنتاجية الفريق. تحليلات في الوقت الفعلي.',
    demoBadge: '// عرض تجريبي حي',
    todaysBookings: 'حجوزات اليوم',
    fullDemo: 'عرض تجريبي كامل →',
    onePlatformThreePillars: 'منصة واحدة.\nثلاث ركائز.',
    capabilitiesLabel: '// القدرات',
    bookingFeature: 'الحجز',
    bookingFeatureDesc: 'يختار العملاء وقتهم الخاص. تذكيرات تلقائية. مزامنة التقويم. صفحة حجز عامة.',
    operationsFeature: 'العمليات',
    operationsFeatureDesc: 'إدارة مركزية للقضايا. بوابة العملاء. الفواتير والمدفوعات. إدارة الفريق.',
    aiFeatureDesc: 'صياغة المستندات باللغة الجورجية. تحليل العقود. البحث القانوني. متابعة تلقائية.',
    simplePricing: 'أسعار بسيطة',
    plansLabel: '// الخطط',
    perMonth: '/ شهر',
    bookingMgmt: 'إدارة الحجوزات',
    caseTracking: 'تتبع القضايا',
    calendarSync: 'مزامنة التقويم',
    emailReminders: 'تذكيرات البريد الإلكتروني',
    starterPlan: 'البداية',
    startNow: 'ابدأ الآن →',
    everythingStarter: 'كل شيء في خطة البداية',
    aiDocDrafting: 'صياغة المستندات بالذكاء الاصطناعي',
    invoicesPayments: 'الفواتير والمدفوعات',
    clientPortalFeature: 'بوابة العملاء',
    directSupport: 'دعم مباشر',
    professionalPlan: 'الاحترافية',
    mostPopular: 'الأكثر شيوعاً',
    everythingPro: 'كل شيء في الخطة الاحترافية',
    teamMgmt10: 'إدارة الفريق (+10 محامين)',
    contractAnalysis: 'تحليل العقود',
    advancedAnalytics: 'تحليلات متقدمة',
    personalOnboarding: 'توجيه شخصي',
    businessPlan: 'الأعمال',
    spotsLeft: '3 أماكن متبقية',
    enterpriseNote: 'المؤسسات — اتصل بنا للحصول على عرض مخصص.',
    readyQuestion: 'جاهز؟',
    first30DaysFree: 'أول 30 يوماً مجاناً. بدون عقد. يمكنك الإلغاء في أي وقت.',
    footerTagline: 'منصة SaaS قانونية جورجية.',
    productLabel: 'المنتج',
    companyLabel: 'الشركة',
    bookingsLink: 'الحجوزات',
    casesLink: 'القضايا',
    aiDocsLink: 'مستندات الذكاء الاصطناعي',
    aboutUs: 'من نحن',
    careers: 'الوظائف',
    copyrightText: '© 2026 TrustLegal',
    builtWith: 'مبني باستخدام Symbols',
    sidebarMain: 'لوحة التحكم',
    sidebarBookings: 'الحجوزات',
    sidebarCases: 'القضايا',
    sidebarClients: 'العملاء',
    sidebarDocs: 'المستندات',
    sidebarPayments: 'المدفوعات',
    sidebarLawyers: 'المحامون',
    sidebarSettings: 'الإعدادات',
    sidebarLogout: 'تسجيل الخروج',
    bookingsTitle: 'الحجوزات',
    newBooking: '+ حجز جديد',
    newBookingTitle: 'حجز جديد',
    clientName: 'اسم العميل',
    phoneNumber: 'الهاتف',
    civilLaw: 'مدني',
    criminalLaw2: 'القانون الجنائي',
    administrativeLaw: 'إداري',
    otherType: 'أخرى',
    notesPlaceholder: 'ملاحظات...',
    confirmBooking: 'تأكيد الحجز',
    cancelBtn: 'إلغاء',
    calendarSyncNote: 'مزامنة التقويم — تتم مزامنة Google Calendar و Outlook و Apple Calendar تلقائياً',
    synced: 'تمت المزامنة',
    calendarSync2: 'مزامنة التقويم',
    syncedStatus: 'تمت المزامنة',
    bookingsToday: '3 حجوزات اليوم',
    settingsLink: 'الإعدادات →',
    pendingStatus: 'قيد الانتظار',
    connectionNeeded: 'مطلوب الاتصال',
    connectLink: 'اتصال →',
    lastSync: 'آخر مزامنة: قبل 5 دقائق',
    mon: 'الاثنين',
    tue: 'الثلاثاء',
    wed: 'الأربعاء',
    thu: 'الخميس',
    fri: 'الجمعة',
    bookingDetails: 'تفاصيل الحجز',
    confirmed: 'مؤكد',
    pending: 'قيد الانتظار',
    upcomingBookings: 'الحجوزات القادمة',
    closeBtn: 'إغلاق',
    selectDateTime: 'حدد التاريخ والوقت',
    fillInfo: 'املأ المعلومات — ',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    phoneField: 'الهاتف',
    emailField: 'البريد الإلكتروني',
    caseDescription: 'وصف موجز للقضية',
    confirmBookingPublic: 'تأكيد الحجز',
    goBack: 'الرجوع',
    bookingConfirmedMsg: 'تم تأكيد الحجز!',
    timeLabel: 'الوقت: ',
    lawGroupBarateli: 'Barateli Legal Group',
    ninoBarateli: 'Nino Barateli',
    casesTitle: 'القضايا',
    searchPlaceholder2: 'بحث...',
    newCase: '+ قضية جديدة',
    allTab: 'الكل',
    activeTab: 'نشط',
    pendingTab: 'قيد الانتظار',
    closedTab: 'مغلق',
    selectCasePrompt: 'حدد قضية لعرض التفاصيل',
    info: 'معلومات',
    registry: 'السجل',
    clientInfo: 'معلومات العميل',
    chronology: 'التسلسل الزمني',
    addNote: 'إضافة ملاحظة',
    enterNote: 'أدخل ملاحظة...',
    addBtn: 'إضافة',
    documentsLabel: 'المستندات',
    createBtn: '+ إنشاء',
    noDocs: 'لا توجد مستندات',
    hearingSchedule: 'جدول الجلسات',
    caseStatus: 'حالة القضية',
    electronicFiling: 'الإيداع الإلكتروني',
    idCode: 'رمز الهوية:',
    director: 'المدير:',
    addressLabel: 'العنوان:',
    statusLabel: 'الحالة:',
    registeredProperty: 'الممتلكات المسجلة',
    extractLabel: 'مستخرج',
    recentChanges: 'التغييرات الأخيرة',
    yourFieldChanges: 'تغييرات في مجالك',
    newLabel: 'جديد',
    notifications: 'الإشعارات',
    clientsTitle: 'العملاء',
    clientsSearchPlaceholder: 'البحث عن عملاء...',
    clientsProfile: 'ملف العميل',
    clientsContactLabel: 'جهة الاتصال',
    clientsInvoiceHistory: 'سجل الفواتير',
    clientsUnpaid: 'غير مدفوع',
    clientsPaid: 'مدفوع',
    clientsPortalInvite: 'إرسال رابط الوصول لبوابة العميل',
    dashTodayBookings: 'حجوزات اليوم',
    dashUnpaid: 'غير مدفوع',
    dashOverdue: 'متأخر',
    dashAiGenerations: 'توليدات الذكاء الاصطناعي',
    dashTodaysBookings: 'حجوزات اليوم',
    dashConfirmed: 'مؤكد',
    dashRecentCases: 'القضايا الأخيرة',
    dashNewBooking: '+ حجز جديد',
    dashNewCase: '+ قضية جديدة',
    dashAiDocument: 'مستند الذكاء الاصطناعي',
    docsTitle: 'المستندات',
    docsCreate: 'إنشاء',
    docsExisting: 'المستندات الحالية',
    docsFiles: 'الملفات',
    docsOcrScan: 'مسح ضوئي',
    docsOcrTitle: 'المسح الضوئي OCR',
    docsUploadText: 'رفع صورة مستند أو PDF',
    docsScanning: 'جاري مسح المستند...',
    docsFile: 'ملف',
    docsPages: 'صفحات',
    docsLanguage: 'اللغة',
    docsGeorgian: 'الجورجية',
    docsAddToCase: 'إضافة إلى القضية',
    docsCopy: 'نسخ',
    docsRescan: 'إعادة المسح',
    docsClaim: 'مطالبة',
    docsPowerOfAttorney: 'توكيل رسمي',
    docsNotification: 'إشعار',
    docsContractReview: 'مراجعة العقد',
    docsFreeForm: 'صيغة حرة',
    docsParty1: 'الطرف 1',
    docsNameCompany: 'الاسم / الشركة',
    docsParty2: 'الطرف 2',
    docsDate: 'التاريخ',
    docsAdditionalInfo: 'معلومات إضافية',
    docsGenerating: 'جاري الإنشاء...',
    docsGenerate: 'إنشاء',
    docsGeneratedDocument: 'المستند المُنشأ',
    docsEmptyState: 'سيظهر المستند المُنشأ هنا',
    docsShowDemo: 'عرض مستند تجريبي',
    docsDownload: 'تنزيل',
    docsSend: 'إرسال',
    docsCreatedDocuments: 'المستندات المُنشأة',
    docsSearch: 'بحث...',
    docsFileManager: 'مدير الملفات',
    docsUpload: 'رفع',
    docsCases: 'القضايا',
    docsTemplates: 'القوالب',
    docsRecentFiles: 'الملفات الحديثة',
    billingTitle: 'الفوترة',
    billingNewInvoice: 'فاتورة جديدة',
    billingTotalSent: 'إجمالي المُرسل',
    billingPaid: 'مدفوع',
    billingUnpaid: 'غير مدفوع',
    billingOverdue: 'متأخر',
    billingActive: 'نشط',
    billingClientStatus: 'حالة العميل',
    billingEInvoice: 'فاتورة إلكترونية',
    billingAutoCheck: 'تحقق تلقائي',
    billingSettings: 'الإعدادات →',
    billingInvoice: 'الفاتورة',
    billingClient: 'العميل',
    billingCase: 'القضية',
    billingAmount: 'المبلغ',
    billingDue: 'مستحق',
    billingStatus: 'الحالة',
    aiTitle: 'مساعد AI',
    aiPowered: 'مدعوم بواسطة AI',
    aiDraftDocs: 'صياغة المستندات',
    aiContractAnalysis: 'تحليل العقود',
    aiLegalResearch: 'البحث القانوني',
    aiDraftAvailable: 'صياغة المستندات متاحة في صفحة المستندات',
    aiGoToDocuments: 'الذهاب إلى المستندات →',
    aiPasteContract: 'الصق نص العقد هنا...',
    aiAnalyze: 'تحليل',
    aiReanalyze: 'إعادة التحليل',
    aiParties: 'الأطراف',
    aiObligations: 'الالتزامات الرئيسية',
    aiRiskFactors: 'عوام�� الخطر',
    aiDeadlines: 'المواعيد النهائية',
    aiRecommendations: 'التوصيات',
    aiAskQuestion: 'اطرح سؤالاً حول القانون الجورجي',
    aiLegalResearchTitle: 'البحث القانوني عبر AI',
    aiAskPlaceholder: 'اطرح سؤالاً...',
    aiSend: 'إرسال',
    pitchTagline: 'SaaS القانوني في جورجيا',
    pitchSubtitle: 'الحجز · العمليات · AI — للشركات الجورجية',
    pitchCta: 'اكتشف الفرصة →',
    pitchMarketLabel: '// السوق',
    pitchMarketTitle: '+5000 محامٍ في جورجيا',
    pitchPopulation: 'تعداد السكان',
    pitchTbilisi: 'تبليسي',
    pitchConcentrated: 'سوق مركّز',
    pitchZeroCompetitor: 'منافس SaaS محلي',
    pitchProblemLabel: '// المشكلة',
    pitchProblemTitle: 'الشركات الجورجية لا تزال تعتمد على WhatsApp و Excel',
    pitchNoBooking: 'لا يوجد نظام لحجز العملاء',
    pitchManualCases: 'إدارة القضايا يدوياً',
    pitchNoAiTools: 'لا توجد أدوات AI باللغة الجورجية',
    pitchCapabilitiesLabel: '// القدرات',
    pitchOnePlatform: 'منصة وا��دة. ثلاث ركائز.',
    pitchProductLabel: '// المنتج',
    pitchProductTitle: 'كل شيء في منصة واحدة',
    pitchIntegrationsLabel: '// التكاملات',
    pitchIntegrationsTitle: 'أتمتة، لا عمل يدوي',
    pitchPublicRegistry: 'السجل العام',
    pitchCalendarSyncTitle: 'مزامنة التقويم',
    pitchOcrTitle: 'OCR والمسح الضوئي',
    pitchPlansLabel: '// الخطط',
    pitchPlansTitle: 'الأسعار للسوق الجورجي',
    pitchTierStarter: 'أساسي',
    pitchMostPopular: 'الأكثر شيوعاً',
    pitchTierPro: 'احترافي',
    pitchTierBusiness: 'أعمال',
    pitchTierEnterprise: 'الشركات',
    pitchRevenueLabel: '// الإيرادات',
    pitchRevenueTitle: 'إمكانات الإيرادات',
    pitchFinanceLabel: '// الشؤون المالية',
    pitchFinanceTitle: 'اقتصاديات الوحدة',
    pitchTimeLabel: '// التوقيت',
    pitchTimeTitle: 'التوقيت مناسب',
    pitchPrivacyLabel: '// الخصوصية',
    pitchPrivacyTitle: 'الخصوصية أولوية',
    pitchCtaLabel: '// نبني معاً',
    pitchCtaTitle: 'دعونا نبني البنية التحتية القانونية في جورجيا',
    pitchCtaLink: 'الصفحة الرئيسية →',
    pitchPerMonth: 'شهر',
    settingsTitle: 'الإعدادات',
    settingsTabProfile: 'الملف الشخصي',
    settingsTabFirm: 'الشركة',
    settingsTabTeam: 'الفريق',
    settingsTabNotifications: 'الإشعارات',
    settingsUploadPhoto: 'رفع صورة',
    settingsSave: 'حفظ',
    settingsFirmAddress: 'العنوان',
    settingsFirmRegNumber: 'رقم التسجيل',
    settingsPublicBookingUrl: 'رابط الحجز العام',
    settingsTeamMembers: 'أعضاء الفريق',
    settingsInvite: '+ دعوة',
    settingsRoleOwner: 'المالك',
    settingsRoleLawyer: 'محامٍ',
    settingsNotifyTitle: 'إعدادات الإشعارات',
    settingsToggleOn: 'مفعل',
    settingsToggleOff: 'معطل',
    loginSubtitle: 'تسجيل الدخول إلى حسابك',
    loginLawyer: 'محامٍ',
    loginClient: 'عميل',
    loginPassword: 'كلمة المرور',
    loginSubmit: 'تسجيل الدخول →',
    loginCaseNumber: 'رقم القضية',
    loginBackLink: '← العودة',
    portalLogout: 'تسجيل الخروج',
    portalWelcome: 'مرحباً،',
    portalActiveCases: 'القضايا النشطة',
    portalDocuments: 'المستندات',
    portalMessages: 'الرسائل',
    portalSend: 'إرسال',
    clientDashNavCases: 'القضايا',
    clientDashNavInvoices: 'الفواتير',
    clientDashNavDocuments: 'المستندات',
    clientDashNavMessages: 'الرسائل',
    clientDashLogout: 'تسجيل الخروج',
    clientDashWelcome: 'مرحباً،',
    clientDashDownload: 'تنزيل',
    clientDashSend: 'إرسال',
    findLawyer: 'ابحث عن محامٍ',
    lawyersSearchSub: 'ابحث عن أكثر من 5,700 محامٍ مسجل في نقابة المحامين الجورجية',
    searchBtn: 'بحث',
    viewAll: 'عرض الكل',
    lawyerPortal: 'بوابة المحامي',
    aiFeature: 'الذكاء الاصطناعي',
    aiChip1: 'إلغاء العقد التوثيقي',
    aiChip1Question: 'ما هي شروط إلغاء العقد التوثيقي؟',
    aiChip2: 'المادة 317 من القانون المدني',
    aiChip2Question: 'تفسير المادة 317 من القانون المدني',
    aiChip3: 'بطلان المعاملة',
    aiChip3Question: 'الممارسة القضائية حول بطلان المعاملة في السنوات الثلاث الماضية',
    aiDeadlinesData: '• بدء الخدمة: 10 أيام من العقد\n• الدفعة الأولى: 1 أبريل 2026\n• مدة العقد: 12 ش��راً',
    aiEmptyChatSub: 'الذكاء الاصطناعي — اطرح سؤالاً واحصل على إجابة حول القانون الجورجي',
    aiObligationsData: '1. تقديم الخدمة خلال 30 يوماً تقويمياً\n2. الدفع خلال 15 يوم عمل\n3. السرية لمدة 3 سنوات',
    aiPartiesData: 'الطرف الأول: Barateli & Partners LLC\nالطرف الثاني: Delta Group LLC',
    aiRecommendationsData: '1. إضافة شرط جزائي (المادة 417 من القانون المدني)\n2. تحديد تسوية المنازعات عن طريق التحكيم\n3. توسيع شرط القوة القاهرة',
    aiRisksData: '• غرامة التأخير في الدفع غير محددة\n• آلية تسوية المنازعات غير محددة\n• شرط القوة القاهرة لا يغطي الجوائح',
    address: 'العنوان',
    addressVal: 'تبليسي، تشافتشافادزه 12',
    appleCalendar: 'تقويم Apple',
    billingClient1: 'جيورجي مامولاشفيلي',
    billingClient2: 'مريم كفاراتسخيليا',
    billingClient3: 'ليلا غوغيياشفيلي',
    billingClientName: 'Delta Group LLC',
    billingDue1: '25 مارس',
    billingDue2: '15 مارس',
    billingDue3: '10 مارس',
    billingEmailNotification: 'إشعار البريد الإلكتروني',
    billingLastCheck: 'آخر فحص: اليوم',
    billingNoDebt: 'لا توجد ديون مستحقة',
    billingRsBanner: 'تكامل rs.ge — ديون ضرائب العميل والفواتير الإلكترونية بنقرة واحدة',
    billingRsTaxSystem: 'rs.ge — النظام الضريبي',
    billingStatusPaid: 'مدفوع',
    billingStatusSent: 'مُرسل',
    billingViewFull: 'عرض التفاصيل →',
    billingViewInvoices: 'عرض الفواتير →',
    billingWeeklyEnabled: 'مُفعّل أسبوعياً',
    caseRow1Title: '#2024-047 — جيورجي مامولاشفيلي',
    caseRow2Title: '#2024-046 — مريم كفاراتسخيليا',
    caseRow3Title: '#2024-045 — ليلا غوغياسف��لي',
    change1Date: '15 مارس — ساري من: 1 أبريل',
    change1Desc: 'تمت زيادة الموعد النهائي من 30 إلى 45 يوماً',
    change1Name: 'القانون المدني — مادة 316',
    change2Date: '12 مارس — ساري من: 1 مايو',
    change2Desc: 'موعد الاستئناف من 14 إلى 21 يوماً',
    change2Name: 'قانون الإجراءات — المواعيد النهائية',
    claimAccepted: 'تم قبول الدعوى — 17 مارس',
    claimFiled: 'تم رفع الدعوى — 15 مارس',
    claimFiledDoc: 'الدعوى — رُفعت',
    clientName1: 'جيورجي مامولاشفيلي',
    clientName2: 'مريم كفاراتسخيليا',
    clientName3: 'ليلا غوغياسفيلي',
    companyExtractLoaded: 'مستخرج الشركة — تم التحميل',
    companyName: 'مجموعة دلتا ذ.م.م',
    clientsActiveCases1: 'قضية واحدة نشطة',
    clientsActiveCases2: 'قضية واحدة نشطة',
    clientsActiveCases3: '0 قضايا نشطة',
    clientsAvatar1: 'GM',
    clientsAvatar2: 'MK',
    clientsAvatar3: 'LG',
    clientsCaseLink1: '#2024-047 — مدني',
    clientsCaseLink2: '#2024-046 — إداري',
    clientsContact1: '599123456 · g.mamulasvili@gmail.com',
    clientsContact2: '577234567 · mari.k@mail.ru',
    clientsContact3: '571456789 · lela.g@inbox.ge',
    clientsNoCases: 'لا توجد قضايا نشطة',
    clientsPaid1: 'تم دفع ₾2,400',
    clientsPaid2: 'تم دفع ₾800',
    clientsPaid3: 'تم دفع ₾1,800',
    dashAlertText: 'قضيتان متأخرتان وفواتير غير مدفوعة بقيمة ₾1,840',
    dashBooking1Time: '10:00 — مدني',
    dashBooking2Time: '11:30 — إداري',
    dashBooking3Time: '14:00 — جنائي',
    dashCaseMeta1: 'مدني · 18 مارس',
    dashCaseMeta2: 'إداري · 17 مارس',
    dashCaseMeta3: 'جنائي · 15 مارس',
    dashClient3Name: 'ديفيت تشيكوفاني',
    dashDate: '18 مارس 2026',
    dashGreeting: 'مرحباً، نينو',
    dateMar15: '15 مارس',
    dateMar17: '17 مارس',
    dateMar18: '18 مارس',
    disabledStatus: '— مُعطّل',
    docsContractScanPdf: 'contract_scan.pdf',
    docsDemoClaimText: 'جورجيا، تبليسي\n\nدعوى\n\nالمدعي: شركة باراتيلي وشركاه ذ.م.م\nالمدعى عليه: مجموعة دلتا ذ.م.م\n\nالوقائع:\n\nبموجب هذه الدعوى، يطلب المدعي من المدعى عليه الوفاء بالتزاماته.\n\nالطلبات:\n\n1. إلزام المدعى عليه بدفع 12,500 GEL\n2. فرض غرامة قدرها 1,875 GEL\n3. تعويض مصاريف المحكمة\n\nالتاريخ: 18 مارس 2026\nالتوقيع: ________________',
    docsDocument: 'مستند',
    docsFile1Meta: 'PDF · 124 KB · 15 مارس 2026',
    docsFile1Name: 'دعوى - مامولاشفيلي.pdf',
    docsFile2Meta: 'PDF · 89 KB · 12 مارس 2026',
    docsFile2Name: 'توكيل - كفاراتسخيليا.pdf',
    docsFile3Meta: 'DOCX · 45 KB · 10 مارس 2026',
    docsFile3Name: 'عقد №147.docx',
    docsFile4Meta: 'JPG · 1.2 MB · 8 مارس 2026',
    docsFile4Name: 'نسخة الهوية - مامولاشفيلي.jpg',
    docsFile5Meta: 'PDF · 67 KB · 5 مارس 2026',
    docsFile5Name: 'إشعار - غوغياسفيلي.pdf',
    docsFolder1Count: '3 ملفات',
    docsFolder1Name: '#2024-047 مامولاشفيلي',
    docsFolder2Count: 'ملفان',
    docsFolder2Name: '#2024-046 كفاراتسخيليا',
    docsFolder3Count: 'ملف واحد',
    docsFolder3Name: '#2024-045 غوغياسفيلي',
    docsFolder4Count: '5 ملفات',
    docsFormatAnalysis: 'تحليل التنسيق...',
    docsFreeText: 'نص حر...',
    docsGeneratedClaimText: 'جورجيا، تبليسي\n\nدعوى\n\nالمدعي: [الطرف 1]\nالمدعى عليه: [الطرف 2]\n\nالوقائع:\n\nبموجب هذه الدعوى، يطلب المدعي من المدعى عليه الوفاء بالتزاماته بموجب القانون المدني الجورجي.\n\nالأساس القانوني:\n\nعملاً بالمادة 316 من القانون المدني، يجب تنفيذ الالتزامات بشكل صحيح.\n\nالطلبات:\n\nبناءً على ما سبق، يطلب المدعي من المحكمة إلزام المدعى عليه.\n\nالتاريخ: 18 مارس 2026\nالتوقيع: ________________',
    docsGeorgianSymbols: 'حروف جورجية',
    docsOcrNote: 'مسح OCR — رقمنة تلقائية للمستندات الورقية، لا حاجة للكتابة اليدوية',
    docsOcrResultText: 'عقد رقم 147\n\nتبليسي، 10 مارس 2026\n\nمن ناحية، شركة Barateli & Partners LLC (رقم التعريف 404123456)، ممثلة بمديرتها Nino Barateli (يشار إليها فيما يلي بـ "المقاول") ومن ناحية أخرى، شركة Delta Group LLC (رقم التعريف 404789012)، ممثلة بمديرها Giorgi Mamulashvili (يشار إليه فيما يلي بـ "العميل")، أبرما هذا العقد:\n\nالمادة 1. موضوع العقد\n1.1. يتعهد المقاول بتقديم خدمات قانونية للعميل.\n1.2. تكلفة الخدمة هي 12,500 (اثنا عشر ألفاً وخمسمائة) GEL.',
    docsOcrSuccess: 'تم التعرف بنجاح — دقة 98.5%',
    docsRow1Meta: '#2024-047 · مطالبة · 15 مارس',
    docsRow1Name: 'مطالبة - Mamulashvili.pdf',
    docsRow2Meta: '#2024-046 · توكيل رسمي · 12 مارس',
    docsRow2Name: 'توكيل رسمي - Kvaratskhelia.pdf',
    docsRow3Meta: '#2024-045 · إشعار · 8 مارس',
    docsRow3Name: 'إشعار - Gogiashvili.pdf',
    docsTextRecognition: 'التعرف على النص',
    docsUploadFormats: 'JPG, PNG, PDF — بحد أقصى 10MB',
    docsUploadSub: 'اسحب ملفاً أو انقر للتحديد',
    ecourt: 'ecourt',
    ecourtDesc: 'تقديم المطالبات، والتحقق من حالة القضية وجدول الجلسات — دون زيارة المحكمة',
    enabledStatus: '✓ مفعل',
    evidencePending: 'الأدلة — قيد الانتظار',
    extract: 'مستخرج',
    field1Text: 'مدني: تعديل المادة 316',
    field2Text: 'مدني: المواعيد النهائية للمادة 259',
    field3Text: 'إداري: الخدمة الإلكترونية',
    googleCalendar: 'Google Calendar',
    hearingItem1: '📅 22 مارس، 10:00 — محكمة مدينة تبليسي',
    hearingItem2: '📅 28 مارس، 14:30 — محكمة الاستئناف',
    loginEmail: 'البريد الإلكتروني',
    matsne: 'matsne',
    matsneDesc: 'تغييرات التشريعات تلقائياً — في مجال تخصصك',
    outlook: 'Outlook',
    prepHearing: 'جلسة تحضيرية — 22 مارس',
    propertyApartment: 'شقة — Vake، 85 متر مربع · ~₾180,000',
    propertyCar: 'BMW X5 — 2021، AA-123-BB · ~₾95,000',
    propertyExtractAdded: 'مستخرج الملكية — تمت الإضافة',
    registryDesc: 'بيانات الشركات والممتلكات تلقائياً — لا مزيد من التنزيل اليدوي للمستخرجات',
    timeEntry1Date: '18 مارس، 10:30',
    timeEntry1Text: 'تم فتح القضية، واكتملت الاستشارة الأولية',
    timeEntry2Date: '17 مارس، 14:00',
    timeEntry2Text: 'قدم العميل الوثائق',
    timeEntry3Date: '15 مارس، 09:00',
    timeEntry3Text: 'تواصل العميل مع الشركة، الطلب الأولي',
    typeCivil: 'مدني',
    typeAdministrative: 'إداري',
    typeCriminal: 'جنائي',
    pitchArpuMonth: 'متوسط ARPU/شهر',
    pitchArpuYear: 'متوسط ARPU/سنة',
    pitchAutoBackup: 'نسخ احتياطي تلقائي',
    pitchAutoNextSteps: 'الخطوات التالية التلقائية',
    pitchAutoReminder: 'تذكير تلقائي',
    pitchBooking: 'الحجز',
    pitchCacOrganic: 'CAC (نمو عضوي)',
    pitchCalcNote: '5000 محامٍ × ₾35/شهر في المتوسط × 12 شهراً',
    pitchCalendarSync: 'مزامنة التقويم',
    pitchCalendarSyncDesc: 'Google Calendar، Outlook، Apple Calendar — تتم مزامنة الجلسات والمواعيد النهائية تلقائياً',
    pitchCaseManagement: 'إدارة القضايا',
    pitchClientSchedule: 'جدول العميل',
    pitchCloudDedicated: 'سحابة مخصصة',
    pitchCloudDedicatedDesc: 'خادم سحابي معزول — بياناتك مفصولة تماماً عن العملاء الآخرين',
    pitchContractAnalysis: 'تحليل العقود',
    pitchCtaSubtext: 'الحجز + العمليات + AI',
    pitchDedicatedServer: 'خادم مخصص',
    pitchDocDraftGeo: 'صياغة المستندات باللغة الجورجية',
    pitchEcourtDesc: 'تقديم المطالبات، وحالة القضية وجدول الجلسات — دون زيارة المحكمة',
    pitchGdprCompliant: 'متوافق مع GDPR',
    pitchHybrid: 'هجين',
    pitchHybridDesc: 'سحابي + محلي — البيانات الحساسة محلياً، والباقي في السحابة',
    pitchIntegrationsSub: 'الخدمات الحكومية، التقويمات و OCR — من منصة واحدة',
    pitchInvoices: 'الفواتير',
    pitchMatsneDesc: 'تغييرات التشريعات تلقائياً — في مجال تخصصك',
    pitchOcrDesc: 'رقمنة المستندات الورقية تلقائياً — لا حاجة للكتابة اليدوية',
    pitchOnPremise: 'خادم محلي',
    pitchOnPremiseDesc: 'محلي بالكامل — تبقى البيانات في مكتبك، دون اتصال بالإنترنت',
    pitchOperations: 'العمليات',
    pitchPerkAiDocs: 'مستندات AI',
    pitchPerkBookings: 'إدارة الحجوزات',
    pitchPerkClientPortal: 'بوابة العملاء',
    pitchPerkCommunication: 'التواصل',
    pitchPerkFileStorage: 'تخزين الملفات',
    pitchPerkResponsive: 'متجاوب',
    pitchPrivacySubtitle: 'البيانات القانونية تتطلب أقصى درجات الحماية',
    pitchPublicRegistryDesc: 'بيانات الشركات والممتلكات تلقائياً — لا تنزيل يدوي للمستخرجات',
    pitchRateNote: '1 USD = 2.73 GEL — مارس 2026',
    pitchRecurringModel: 'نموذج متكرر',
    pitchRsGeDesc: 'الديون الضريبية والفواتير الإلكترونية — حالة العميل بنقرة واحدة',
    pitchScen250: '250 محامياً',
    pitchScen500: '500 محامٍ',
    pitchScen1000: '1000 محامٍ',
    pitchServerCost: 'تكلفة الخادم/المستخدم',
    pitchTierBusiness10: '+10 محامين',
    pitchTierEnterpriseCustom: 'مخصص',
    pitchTierEnterprisePrice: 'عرض سعر',
    pitchTierPro310: '3-10 محامين',
    pitchTierStarter12: '1-2 محامين',
    pitchTitle: 'TrustLegal لجورجيا',
    pitchTrustedAccounting: 'محاسبة موثوقة',
    pitchWhyAiCheap: 'أدوات الذكاء الاصطناعي أصبحت الآن بأسعار معقولة',
    pitchWhyDigitizing: 'السوق القانوني الجورجي يتحول رقمياً بسرعة',
    pitchWhyNoCompetitor: 'لا يوجد منافس راسخ',
    settingsFirmName: 'Barateli Legal Group',
    settingsMember1Name: 'نينو باراتيلي',
    settingsMember2Name: 'جيجا أسلانيشفيلي',
    settingsNotifyDeadlineReminder: 'تذكير بالموعد النهائي',
    settingsNotifyNewBookingEmail: 'حجز جديد — بريد إلكتروني',
    settingsNotifyNewBookingWhatsapp: 'حجز جديد — WhatsApp',
    settingsNotifyOverdueInvoice: 'فاتورة متأخرة',
    settingsNotifyReminder24h: 'تذكير قبل 24 ساعة',
    settingsProfileName: 'نينو باراتيلي',
    settingsToggle3DaysBefore: 'قبل 3 أيام',
    portalCaseTypeCivil: 'مدني',
    portalDocDate1: '15 مارس',
    portalDocName1: 'دعوى - Mamulashvili.pdf',
    portalFirmLogo: 'Barateli Legal',
    portalInvoiceDue: 'تاريخ الاستحقاق: 25 مارس',
    portalLastUpdate: 'آخر تحديث: 18 مارس',
    portalMsgFrom1: 'نينو باراتيلي',
    portalMsgPlaceholder: 'أرسل رسالة...',
    portalMsgText1: 'مرحباً جيورجي، لدينا تحديث جديد بشأن القضية.',
    portalMsgText2: 'شكراً، في انتظار التفاصيل.',
    portalNextHearing: 'جلسة المحكمة 25 مارس',
    portalPay: 'دفع',
    portalPendingInvoices: 'الفواتير المعلقة',
    portalProgressLabel: 'التقدم: 3/5 خطوات',
    portalStatusActive: 'نشط',
    clientDashCaseTypeCivil: 'مدني',
    clientDashDocMeta1: 'قضية #2024-047 · 15 مارس',
    clientDashDocMeta2: 'قضية #2024-046 · 12 مارس',
    clientDashDocName1: 'دعوى - Mamulashvili.pdf',
    clientDashDocName2: 'توكيل رسمي - Kvaratskhelia.pdf',
    clientDashDocumentsTitle: 'المستندات',
    clientDashInvCase1: 'قضية: #2024-047',
    clientDashInvCase2: 'قضية: #2024-046',
    clientDashInvDue1: 'تاريخ الاستحقاق: 25 مارس 2026',
    clientDashInvoicesTitle: 'الفواتير',
    clientDashInvPaidDate: 'تم الدفع: 14 مارس 2026',
    clientDashLawyerInitials: 'NB',
    clientDashLawyerName: 'نينو باراتيلي',
    clientDashLawyerRole: 'محاميك',
    clientDashMessagesTitle: 'الرسائل',
    clientDashMsgFrom1: 'نينو باراتيلي',
    clientDashMsgFrom3: 'نينو باراتيلي',
    clientDashMsgPlaceholder: 'اكتب رسالة...',
    clientDashMsgText1: 'مرحباً جيورجي، لدينا تحديث جديد للقضية. حددت ا��محكمة جلسة استماع في 25 مارس.',
    clientDashMsgText2: 'شكراً، في انتظار التفاصيل. هل يجب علي تحضير أي مستندات؟',
    clientDashMsgText3: 'لا، كل شيء جاهز. سأتواصل معك قبل أسبوع من الجلسة.',
    clientDashMsgTime1: '10:30 · اليوم',
    clientDashMsgTime2: '10:45 · اليوم',
    clientDashMsgTime3: '11:02 · اليوم',
    clientDashMyCases: 'قضاياي',
    clientDashPaid: 'مدفوع',
    clientDashPay: 'دفع',
    clientDashProgressLabel: 'التقدم: اكتملت 3/5 خطوات',
    clientDashStatActiveCase: 'قضية نشطة',
    clientDashStatDocument: 'مستند',
    clientDashStatNextHearing: 'الجلسة القادمة',
    clientDashStatNextHearingValue: '25 مارس',
    clientDashStatPayable: 'مستحق الدفع',
    clientDashStatusActive: 'نشط',
    clientDashStep1Date: '5 مارس 2026',
    clientDashStep1Title: 'اكتملت الاستشارة',
    clientDashStep2Date: '10 مارس 2026',
    clientDashStep2Title: 'تمت صياغة الدعوى',
    clientDashStep3Date: '15 مارس 2026',
    clientDashStep3Title: 'تم رفع الدعوى في المحكمة',
    clientDashStep4Date: '25 مارس 2026 — قيد الانتظار',
    clientDashStep4Title: 'جلسة المحكمة',
    clientDashStep5Title: 'القرار',
    clientDashUnpaid: 'غير مدفوع',
    clientDashWelcomeSub: 'هنا يمكنك تتبع قضاياك وفواتيرك ومستنداتك.',
  },
}
